webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularAnimate = __webpack_require__(4);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularCookies = __webpack_require__(6);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(8);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(10);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _uaParserJs = __webpack_require__(12);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(15);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(17);
	
	__webpack_require__(19);
	
	__webpack_require__(21);
	
	__webpack_require__(22);
	
	__webpack_require__(56);
	
	__webpack_require__(57);
	
	__webpack_require__(58);
	
	__webpack_require__(59);
	
	__webpack_require__(60);
	
	__webpack_require__(62);
	
	__webpack_require__(63);
	
	__webpack_require__(64);
	
	var _app = __webpack_require__(65);
	
	var _body = __webpack_require__(66);
	
	var _body2 = _interopRequireDefault(_body);
	
	var _navbar = __webpack_require__(68);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _auth = __webpack_require__(70);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _app2 = __webpack_require__(71);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _account = __webpack_require__(83);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _home = __webpack_require__(91);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _viewpoints = __webpack_require__(95);
	
	var _viewpoints2 = _interopRequireDefault(_viewpoints);
	
	var _capitalize = __webpack_require__(102);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _util = __webpack_require__(75);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _Sites = __webpack_require__(103);
	
	var _Sites2 = _interopRequireDefault(_Sites);
	
	var _Users = __webpack_require__(104);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _FilesUtil = __webpack_require__(105);
	
	var _FilesUtil2 = _interopRequireDefault(_FilesUtil);
	
	var _Files = __webpack_require__(106);
	
	var _Files2 = _interopRequireDefault(_Files);
	
	var _Errors = __webpack_require__(107);
	
	var _Errors2 = _interopRequireDefault(_Errors);
	
	var _viewpoint = __webpack_require__(108);
	
	var _viewpoint2 = _interopRequireDefault(_viewpoint);
	
	var _translation = __webpack_require__(109);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _modal = __webpack_require__(110);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _progress = __webpack_require__(122);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	var _Wistia = __webpack_require__(123);
	
	var _Wistia2 = _interopRequireDefault(_Wistia);
	
	var _mapPin = __webpack_require__(124);
	
	var _mapPin2 = _interopRequireDefault(_mapPin);
	
	var _translate = __webpack_require__(125);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _onload = __webpack_require__(126);
	
	var _onload2 = _interopRequireDefault(_onload);
	
	var _passwordMatch = __webpack_require__(127);
	
	var _passwordMatch2 = _interopRequireDefault(_passwordMatch);
	
	var _progressBar = __webpack_require__(128);
	
	var _progressBar2 = _interopRequireDefault(_progressBar);
	
	var _slidable = __webpack_require__(130);
	
	var _slidable2 = _interopRequireDefault(_slidable);
	
	var _lazyLoad = __webpack_require__(131);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	__webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('fplTruescapeComApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, 'rzModule', _angularUiBootstrap2.default, _auth2.default, _body2.default, _angularAnimate2.default, _account2.default, _lazyLoad2.default, _navbar2.default, _home2.default, _app3.default, _util2.default, _Sites2.default, _translation2.default, _translate2.default, _viewpoints2.default, _mapPin2.default, _capitalize2.default, _viewpoint2.default, 'ngScrollbars', 'ngJuxtapose', _modal2.default, _FilesUtil2.default, _Files2.default, _Errors2.default, _Users2.default, _progressBar2.default, 'ui.openseadragon', 'ap.canvas.ext', 'uiSwitch', _progress2.default, 'ngToast', _onload2.default, _passwordMatch2.default, _slidable2.default, 'ngStorage', _Wistia2.default]).config(_app.routeConfig).config(['$uibTooltipProvider', function ($uibTooltipProvider) {
	  var parser = new _uaParserJs2.default();
	  var result = parser.getResult();
	  var touch = result.device && (result.device.type === 'tablet' || result.device.type === 'mobile');
	  if (touch) {
	    $uibTooltipProvider.options({ trigger: 'dontTrigger' });
	  } else {
	    $uibTooltipProvider.options({ trigger: 'mouseenter' });
	  }
	}]).config(['ngToastProvider', 'appConfig', 'ScrollBarsProvider', function (ngToastProvider, appConfig, ScrollBarsProvider) {
	  ScrollBarsProvider.defaults = {
	    scrollButtons: {
	      scrollAmount: 'auto',
	      enable: true },
	
	    scrollbarPosition: 'outside',
	    autoHideScrollbar: false,
	    axis: 'y' };
	  ngToastProvider.configure({
	    animation: 'slide',
	    horizontalPosition: 'right',
	    verticalPosition: 'bottom',
	    maxNumber: 1,
	    combineDuplications: false
	  });
	}]).run(['$rootScope', '$location', '$state', '$window', 'Auth', function ($rootScope, $location, $state, $window, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        event.preventDefault();
	        Auth.logout();
	        $window.location.assign('/login');
	      }
	    });
	  });
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['fplTruescapeComApp'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(18);
	module.exports = 'ng-juxtapose';


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	angular.module('ngJuxtapose', [])
		.provider('juxtaposeConfig', function(){
	
			//the default options
			var defaultConfig = {
				startingPosition: '50%',
				showLabels : true,
				showCredits: true,
				animate : true,
				vertical : false
			};
	
			var config = angular.extend({}, defaultConfig);
	
			return {
				setStartingPosition : function(value){
					config.startingPosition = value;
				},
				setShowLabels : function(value){
					config.showLabels = value;
				},
				setShowCredits : function(value){
					config.showCredits = value;
				},
				setAnimate : function(value){
					config.animate = value;
				},
				setVertical : function(value){
					config.vertical = value;
				},
				$get: function(){
					return {
						startingPosition: '50%',
						showLabels : true,
						showCredits: true,
						animate : true,
						vertical : false
					};
				}
			};
		})
		.controller('JuxtaposeController', ['$scope', '$attrs', '$parse', '$window', 'juxtaposeConfig',  function($scope, $attrs, $parse,  $window, juxtaposeConfig){
	
			var self = this;
	
			if(!$window.juxtapose) {
				console.error("Cannot find 'juxtapose'. Make sure you've included the JuxtaposeJS library before this directive");
				return;
			}
	
			// Configuration attributes
			angular.forEach(['startingPosition', 'showLabels', 'showCredits', 'animate', 'vertical'], function( key, index ) {
				$scope[key] = angular.isDefined($attrs[key]) ? (index < 1 ? $parse($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : juxtaposeConfig[key];
			});
	
			var selector = '#' + $attrs.id;
	
			// Watchable configuration attributes
			angular.forEach(['startingPosition', 'showLabels', 'showCredits', 'animate', 'vertical'], function( key ) {
				if ( $attrs[key] ) {
					$scope.$parent.$watch($parse($attrs[key]), function(value, oldValue) {
						if(value !== oldValue){
							$scope[key] = value;
							self.updateSlider();
						}
					});
				} 
			});
	
			//Watchable directive attributes
			$scope.$watchCollection(
				'[beforeImageUrl, beforeImageLabel, beforeImageCredit, beforeImageAlt, afterImageUrl, afterImageLabel, afterImageCredit, afterImageAlt]', 
				function (newValues) { 
					var beforeImageUrl = newValues[0], afterImageUrl = newValues[4];
					if(beforeImageUrl && afterImageUrl){
						self.updateSlider();
					}
				}
			);
	
			//Clean up
			$scope.$on('$destroy', function() {
				self.$element = null;
				self.slider = null;
			});
	
			this.init = function(element){
				self.$element = element;
				self.slider = null;
			};
	
			this.updateSlider = function(){
				
				var selector = '#' + $attrs.id;
	
				var images = [
					{
						src: $scope.beforeImageUrl,
						label: $scope.beforeImageLabel,
						credit: $scope.beforeImageCredit
					},
					{
						src: $scope.afterImageUrl,
						label: $scope.afterImageLabel,
						credit: $scope.afterImageCredit
					}
				];
	
				var options = {
					animate: $scope.animate,
					showLabels: $scope.showLabels,
					showCredits: $scope.showCredits,
					mode: $scope.vertical ? 'vertical' : 'horizontal',
					startingPosition: $scope.startingPosition,
					callback : $scope.callback
				};
				self.$element.empty();//remove previous slider if any
				self.slider = new juxtapose.JXSlider(selector, images, options);
	
				if($attrs.beforeImageAlt || $attrs.afterImageAlt){
					var imgElements = self.$element.find('img');
	
					var children =  self.$element.children();
					var $jxSlider =  self.$element.children().eq(0);
					var $jxImageLeft = $jxSlider.children().eq(1);
					var $jxImageRight = $jxSlider.children().eq(2);
	
					angular.element($jxImageLeft.eq(0)[0]).attr('alt', $scope.beforeImageAlt);
					angular.element($jxImageRight.eq(0)[0]).attr('alt', $scope.afterImageAlt);
				}
			};
	
			this.getElement = function(){
				return self.$element;
			};
	
			this.getSlider = function(){
				return self.slider;
			};
	
		}])
		.directive('juxtapose', function () {
			var counter = 0;
			var ID_ATTR = 'juxtapose';
			return {
				restrict: 'EA',
				scope: {
					beforeImageUrl : '=',
					beforeImageLabel : '=?',
					beforeImageCredit : '=?',
					beforeImageAlt : '=?',
	
					afterImageUrl : '=',
					afterImageLabel : '=?',
					afterImageCredit : '=?',
					afterImageAlt : '=?',
	
					callback : '&?'
				},
				template : '<div class="juxtapose"></div>',
				replace: true,
				controller: 'JuxtaposeController',
				link: function (scope, element, attrs, juxtaposeCtrl) {
	
					// generate an ID
					attrs.$set('id', ID_ATTR + '-' + counter++);
	
					juxtaposeCtrl.init(element);
				}
			};
		});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(20);
	module.exports = 'ap.canvas.ext';


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/** @license
	 * Angular Canvas Extensions - AngularJS module
	 *
	 * Allows to open images in canvas, zoom, pan, crop, resize and download image.
	 *
	 * https://github.com/petalvlad/angular-canvas-ext
	 *
	 * Copyright (c) 2014 Alex Petropavlovsky <petalvlad@gmail.com>
	 * Released under the MIT license
	 */
	var canvasExtModule = angular.module('ap.canvas.ext', []);
	canvasExtModule.factory('apBrowserHelper', function () {
	  var uagent = navigator.userAgent.toLowerCase(), browser = {}, platform = {};
	  platform.ios = /iphone|ipad|ipod/.test(uagent);
	  platform.ipad = /ipad/.test(uagent);
	  platform.android = /android/.test(uagent);
	  platform.blackberry = /blackberry/.test(uagent);
	  platform.windowsPhone = /iemobile/.test(uagent);
	  platform.mobile = platform.ios || platform.android || platform.blackberry || platform.windowsPhone;
	  platform.desktop = !platform.mobile;
	  browser.firefox = /mozilla/.test(uagent) && /firefox/.test(uagent);
	  browser.chrome = /webkit/.test(uagent) && /chrome/.test(uagent);
	  browser.safari = /applewebkit/.test(uagent) && /safari/.test(uagent) && !/chrome/.test(uagent);
	  browser.opera = /opera/.test(uagent);
	  browser.msie = /msie/.test(uagent);
	  browser.version = '';
	  if (!(browser.msie || browser.firefox || browser.chrome || browser.safari || browser.opera)) {
	    if (/trident/.test(uagent)) {
	      browser.msie = true;
	      browser.version = 11;
	    }
	  }
	  if (browser.version === '') {
	    for (x in browser) {
	      if (browser[x]) {
	        browser.version = uagent.match(new RegExp('(' + x + ')( |/)([0-9]+)'))[3];
	        break;
	      }
	    }
	  }
	  return {
	    browser: browser,
	    platform: platform,
	    retina: window.devicePixelRatio >= 1.5
	  };
	});canvasExtModule.factory('apTypeHelper', function () {
	  function objectType(obj) {
	    var text = Function.prototype.toString.call(obj.constructor);
	    return text.match(/function (.*)\(/)[1];
	  }
	  function isInstanceOf(value, type) {
	    if (!value || typeof value !== 'object') {
	      return false;
	    }
	    return objectType(value) === type;
	  }
	  function isOneOf(value, types) {
	    for (var i = 0; i < types.length; i++) {
	      if (isInstanceOf(value, types[i])) {
	        return true;
	      }
	    }
	    return false;
	  }
	  function isNumber(value) {
	    return typeof value === 'number';
	  }
	  return {
	    isInstanceOf: isInstanceOf,
	    isOneOf: isOneOf,
	    isNumber: isNumber
	  };
	});
	canvasExtModule.factory('apPosition', ['apTypeHelper', function (apTypeHelper) {
	  function APPosition(x, y) {
	    this.x = apTypeHelper.isNumber(x) ? x : 0;
	    this.y = apTypeHelper.isNumber(y) ? y : 0;
	  }
	  APPosition.prototype = {
	    isValid: function () {
	      return apTypeHelper.isNumber(this.x) && apTypeHelper.isNumber(this.y);
	    }
	  };
	  APPosition.defaultPosition = function () {
	    return new APPosition();
	  };
	  return APPosition;
	}]);
	canvasExtModule.factory('apSize', ['apTypeHelper', function (apTypeHelper) {
	  function APSize(width, height) {
	    this.width = apTypeHelper.isNumber(width) ? width : 0;
	    this.height = apTypeHelper.isNumber(height) ? height : 0;
	  }
	  APSize.prototype = {
	    isValid: function () {
	      return apTypeHelper.isNumber(this.width) && apTypeHelper.isNumber(this.height);
	    }
	  };
	  APSize.defaultSize = function () {
	    return new APSize();
	  };
	  return APSize;
	}]);
	canvasExtModule.factory('apFrame', ['apTypeHelper', 'apPosition', 'apSize', function (apTypeHelper, apPosition, apSize) {
	  function APFrame(x, y, width, height) {
	    this.origin = new apPosition(x, y);
	    this.size = new apSize(width, height);
	  }
	  APFrame.prototype = {
	    isValid: function () {
	      return this.origin.isValid() && this.size.isValid();
	    }
	  };
	  APFrame.defaultFrame = function () {
	    return new APFrame();
	  };
	  return APFrame;
	}]);
	canvasExtModule.factory('apImageHelper', ['$rootScope', '$q', 'apBrowserHelper', 'apTypeHelper', 'apPosition', 'apSize', 'apFrame', function ($rootScope, $q, apBrowserHelper, apTypeHelper, apPosition, apSize, apFrame) {
	  var browser = apBrowserHelper.browser, platform = apBrowserHelper.platform;
	  function createCanvasContext(width, height) {
	    var canvas = document.createElement('canvas');
	    canvas.width = width;
	    canvas.height = height;
	    return canvas.getContext('2d');
	  }
	  function imageToImageData(image) {
	    var context = createCanvasContext(image.width, image.height);
	    context.drawImage(image, 0, 0);
	    return context.getImageData(0, 0, context.canvas.width, context.canvas.height);
	  }
	  function imageToCanvas(image) {
	    var context = createCanvasContext(image.width, image.height);
	    context.drawImage(image, 0, 0);
	    return context.canvas;
	  }
	  function sameSizeImages(img1, img2) {
	    return img1.width === img2.width && img1.height === img2.height;
	  }
	  function imagesDifference(img1, img2, tolerance, strict) {
	    // if (!apTypeHelper.isOneOf(img1, ['HTMLImageElement', 'ImageData']) ||
	    //     !apTypeHelper.isOneOf(img2, ['HTMLImageElement', 'ImageData'])) {
	    //   return undefined;
	    // }
	    var img1Data = img1 instanceof ImageData ? img1.data : imageToImageData(img1).data, img2Data = img2 instanceof ImageData ? img2.data : imageToImageData(img2).data;
	    tolerance = apTypeHelper.isNumber(tolerance) || 255 * 0.05;
	    var difference = 0;
	    for (var i = 0; i < img1Data.length; i++) {
	      if (img1Data[i] !== img2Data[i] && Math.abs(img1Data[i] - img2Data[i]) > tolerance) {
	        if (strict) {
	          return 100;
	        }
	        difference++;
	      }
	    }
	    var differencePercent = difference * 100 / img1Data.length;
	    return differencePercent;
	  }
	  function sameImages(img1, img2, tolerance, treshold, strict) {
	    if (!sameSizeImages(img1, img2)) {
	      return false;
	    }
	    treshold = apTypeHelper.isNumber(treshold) ? treshold : 5;
	    difference = imagesDifference(img1, img2, tolerance, strict);
	    return difference <= treshold;
	  }
	  function loadImageFromUrl(url) {
	    var d = $q.defer();
	    var image = new Image();
	    image.onload = function () {
	      d.resolve(image);
	      $rootScope.$apply();
	    };
	    image.onerror = function () {
	      d.resolve(null);
	      $rootScope.$apply();
	    };
	    image.src = url;
	    return d.promise;
	  }
	  function loadImagesFromUrls(urls) {
	    var promises = [];
	    angular.forEach(urls, function (url, i) {
	      promises.push(loadImageFromUrl(url));
	    });
	    return $q.all(promises);
	  }
	  function downloadImageHandler(imageDataURI, filename, event) {
	    var dataURI = imageDataURI;
	    function prevent() {
	      event.preventDefault();
	      return false;
	    }
	    if (!dataURI) {
	      return prevent();
	    }
	    if (platform.ios) {
	      window.win = open(dataURI);
	      return prevent();
	    }
	    if (browser.msie) {
	      var blob = dataURItoBlob(dataURI);
	      if (blob && window.navigator.msSaveOrOpenBlob) {
	        window.navigator.msSaveOrOpenBlob(blob, filename);
	      }
	      return prevent();
	    }
	    var type = mimetypeOfDataURI(dataURI);
	    dataURI = dataURI.replace(type, 'image/octet-stream');
	    event.currentTarget.href = dataURI;
	    event.currentTarget.download = filename;
	    return true;
	  }
	  function isImageDataURL(s) {
	    var regex = /^\s*data:(image\/[a-z]+);base64,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
	    return s && !!s.match(regex);
	  }
	  function mimetypeOfDataURI(dataURI) {
	    if (!isImageDataURL(dataURI)) {
	      return null;
	    }
	    return dataURI.split(',')[0].split(':')[1].split(';')[0];
	  }
	  function dataURItoBlob(dataURI) {
	    if (!isImageDataURL(dataURI)) {
	      return null;
	    }
	    var byteString;
	    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
	      byteString = atob(dataURI.split(',')[1]);
	    } else {
	      byteString = unescape(dataURI.split(',')[1]);
	    }
	    var mimeString = mimetypeOfDataURI(dataURI);
	    var ab = new ArrayBuffer(byteString.length);
	    var ia = new Uint8Array(ab);
	    for (var i = 0; i < byteString.length; i++) {
	      ia[i] = byteString.charCodeAt(i);
	    }
	    return new Blob([ab], { type: mimeString });
	  }
	  function fileToImageDataURI(file, type, quality, callback) {
	    if (!(file instanceof Blob) && !(file instanceof File)) {
	      callback(null);
	      return;
	    }
	    if (!type) {
	      type = file.type;
	    }
	    var imgSrc = URL.createObjectURL(file);
	    if (imgSrc && imgSrc !== '') {
	      var image = new Image();
	      image.onload = function () {
	        if (platform.ios) {
	          getImageOrientation(image, function (orientation) {
	            var fixOptions = {
	                orientation: orientation,
	                maxWidth: 500,
	                maxHeight: 500
	              };
	            getCanvasWithFixedImage(image, fixOptions, function (target) {
	              callback(canvasToDataURI(target, type, quality));
	            });
	          });
	        } else {
	          var ctx = createCanvasContext(image.width, image.height);
	          ctx.drawImage(image, 0, 0);
	          callback(canvasToDataURI(ctx.canvas, type, quality));
	        }
	      };
	      image.src = imgSrc;
	    } else {
	      callback(null);
	    }
	  }
	  function getImageOrientation(image, callback) {
	    EXIF.getData(image, function () {
	      callback(EXIF.getTag(image, 'Orientation'));
	    });
	  }
	  function getCanvasWithFixedImage(image, fixOptions, callback) {
	    var mpImg = new MegaPixImage(image), canvas = createCanvasContext(image.width, image.height).canvas;
	    mpImg.onrender = function (target) {
	      callback(target);
	    };
	    mpImg.render(canvas, fixOptions);
	  }
	  function copyImageData(ctx, src) {
	    var dst = ctx.createImageData(src.width, src.height);
	    if (dst.data.set) {
	      dst.data.set(src.data);
	    } else {
	      var srcData = src.data, dstData = dst.data;
	      for (var i = 0; i < srcData.length; ++i) {
	        dstData[i] = srcData[i];
	      }
	    }
	    return dst;
	  }
	  function makeFrame(x, y, width, height) {
	    return new apFrame(x, y, width, height);
	  }
	  function cropImage(image, frame, maxSize, type, quality) {
	    if (!image || !frame) {
	      return null;
	    }
	    // if (!apTypeHelper.isOneOf(image, ['HTMLImageElement', 'ImageData', 'HTMLCanvasElement']) ||
	    //     !frame ||
	    //     !frame.isValid()) {
	    //   return null;
	    // }
	    var ctx = createCanvasContext(frame.size.width, frame.size.height);
	    if (image instanceof ImageData) {
	      var srcCtx = createCanvasContext(image.width, image.height);
	      srcCtx.putImageData(image, 0, 0);
	      image = srcCtx.canvas;
	    }
	    ctx.drawImage(image, frame.origin.x, frame.origin.y, frame.size.width, frame.size.height, 0, 0, frame.size.width, frame.size.height);
	    if (maxSize && (frame.size.width > maxSize.width || frame.size.height > maxSize.height)) {
	      return resizeImage(ctx.canvas, maxSize, type, quality);
	    }
	    return canvasData(ctx, type, quality);
	  }
	  function resizeImage(image, size, type, quality, fill) {
	    if (!image || !(image instanceof Image) && !(image instanceof ImageData) && !(image instanceof HTMLCanvasElement)) {
	      return null;
	    }
	    var widthScale = size.width / image.width, heightScale = size.height / image.height, scale = fill ? Math.max(widthScale, heightScale) : Math.min(widthScale, heightScale), size = {
	        width: image.width * scale,
	        height: image.height * scale
	      };
	    var dstCtx = createCanvasContext(size.width, size.height);
	    if (image instanceof ImageData) {
	      var srcCtx = createCanvasContext(image.width, image.height);
	      srcCtx.putImageData(image, 0, 0);
	      image = srcCtx.canvas;
	    }
	    dstCtx.drawImage(image, 0, 0, dstCtx.canvas.width, dstCtx.canvas.height);
	    return canvasData(dstCtx, type, quality);
	  }
	  function getImageOffsetLimits(image, scale, size) {
	    var imageHalfWidth = image.width / 2, imageHalfHeight = image.height / 2, boundsHalfWidth = size.width / 2, boundsHalfHeight = size.height / 2, scaledBoundsHalfWidth = boundsHalfWidth / scale, scaledBoundsHalfHeight = boundsHalfHeight / scale;
	    return {
	      left: -imageHalfWidth + scaledBoundsHalfWidth,
	      right: imageHalfWidth - scaledBoundsHalfWidth,
	      top: -imageHalfHeight + scaledBoundsHalfHeight,
	      bottom: imageHalfHeight - scaledBoundsHalfHeight
	    };
	  }
	  function drawImage(image, scale, offset, ctx) {
	    var imageHalfWidth = image.width / 2, imageHalfHeight = image.height / 2, canvasHalfWidth = ctx.canvas.width / 2, canvasHalfHeight = ctx.canvas.height / 2, beforeScaleOffset = {
	        x: (-imageHalfWidth + offset.x) * scale,
	        y: (-imageHalfHeight + offset.y) * scale
	      }, afterScaleOffset = {
	        x: canvasHalfWidth / scale,
	        y: canvasHalfHeight / scale
	      };
	    ctx.canvas.width = ctx.canvas.width;
	    // move center to the left and top corner
	    ctx.translate(beforeScaleOffset.x, beforeScaleOffset.y);
	    // scale
	    ctx.scale(scale, scale);
	    // move center back to the center
	    ctx.translate(afterScaleOffset.x, afterScaleOffset.y);
	    // draw image in original size
	    ctx.drawImage(image, 0, 0, image.width, image.height);
	    // return frame of cropped image
	    var x = imageHalfWidth - canvasHalfWidth / scale - offset.x, y = imageHalfHeight - canvasHalfHeight / scale - offset.y, width = ctx.canvas.width / scale, height = ctx.canvas.height / scale;
	    return makeFrame(x, y, width, height);
	  }
	  function snapImage(image, size, scale, offset) {
	    var ctx = createCanvasContext(size.width, size.height);
	    drawImage(image, scale, offset, ctx);
	    return canvasData(ctx);
	  }
	  function canvasToDataURI(canvas, type, quality) {
	    if (!type) {
	      type = 'image/jpeg';
	    }
	    if (!quality) {
	      quality = 1;
	    }
	    return canvas.toDataURL(type, quality);
	  }
	  function canvasData(ctx, type, quality) {
	    return {
	      dataURI: canvasToDataURI(ctx.canvas, type, quality),
	      imageData: ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height)
	    };
	  }
	  return {
	    downloadImageHandler: downloadImageHandler,
	    dataURItoBlob: dataURItoBlob,
	    fileToImageDataURI: fileToImageDataURI,
	    copyImageData: copyImageData,
	    cropImage: cropImage,
	    resizeImage: resizeImage,
	    getImageOffsetLimits: getImageOffsetLimits,
	    drawImage: drawImage,
	    mimetypeOfDataURI: mimetypeOfDataURI,
	    loadImagesFromUrls: loadImagesFromUrls,
	    loadImageFromUrl: loadImageFromUrl,
	    sameImages: sameImages,
	    makeFrame: makeFrame,
	    imageToImageData: imageToImageData,
	    imageToCanvas: imageToCanvas,
	    snapImage: snapImage
	  };
	}]);
	canvasExtModule.directive('apCanvas', ['apImageHelper', function (apImageHelper) {
	  return {
	    restrict: 'A',
	    scope: {
	      src: '=',
	      scale: '=?',
	      offset: '=?',
	      zoomable: '=?',
	      mode: '=?',
	      image: '=?',
	      frame: '=?'
	    },
	    link: function ($scope, element, attrs) {
	      var canvas = element[0], ctx = canvas.getContext('2d'), previousMousePosition = null, isMoving = false, defaultScale = 0, isUpdateOffset = false, isUpdateScale = false, lastZoomDist = null;
	      if (!$scope.offset) {
	        $scope.offset = {
	          x: 0,
	          y: 0
	        };
	      }
	      if (!$scope.mode) {
	        $scope.mode = 'fill';
	      }
	      $scope.$watch(function () {
	        return $scope.src;
	      }, function (newSrc) {
	        if (newSrc) {
	          loadImage();
	        } else {
	          $scope.image = null;
	        }
	      });
	      function loadImage() {
	        var image = new Image();
	        image.onload = function () {
	          $scope.image = image;
	          $scope.$apply();
	        };
	        image.src = $scope.src;
	      }
	      $scope.$watch(function () {
	        return $scope.image;
	      }, function (newImage, oldImage) {
	        canvas.width = canvas.width;
	        if (newImage) {
	          updateDefaultScale();
	          if (oldImage || !$scope.scale) {
	            updateScale();
	          }
	          drawImage();
	        }
	      });
	      function setScale(scale) {
	        isUpdateScale = true;
	        $scope.scale = scale;
	        isUpdateScale = false;
	      }
	      function updateDefaultScale() {
	        var image = $scope.image, widthScale = canvas.width / image.width, heightScale = canvas.height / image.height;
	        if ($scope.mode === 'fill') {
	          defaultScale = Math.max(widthScale, heightScale);
	        } else if ($scope.mode === 'fit') {
	          defaultScale = Math.min(widthScale, heightScale);
	        } else {
	          defaultScale = 1;
	        }
	      }
	      function updateScale() {
	        setScale(defaultScale);
	      }
	      function drawImage() {
	        if (!$scope.image || isUpdateScale || isUpdateOffset) {
	          return;
	        }
	        clipToBounds();
	        $scope.frame = apImageHelper.drawImage($scope.image, $scope.scale, $scope.offset, ctx);
	      }
	      function clipToBounds() {
	        isUpdateOffset = true;
	        var bounds = {
	            width: canvas.width,
	            height: canvas.height
	          }, offsetLimits = apImageHelper.getImageOffsetLimits($scope.image, $scope.scale, bounds);
	        if ($scope.offset.y < offsetLimits.top) {
	          $scope.offset.y = offsetLimits.top;
	        }
	        if ($scope.offset.y > offsetLimits.bottom) {
	          $scope.offset.y = offsetLimits.bottom;
	        }
	        if ($scope.offset.x < offsetLimits.left) {
	          $scope.offset.x = offsetLimits.left;
	        }
	        if ($scope.offset.x > offsetLimits.right) {
	          $scope.offset.x = offsetLimits.right;
	        }
	        isUpdateOffset = false;
	      }
	      if ($scope.zoomable) {
	        function getMousePosition(e) {
	          var rect = canvas.getBoundingClientRect();
	          return {
	            x: (e.clientX - rect.left) / $scope.scale,
	            y: (e.clientY - rect.top) / $scope.scale
	          };
	        }
	        function setIsMoving(moving, event, position) {
	          event.preventDefault();
	          isMoving = moving;
	          if (moving) {
	            previousMousePosition = getMousePosition(position);
	          }
	        }
	        function moveTo(e, position) {
	          if (isMoving) {
	            e.preventDefault();
	            var mousePosition = getMousePosition(position);
	            $scope.offset = {
	              x: $scope.offset.x + (mousePosition.x - previousMousePosition.x),
	              y: $scope.offset.y + (mousePosition.y - previousMousePosition.y)
	            };
	            previousMousePosition = mousePosition;
	            $scope.$apply();
	          }
	        }
	        function zoom(e, touch1, touch2) {
	          e.preventDefault();
	          var dist = Math.sqrt(Math.pow(touch2.pageX - touch1.pageX, 2) + Math.pow(touch2.pageY - touch1.pageY, 2));
	          if (lastZoomDist) {
	            $scope.scale *= dist / lastZoomDist;
	            $scope.$apply();
	          }
	          lastZoomDist = dist;
	        }
	        function handleMouseDown(e) {
	          setIsMoving(true, e, e);
	        }
	        function handleTouchStart(e) {
	          if (e.targetTouches.length === 1) {
	            setIsMoving(true, e, e.changedTouches[0]);
	          }
	        }
	        function handleMouseUp(e) {
	          setIsMoving(false, e);
	        }
	        function handleTouchEnd(e) {
	          lastZoomDist = null;
	          setIsMoving(false, e);
	        }
	        function handleMouseMove(e) {
	          moveTo(e, e);
	        }
	        function handleTouchMove(e) {
	          if (e.targetTouches.length >= 2) {
	            var touch1 = e.targetTouches[0], touch2 = e.targetTouches[1];
	            if (touch1 && touch2) {
	              zoom(e, touch1, touch2);
	            }
	          } else {
	            moveTo(e, e.changedTouches[0]);
	          }
	        }
	        function handleMouseWheel(e) {
	          if (e.wheelDelta > 0) {
	            $scope.scale *= 1.01;
	          } else {
	            $scope.scale /= 1.01;
	          }
	        }
	        canvas.addEventListener('mousedown', handleMouseDown, false);
	        canvas.addEventListener('mouseup', handleMouseUp, false);
	        canvas.addEventListener('mouseleave', handleMouseUp, false);
	        canvas.addEventListener('mousemove', handleMouseMove, false);
	        canvas.addEventListener('mousewheel', handleMouseWheel, false);
	        canvas.addEventListener('touchstart', handleTouchStart, false);
	        canvas.addEventListener('touchend', handleTouchEnd, false);
	        canvas.addEventListener('touchcancel', handleTouchEnd, false);
	        canvas.addEventListener('touchleave', handleTouchEnd, false);
	        canvas.addEventListener('touchmove', handleTouchMove, false);
	        $scope.$watch(function () {
	          return $scope.scale;
	        }, function (newScale, oldScale) {
	          if (newScale && newScale < defaultScale) {
	            setScale(defaultScale);
	          }
	          drawImage();
	        });
	        $scope.$watch(function () {
	          return $scope.offset;
	        }, function (newOffset) {
	          drawImage();
	        });
	      }
	    }
	  };
	}]);canvasExtModule.directive('apFileSrc', ['apImageHelper', function (apImageHelper) {
	  return {
	    restrict: 'A',
	    scope: {
	      src: '=apFileSrc',
	      onImageSelected: '&?',
	      onImageReady: '&?',
	      mimeType: '=?',
	      quality: '=?'
	    },
	    link: function ($scope, element, attrs) {
	      var updateImageSrc = function (src) {
	        $scope.src = src;
	        $scope.$apply();
	        if ($scope.onImageReady) {
	          $scope.onImageReady();
	        }
	      };
	      element.bind('change', function (e) {
	        if ($scope.onImageSelected) {
	          $scope.onImageSelected();
	        }
	        var file = e.target.files.length ? e.target.files[0] : null;
	        if (file) {
	          apImageHelper.fileToImageDataURI(file, $scope.mimeType, $scope.quality, updateImageSrc);
	        }
	      });
	    }
	  };
	}]);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	angular.module('uiSwitch', [])
	
	.directive('switch', function(){
	  return {
	    restrict: 'AE'
	  , replace: true
	  , transclude: true
	  , template: function(element, attrs) {
	      var html = '';
	      html += '<span';
	      html +=   ' class="switch' + (attrs.class ? ' ' + attrs.class : '') + '"';
	      html +=   attrs.ngModel ? ' ng-click="' + attrs.disabled + ' ? ' + attrs.ngModel + ' : ' + attrs.ngModel + '=!' + attrs.ngModel + (attrs.ngChange ? '; ' + attrs.ngChange + '()"' : '"') : '';
	      html +=   ' ng-class="{ checked:' + attrs.ngModel + ', disabled:' + attrs.disabled + ' }"';
	      html +=   '>';
	      html +=   '<small></small>';
	      html +=   '<input type="checkbox"';
	      html +=     attrs.id ? ' id="' + attrs.id + '"' : '';
	      html +=     attrs.name ? ' name="' + attrs.name + '"' : '';
	      html +=     attrs.ngModel ? ' ng-model="' + attrs.ngModel + '"' : '';
	      html +=     ' style="display:none" />';
	      html +=     '<span class="switch-text">'; /*adding new container for switch text*/
	      html +=     attrs.on ? '<span class="on">'+attrs.on+'</span>' : ''; /*switch text on value set by user in directive html markup*/
	      html +=     attrs.off ? '<span class="off">'+attrs.off + '</span>' : ' ';  /*switch text off value set by user in directive html markup*/
	      html += '</span>';
	      return html;
	    }
	  }
	});


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! angularjs-slider - v6.7.0 - 
	 (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervi.eu>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> - 
	 https://github.com/angular-slider/angularjs-slider - 
	 2019-02-23 */
	/*jslint unparam: true */
	/*global angular: false, console: false, define, module */
	;(function(root, factory) {
	  'use strict'
	  /* istanbul ignore next */
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    // to support bundler like browserify
	    var angularObj = angular || require('angular')
	    if ((!angularObj || !angularObj.module) && typeof angular != 'undefined') {
	      angularObj = angular
	    }
	    module.exports = factory(angularObj)
	  } else {
	    // Browser globals (root is window)
	    factory(root.angular)
	  }
	})(this, function(angular) {
	  'use strict'
	  var module = angular
	    .module('rzModule', [])
	    .factory('RzSliderOptions', function() {
	      var defaultOptions = {
	        floor: 0,
	        ceil: null, //defaults to rz-slider-model
	        step: 1,
	        precision: 0,
	        minRange: null,
	        maxRange: null,
	        restrictedRange: null,
	        pushRange: false,
	        minLimit: null,
	        maxLimit: null,
	        id: null,
	        translate: null,
	        getLegend: null,
	        stepsArray: null,
	        bindIndexForStepsArray: false,
	        draggableRange: false,
	        draggableRangeOnly: false,
	        showSelectionBar: false,
	        showSelectionBarEnd: false,
	        showSelectionBarFromValue: null,
	        showOuterSelectionBars: false,
	        hidePointerLabels: false,
	        hideLimitLabels: false,
	        autoHideLimitLabels: true,
	        readOnly: false,
	        disabled: false,
	        interval: 350,
	        showTicks: false,
	        showTicksValues: false,
	        ticksArray: null,
	        ticksTooltip: null,
	        ticksValuesTooltip: null,
	        vertical: false,
	        getSelectionBarColor: null,
	        getTickColor: null,
	        getPointerColor: null,
	        keyboardSupport: true,
	        scale: 1,
	        enforceStep: true,
	        enforceRange: false,
	        noSwitching: false,
	        onlyBindHandles: false,
	        onStart: null,
	        onChange: null,
	        onEnd: null,
	        rightToLeft: false,
	        reversedControls: false,
	        boundPointerLabels: true,
	        mergeRangeLabelsIfSame: false,
	        labelOverlapSeparator: ' - ',
	        customTemplateScope: null,
	        logScale: false,
	        customValueToPosition: null,
	        customPositionToValue: null,
	        selectionBarGradient: null,
	        ariaLabel: null,
	        ariaLabelledBy: null,
	        ariaLabelHigh: null,
	        ariaLabelledByHigh: null,
	      }
	      var globalOptions = {}
	
	      var factory = {}
	      /**
	       * `options({})` allows global configuration of all sliders in the
	       * application.
	       *
	       *   var app = angular.module( 'App', ['rzModule'], function( RzSliderOptions ) {
	       *     // show ticks for all sliders
	       *     RzSliderOptions.options( { showTicks: true } );
	       *   });
	       */
	      factory.options = function(value) {
	        angular.extend(globalOptions, value)
	      }
	
	      factory.getOptions = function(options) {
	        return angular.extend({}, defaultOptions, globalOptions, options)
	      }
	
	      return factory
	    })
	    .factory('rzThrottle', ['$timeout', function($timeout) {
	      /**
	       * rzThrottle
	       *
	       * Taken from underscore project
	       *
	       * @param {Function} func
	       * @param {number} wait
	       * @param {ThrottleOptions} options
	       * @returns {Function}
	       */
	      return function(func, wait, options) {
	        'use strict'
	        /* istanbul ignore next */
	        var getTime =
	          Date.now ||
	          function() {
	            return new Date().getTime()
	          }
	        var context, args, result
	        var timeout = null
	        var previous = 0
	        options = options || {}
	        var later = function() {
	          previous = getTime()
	          timeout = null
	          result = func.apply(context, args)
	          context = args = null
	        }
	        return function() {
	          var now = getTime()
	          var remaining = wait - (now - previous)
	          context = this
	          args = arguments
	          if (remaining <= 0) {
	            $timeout.cancel(timeout)
	            timeout = null
	            previous = now
	            result = func.apply(context, args)
	            context = args = null
	          } else if (!timeout && options.trailing !== false) {
	            timeout = $timeout(later, remaining)
	          }
	          return result
	        }
	      }
	    }])
	    .factory('RzSlider', ['$timeout', '$document', '$window', '$compile', 'RzSliderOptions', 'rzThrottle', function(
	      $timeout,
	      $document,
	      $window,
	      $compile,
	      RzSliderOptions,
	      rzThrottle
	    ) {
	      'use strict'
	
	      /**
	       * Slider
	       *
	       * @param {ngScope} scope            The AngularJS scope
	       * @param {Element} sliderElem The slider directive element wrapped in jqLite
	       * @constructor
	       */
	      var Slider = function(scope, sliderElem) {
	        /**
	         * The slider's scope
	         *
	         * @type {ngScope}
	         */
	        this.scope = scope
	
	        /**
	         * The slider inner low value (linked to rzSliderModel)
	         * @type {number}
	         */
	        this.lowValue = 0
	
	        /**
	         * The slider inner high value (linked to rzSliderHigh)
	         * @type {number}
	         */
	        this.highValue = 0
	
	        /**
	         * Slider element wrapped in jqLite
	         *
	         * @type {jqLite}
	         */
	        this.sliderElem = sliderElem
	
	        /**
	         * Slider type
	         *
	         * @type {boolean} Set to true for range slider
	         */
	        this.range =
	          this.scope.rzSliderModel !== undefined &&
	          this.scope.rzSliderHigh !== undefined
	
	        /**
	         * Values recorded when first dragging the bar
	         *
	         * @type {Object}
	         */
	        this.dragging = {
	          active: false,
	          value: 0,
	          difference: 0,
	          position: 0,
	          lowLimit: 0,
	          highLimit: 0,
	        }
	
	        /**
	         * property that handle position (defaults to left for horizontal)
	         * @type {string}
	         */
	        this.positionProperty = 'left'
	
	        /**
	         * property that handle dimension (defaults to width for horizontal)
	         * @type {string}
	         */
	        this.dimensionProperty = 'width'
	
	        /**
	         * Half of the width or height of the slider handles
	         *
	         * @type {number}
	         */
	        this.handleHalfDim = 0
	
	        /**
	         * Maximum position the slider handle can have
	         *
	         * @type {number}
	         */
	        this.maxPos = 0
	
	        /**
	         * Precision
	         *
	         * @type {number}
	         */
	        this.precision = 0
	
	        /**
	         * Step
	         *
	         * @type {number}
	         */
	        this.step = 1
	
	        /**
	         * The name of the handle we are currently tracking
	         *
	         * @type {string}
	         */
	        this.tracking = ''
	
	        /**
	         * Minimum value (floor) of the model
	         *
	         * @type {number}
	         */
	        this.minValue = 0
	
	        /**
	         * Maximum value (ceiling) of the model
	         *
	         * @type {number}
	         */
	        this.maxValue = 0
	
	        /**
	         * The delta between min and max value
	         *
	         * @type {number}
	         */
	        this.valueRange = 0
	
	        /**
	         * If showTicks/showTicksValues options are number.
	         * In this case, ticks values should be displayed below the slider.
	         * @type {boolean}
	         */
	        this.intermediateTicks = false
	
	        /**
	         * Set to true if init method already executed
	         *
	         * @type {boolean}
	         */
	        this.initHasRun = false
	
	        /**
	         * Used to call onStart on the first keydown event
	         *
	         * @type {boolean}
	         */
	        this.firstKeyDown = false
	
	        /**
	         * Internal flag to prevent watchers to be called when the sliders value are modified internally.
	         * @type {boolean}
	         */
	        this.internalChange = false
	
	        /**
	         * Internal flag to keep track of the visibility of combo label
	         * @type {boolean}
	         */
	        this.cmbLabelShown = false
	
	        /**
	         * Internal variable to keep track of the focus element
	         */
	        this.currentFocusElement = null
	
	        // Slider DOM elements wrapped in jqLite
	        this.fullBar = null // The whole slider bar
	        this.selBar = null // Highlight between two handles
	        this.minH = null // Left slider handle
	        this.maxH = null // Right slider handle
	        this.flrLab = null // Floor label
	        this.ceilLab = null // Ceiling label
	        this.minLab = null // Label above the low value
	        this.maxLab = null // Label above the high value
	        this.cmbLab = null // Combined label
	        this.ticks = null // The ticks
	
	        // Initialize slider
	        this.init()
	      }
	
	      // Add instance methods
	      Slider.prototype = {
	        /**
	         * Initialize slider
	         *
	         * @returns {undefined}
	         */
	        init: function() {
	          var thrLow,
	            thrHigh,
	            self = this
	
	          var calcDimFn = function() {
	            self.calcViewDimensions()
	          }
	
	          this.applyOptions()
	          this.syncLowValue()
	          if (this.range) this.syncHighValue()
	          this.initElemHandles()
	          this.manageElementsStyle()
	          this.setDisabledState()
	          this.calcViewDimensions()
	          this.setMinAndMax()
	          this.updateRestrictionBar()
	          this.addAccessibility()
	          this.updateCeilLab()
	          this.updateFloorLab()
	          this.initHandles()
	          this.manageEventsBindings()
	
	          // Recalculate slider view dimensions
	          this.scope.$on('reCalcViewDimensions', calcDimFn)
	
	          // Recalculate stuff if view port dimensions have changed
	          angular.element($window).on('resize', calcDimFn)
	
	          this.initHasRun = true
	
	          // Watch for changes to the model
	          thrLow = rzThrottle(function() {
	            self.onLowHandleChange()
	          }, self.options.interval)
	
	          thrHigh = rzThrottle(function() {
	            self.onHighHandleChange()
	          }, self.options.interval)
	
	          this.scope.$on('rzSliderForceRender', function() {
	            self.resetLabelsValue()
	            thrLow()
	            if (self.range) {
	              thrHigh()
	            }
	            self.resetSlider()
	          })
	
	          // Watchers (order is important because in case of simultaneous change,
	          // watchers will be called in the same order)
	          this.scope.$watchCollection('rzSliderOptions()', function(
	            newValue,
	            oldValue
	          ) {
	            if (newValue === oldValue) return
	            self.applyOptions() // need to be called before synchronizing the values
	            self.syncLowValue()
	            if (self.range) self.syncHighValue()
	            self.resetSlider()
	          })
	
	          this.scope.$watch('rzSliderModel', function(newValue, oldValue) {
	            if (self.internalChange) return
	            if (newValue === oldValue) return
	            thrLow()
	          })
	
	          this.scope.$watch('rzSliderHigh', function(newValue, oldValue) {
	            if (self.internalChange) return
	            if (newValue === oldValue) return
	            if (newValue != null) thrHigh()
	            if (
	              (self.range && newValue == null) ||
	              (!self.range && newValue != null)
	            ) {
	              self.applyOptions()
	              self.resetSlider()
	            }
	          })
	
	          this.scope.$on('$destroy', function() {
	            self.unbindEvents()
	            angular.element($window).off('resize', calcDimFn)
	            self.currentFocusElement = null
	          })
	        },
	
	        findStepIndex: function(modelValue) {
	          var index = 0
	          for (var i = 0; i < this.options.stepsArray.length; i++) {
	            var step = this.options.stepsArray[i]
	            if (step === modelValue) {
	              index = i
	              break
	            } else if (angular.isDate(step)) {
	              if (step.getTime() === modelValue.getTime()) {
	                index = i
	                break
	              }
	            } else if (angular.isObject(step)) {
	              if (
	                (angular.isDate(step.value) &&
	                  step.value.getTime() === modelValue.getTime()) ||
	                step.value === modelValue
	              ) {
	                index = i
	                break
	              }
	            }
	          }
	          return index
	        },
	
	        syncLowValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.lowValue = this.findStepIndex(this.scope.rzSliderModel)
	            else this.lowValue = this.scope.rzSliderModel
	          } else this.lowValue = this.scope.rzSliderModel
	        },
	
	        syncHighValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.highValue = this.findStepIndex(this.scope.rzSliderHigh)
	            else this.highValue = this.scope.rzSliderHigh
	          } else this.highValue = this.scope.rzSliderHigh
	        },
	
	        getStepValue: function(sliderValue) {
	          var step = this.options.stepsArray[sliderValue]
	          if (angular.isDate(step)) return step
	          if (angular.isObject(step)) return step.value
	          return step
	        },
	
	        applyLowValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.scope.rzSliderModel = this.getStepValue(this.lowValue)
	            else this.scope.rzSliderModel = this.lowValue
	          } else this.scope.rzSliderModel = this.lowValue
	        },
	
	        applyHighValue: function() {
	          if (this.options.stepsArray) {
	            if (!this.options.bindIndexForStepsArray)
	              this.scope.rzSliderHigh = this.getStepValue(this.highValue)
	            else this.scope.rzSliderHigh = this.highValue
	          } else this.scope.rzSliderHigh = this.highValue
	        },
	
	        /*
	       * Reflow the slider when the low handle changes (called with throttle)
	       */
	        onLowHandleChange: function() {
	          this.syncLowValue()
	          if (this.range) this.syncHighValue()
	          this.setMinAndMax()
	          this.updateLowHandle(this.valueToPosition(this.lowValue))
	          this.updateSelectionBar()
	          this.updateTicksScale()
	          this.updateAriaAttributes()
	          if (this.range) {
	            this.updateCmbLabel()
	          }
	        },
	
	        /*
	       * Reflow the slider when the high handle changes (called with throttle)
	       */
	        onHighHandleChange: function() {
	          this.syncLowValue()
	          this.syncHighValue()
	          this.setMinAndMax()
	          this.updateHighHandle(this.valueToPosition(this.highValue))
	          this.updateSelectionBar()
	          this.updateTicksScale()
	          this.updateCmbLabel()
	          this.updateAriaAttributes()
	        },
	
	        /**
	         * Read the user options and apply them to the slider model
	         */
	        applyOptions: function() {
	          var sliderOptions
	          if (this.scope.rzSliderOptions)
	            sliderOptions = this.scope.rzSliderOptions()
	          else sliderOptions = {}
	
	          this.options = RzSliderOptions.getOptions(sliderOptions)
	
	          if (this.options.step <= 0) this.options.step = 1
	
	          this.range =
	            this.scope.rzSliderModel !== undefined &&
	            this.scope.rzSliderHigh !== undefined
	          this.options.draggableRange =
	            this.range && this.options.draggableRange
	          this.options.draggableRangeOnly =
	            this.range && this.options.draggableRangeOnly
	          if (this.options.draggableRangeOnly) {
	            this.options.draggableRange = true
	          }
	
	          this.options.showTicks =
	            this.options.showTicks ||
	            this.options.showTicksValues ||
	            !!this.options.ticksArray
	          this.scope.showTicks = this.options.showTicks //scope is used in the template
	          if (
	            angular.isNumber(this.options.showTicks) ||
	            this.options.ticksArray
	          )
	            this.intermediateTicks = true
	
	          this.options.showSelectionBar =
	            this.options.showSelectionBar ||
	            this.options.showSelectionBarEnd ||
	            this.options.showSelectionBarFromValue !== null
	
	          if (this.options.stepsArray) {
	            this.parseStepsArray()
	          } else {
	            if (this.options.translate) this.customTrFn = this.options.translate
	            else
	              this.customTrFn = function(value) {
	                return String(value)
	              }
	
	            this.getLegend = this.options.getLegend
	          }
	
	          if (this.options.vertical) {
	            this.positionProperty = 'bottom'
	            this.dimensionProperty = 'height'
	          }
	
	          if (this.options.customTemplateScope)
	            this.scope.custom = this.options.customTemplateScope
	        },
	
	        parseStepsArray: function() {
	          this.options.floor = 0
	          this.options.ceil = this.options.stepsArray.length - 1
	          this.options.step = 1
	
	          if (this.options.translate) {
	            this.customTrFn = this.options.translate
	          } else {
	            this.customTrFn = function(modelValue) {
	              if (this.options.bindIndexForStepsArray)
	                return this.getStepValue(modelValue)
	              return modelValue
	            }
	          }
	
	          this.getLegend = function(index) {
	            var step = this.options.stepsArray[index]
	            if (angular.isObject(step)) return step.legend
	            return null
	          }
	        },
	
	        /**
	         * Resets slider
	         *
	         * @returns {undefined}
	         */
	        resetSlider: function() {
	          this.manageElementsStyle()
	          this.addAccessibility()
	          this.setMinAndMax()
	          this.updateCeilLab()
	          this.updateFloorLab()
	          this.unbindEvents()
	          this.manageEventsBindings()
	          this.setDisabledState()
	          this.calcViewDimensions()
	          this.updateRestrictionBar()
	          this.refocusPointerIfNeeded()
	        },
	
	        refocusPointerIfNeeded: function() {
	          if (this.currentFocusElement) {
	            this.onPointerFocus(
	              this.currentFocusElement.pointer,
	              this.currentFocusElement.ref
	            )
	            this.focusElement(this.currentFocusElement.pointer)
	          }
	        },
	
	        /**
	         * Set the slider children to variables for easy access
	         *
	         * Run only once during initialization
	         *
	         * @returns {undefined}
	         */
	        initElemHandles: function() {
	          // Assign all slider elements to object properties for easy access
	          angular.forEach(
	            this.sliderElem.children(),
	            function(elem, index) {
	              var jElem = angular.element(elem)
	
	              switch (index) {
	                case 0:
	                  this.leftOutSelBar = jElem
	                  break
	                case 1:
	                  this.rightOutSelBar = jElem
	                  break
	                case 2:
	                  this.fullBar = jElem
	                  break
	                case 3:
	                  this.selBar = jElem
	                  break
	                case 4:
	                  this.restrictedBar = jElem
	                  break
	                case 5:
	                  this.minH = jElem
	                  break
	                case 6:
	                  this.maxH = jElem
	                  break
	                case 7:
	                  this.flrLab = jElem
	                  break
	                case 8:
	                  this.ceilLab = jElem
	                  break
	                case 9:
	                  this.minLab = jElem
	                  break
	                case 10:
	                  this.maxLab = jElem
	                  break
	                case 11:
	                  this.cmbLab = jElem
	                  break
	                case 12:
	                  this.ticks = jElem
	                  break
	              }
	            },
	            this
	          )
	
	          // Initialize position cache properties
	          this.selBar.rzsp = 0
	          this.minH.rzsp = 0
	          this.maxH.rzsp = 0
	          this.flrLab.rzsp = 0
	          this.ceilLab.rzsp = 0
	          this.minLab.rzsp = 0
	          this.maxLab.rzsp = 0
	          this.cmbLab.rzsp = 0
	        },
	
	        /**
	         * Update each elements style based on options
	         */
	        manageElementsStyle: function() {
	          if (!this.range) this.maxH.css('display', 'none')
	          else this.maxH.css('display', '')
	
	          this.alwaysHide(
	            this.flrLab,
	            this.options.showTicksValues || this.options.hideLimitLabels
	          )
	          this.alwaysHide(
	            this.ceilLab,
	            this.options.showTicksValues || this.options.hideLimitLabels
	          )
	
	          var hideLabelsForTicks =
	            this.options.showTicksValues && !this.intermediateTicks
	          this.alwaysHide(
	            this.minLab,
	            hideLabelsForTicks || this.options.hidePointerLabels
	          )
	          this.alwaysHide(
	            this.maxLab,
	            hideLabelsForTicks || !this.range || this.options.hidePointerLabels
	          )
	          this.alwaysHide(
	            this.cmbLab,
	            hideLabelsForTicks || !this.range || this.options.hidePointerLabels
	          )
	          this.alwaysHide(
	            this.selBar,
	            !this.range && !this.options.showSelectionBar
	          )
	          this.alwaysHide(
	            this.leftOutSelBar,
	            !this.range || !this.options.showOuterSelectionBars
	          )
	          this.alwaysHide(this.restrictedBar, !this.options.restrictedRange)
	          this.alwaysHide(
	            this.rightOutSelBar,
	            !this.range || !this.options.showOuterSelectionBars
	          )
	
	          if (this.range && this.options.showOuterSelectionBars) {
	            this.fullBar.addClass('rz-transparent')
	          }
	
	          if (this.options.vertical) this.sliderElem.addClass('rz-vertical')
	
	          if (this.options.draggableRange) this.selBar.addClass('rz-draggable')
	          else this.selBar.removeClass('rz-draggable')
	
	          if (this.intermediateTicks && this.options.showTicksValues)
	            this.ticks.addClass('rz-ticks-values-under')
	        },
	
	        alwaysHide: function(el, hide) {
	          el.rzAlwaysHide = hide
	          if (hide) this.hideEl(el)
	          else this.showEl(el)
	        },
	
	        /**
	         * Manage the events bindings based on readOnly and disabled options
	         *
	         * @returns {undefined}
	         */
	        manageEventsBindings: function() {
	          if (this.options.disabled || this.options.readOnly)
	            this.unbindEvents()
	          else this.bindEvents()
	        },
	
	        /**
	         * Set the disabled state based on rzSliderDisabled
	         *
	         * @returns {undefined}
	         */
	        setDisabledState: function() {
	          if (this.options.disabled) {
	            this.sliderElem.attr('disabled', 'disabled')
	          } else {
	            this.sliderElem.attr('disabled', null)
	          }
	        },
	
	        /**
	         * Reset label values
	         *
	         * @return {undefined}
	         */
	        resetLabelsValue: function() {
	          this.minLab.rzsv = undefined
	          this.maxLab.rzsv = undefined
	        },
	
	        /**
	         * Initialize slider handles positions and labels
	         *
	         * Run only once during initialization and every time view port changes size
	         *
	         * @returns {undefined}
	         */
	        initHandles: function() {
	          this.updateLowHandle(this.valueToPosition(this.lowValue))
	
	          /*
	         the order here is important since the selection bar should be
	         updated after the high handle but before the combined label
	         */
	          if (this.range)
	            this.updateHighHandle(this.valueToPosition(this.highValue))
	          this.updateSelectionBar()
	          if (this.range) this.updateCmbLabel()
	
	          this.updateTicksScale()
	        },
	
	        /**
	         * Translate value to human readable format
	         *
	         * @param {number|string} value
	         * @param {jqLite} label
	         * @param {String} which
	         * @param {boolean} [useCustomTr]
	         * @returns {undefined}
	         */
	        translateFn: function(value, label, which, useCustomTr) {
	          useCustomTr = useCustomTr === undefined ? true : useCustomTr
	
	          var valStr = '',
	            getDimension = false,
	            noLabelInjection = label.hasClass('no-label-injection')
	
	          if (useCustomTr) {
	            if (this.options.stepsArray && !this.options.bindIndexForStepsArray)
	              value = this.getStepValue(value)
	            valStr = String(this.customTrFn(value, this.options.id, which))
	          } else {
	            valStr = String(value)
	          }
	
	          if (
	            label.rzsv === undefined ||
	            label.rzsv.length !== valStr.length ||
	            (label.rzsv.length > 0 && label.rzsd === 0)
	          ) {
	            getDimension = true
	            label.rzsv = valStr
	          }
	
	          if (!noLabelInjection) {
	            label.html(valStr)
	          }
	          this.scope[which + 'Label'] = valStr
	
	          // Update width only when length of the label have changed
	          if (getDimension) {
	            this.getDimension(label)
	          }
	        },
	
	        /**
	         * Set maximum and minimum values for the slider and ensure the model and high
	         * value match these limits
	         * @returns {undefined}
	         */
	        setMinAndMax: function() {
	          this.step = +this.options.step
	          this.precision = +this.options.precision
	
	          this.minValue = this.options.floor
	          if (this.options.logScale && this.minValue === 0)
	            throw Error("Can't use floor=0 with logarithmic scale")
	
	          if (this.options.enforceStep) {
	            this.lowValue = this.roundStep(this.lowValue)
	            if (this.range) this.highValue = this.roundStep(this.highValue)
	          }
	
	          if (this.options.ceil != null) this.maxValue = this.options.ceil
	          else
	            this.maxValue = this.options.ceil = this.range
	              ? this.highValue
	              : this.lowValue
	
	          if (this.options.enforceRange) {
	            this.lowValue = this.sanitizeValue(this.lowValue)
	            if (this.range) this.highValue = this.sanitizeValue(this.highValue)
	          }
	
	          this.applyLowValue()
	          if (this.range) this.applyHighValue()
	
	          this.valueRange = this.maxValue - this.minValue
	        },
	
	        /**
	         * Adds accessibility attributes
	         *
	         * Run only once during initialization
	         *
	         * @returns {undefined}
	         */
	        addAccessibility: function() {
	          this.minH.attr('role', 'slider')
	          this.updateAriaAttributes()
	          if (
	            this.options.keyboardSupport &&
	            !(this.options.readOnly || this.options.disabled)
	          )
	            this.minH.attr('tabindex', '0')
	          else this.minH.attr('tabindex', '')
	          if (this.options.vertical)
	            this.minH.attr('aria-orientation', 'vertical')
	          if (this.options.ariaLabel)
	            this.minH.attr('aria-label', this.options.ariaLabel)
	          else if (this.options.ariaLabelledBy)
	            this.minH.attr('aria-labelledby', this.options.ariaLabelledBy)
	
	          if (this.range) {
	            this.maxH.attr('role', 'slider')
	            if (
	              this.options.keyboardSupport &&
	              !(this.options.readOnly || this.options.disabled)
	            )
	              this.maxH.attr('tabindex', '0')
	            else this.maxH.attr('tabindex', '')
	            if (this.options.vertical)
	              this.maxH.attr('aria-orientation', 'vertical')
	            if (this.options.ariaLabelHigh)
	              this.maxH.attr('aria-label', this.options.ariaLabelHigh)
	            else if (this.options.ariaLabelledByHigh)
	              this.maxH.attr('aria-labelledby', this.options.ariaLabelledByHigh)
	          }
	        },
	
	        /**
	         * Updates aria attributes according to current values
	         */
	        updateAriaAttributes: function() {
	          this.minH.attr({
	            'aria-valuenow': this.scope.rzSliderModel,
	            'aria-valuetext': this.customTrFn(
	              this.scope.rzSliderModel,
	              this.options.id,
	              'model'
	            ),
	            'aria-valuemin': this.minValue,
	            'aria-valuemax': this.maxValue,
	          })
	          if (this.range) {
	            this.maxH.attr({
	              'aria-valuenow': this.scope.rzSliderHigh,
	              'aria-valuetext': this.customTrFn(
	                this.scope.rzSliderHigh,
	                this.options.id,
	                'high'
	              ),
	              'aria-valuemin': this.minValue,
	              'aria-valuemax': this.maxValue,
	            })
	          }
	        },
	
	        /**
	         * Calculate dimensions that are dependent on view port size
	         *
	         * Run once during initialization and every time view port changes size.
	         *
	         * @returns {undefined}
	         */
	        calcViewDimensions: function() {
	          var handleWidth = this.getDimension(this.minH)
	
	          this.handleHalfDim = handleWidth / 2
	          this.barDimension = this.getDimension(this.fullBar)
	
	          this.maxPos = this.barDimension - handleWidth
	
	          this.getDimension(this.sliderElem)
	          this.sliderElem.rzsp = this.sliderElem[0].getBoundingClientRect()[
	            this.positionProperty
	          ]
	
	          if (this.initHasRun) {
	            this.updateFloorLab()
	            this.updateCeilLab()
	            this.initHandles()
	            var self = this
	            $timeout(function() {
	              self.updateTicksScale()
	            })
	          }
	        },
	
	        /**
	         * Update the ticks position
	         *
	         * @returns {undefined}
	         */
	        updateTicksScale: function() {
	          if (!this.options.showTicks) return
	
	          var ticksArray = this.options.ticksArray || this.getTicksArray(),
	            translate = this.options.vertical ? 'translateY' : 'translateX',
	            self = this
	
	          if (this.options.rightToLeft) ticksArray.reverse()
	
	          this.scope.ticks = ticksArray.map(function(value) {
	            var legend = null;
	            if (angular.isObject(value)) {
	              legend = value.legend;
	              value = value.value
	            }
	
	            var position = self.valueToPosition(value)
	
	            if (self.options.vertical) position = self.maxPos - position
	
	            var translation = translate + '(' + Math.round(position) + 'px)'
	            var tick = {
	              legend: legend,
	              selected: self.isTickSelected(value),
	              style: {
	                '-webkit-transform': translation,
	                '-moz-transform': translation,
	                '-o-transform': translation,
	                '-ms-transform': translation,
	                transform: translation,
	              },
	            }
	            if (tick.selected && self.options.getSelectionBarColor) {
	              tick.style['background-color'] = self.getSelectionBarColor()
	            }
	            if (!tick.selected && self.options.getTickColor) {
	              tick.style['background-color'] = self.getTickColor(value)
	            }
	            if (self.options.ticksTooltip) {
	              tick.tooltip = self.options.ticksTooltip(value)
	              tick.tooltipPlacement = self.options.vertical ? 'right' : 'top'
	            }
	            if (
	              self.options.showTicksValues === true ||
	              value % self.options.showTicksValues === 0
	            ) {
	              tick.value = self.getDisplayValue(value, 'tick-value')
	              if (self.options.ticksValuesTooltip) {
	                tick.valueTooltip = self.options.ticksValuesTooltip(value)
	                tick.valueTooltipPlacement = self.options.vertical
	                  ? 'right'
	                  : 'top'
	              }
	            }
	            if (self.getLegend) {
	              legend = self.getLegend(value, self.options.id)
	              if (legend) tick.legend = legend
	            }
	            return tick
	          })
	        },
	
	        getTicksArray: function() {
	          var step = this.step,
	            ticksArray = []
	          if (this.intermediateTicks) step = this.options.showTicks
	          for (
	            var value = this.minValue;
	            value <= this.maxValue;
	            value += step
	          ) {
	            ticksArray.push(value)
	          }
	          return ticksArray
	        },
	
	        isTickSelected: function(value) {
	          if (!this.range) {
	            if (this.options.showSelectionBarFromValue !== null) {
	              var center = this.options.showSelectionBarFromValue
	              if (
	                this.lowValue > center &&
	                value >= center &&
	                value <= this.lowValue
	              )
	                return true
	              else if (
	                this.lowValue < center &&
	                value <= center &&
	                value >= this.lowValue
	              )
	                return true
	            } else if (this.options.showSelectionBarEnd) {
	              if (value >= this.lowValue) return true
	            } else if (this.options.showSelectionBar && value <= this.lowValue)
	              return true
	          }
	          if (this.range && value >= this.lowValue && value <= this.highValue)
	            return true
	          return false
	        },
	
	        /**
	         * Update position of the floor label
	         *
	         * @returns {undefined}
	         */
	        updateFloorLab: function() {
	          this.translateFn(this.minValue, this.flrLab, 'floor')
	          this.getDimension(this.flrLab)
	          var position = this.options.rightToLeft
	            ? this.barDimension - this.flrLab.rzsd
	            : 0
	          this.setPosition(this.flrLab, position)
	        },
	
	        /**
	         * Update position of the ceiling label
	         *
	         * @returns {undefined}
	         */
	        updateCeilLab: function() {
	          this.translateFn(this.maxValue, this.ceilLab, 'ceil')
	          this.getDimension(this.ceilLab)
	          var position = this.options.rightToLeft
	            ? 0
	            : this.barDimension - this.ceilLab.rzsd
	          this.setPosition(this.ceilLab, position)
	        },
	
	        /**
	         * Update slider handles and label positions
	         *
	         * @param {string} which
	         * @param {number} newPos
	         */
	        updateHandles: function(which, newPos) {
	          if (which === 'lowValue') this.updateLowHandle(newPos)
	          else this.updateHighHandle(newPos)
	
	          this.updateSelectionBar()
	          this.updateTicksScale()
	          if (this.range) this.updateCmbLabel()
	        },
	
	        /**
	         * Helper function to work out the position for handle labels depending on RTL or not
	         *
	         * @param {string} labelName maxLab or minLab
	         * @param newPos
	         *
	         * @returns {number}
	         */
	        getHandleLabelPos: function(labelName, newPos) {
	          var labelRzsd = this[labelName].rzsd,
	            nearHandlePos = newPos - labelRzsd / 2 + this.handleHalfDim,
	            endOfBarPos = this.barDimension - labelRzsd
	
	          if (!this.options.boundPointerLabels) return nearHandlePos
	
	          if (
	            (this.options.rightToLeft && labelName === 'minLab') ||
	            (!this.options.rightToLeft && labelName === 'maxLab')
	          ) {
	            return Math.min(nearHandlePos, endOfBarPos)
	          } else {
	            return Math.min(Math.max(nearHandlePos, 0), endOfBarPos)
	          }
	        },
	
	        /**
	         * Update low slider handle position and label
	         *
	         * @param {number} newPos
	         * @returns {undefined}
	         */
	        updateLowHandle: function(newPos) {
	          this.setPosition(this.minH, newPos)
	          this.translateFn(this.lowValue, this.minLab, 'model')
	          this.setPosition(
	            this.minLab,
	            this.getHandleLabelPos('minLab', newPos)
	          )
	
	          if (this.options.getPointerColor) {
	            var pointercolor = this.getPointerColor('min')
	            this.scope.minPointerStyle = {
	              backgroundColor: pointercolor,
	            }
	          }
	
	          if (this.options.autoHideLimitLabels) {
	            this.shFloorCeil()
	          }
	        },
	
	        /**
	         * Update high slider handle position and label
	         *
	         * @param {number} newPos
	         * @returns {undefined}
	         */
	        updateHighHandle: function(newPos) {
	          this.setPosition(this.maxH, newPos)
	          this.translateFn(this.highValue, this.maxLab, 'high')
	          this.setPosition(
	            this.maxLab,
	            this.getHandleLabelPos('maxLab', newPos)
	          )
	
	          if (this.options.getPointerColor) {
	            var pointercolor = this.getPointerColor('max')
	            this.scope.maxPointerStyle = {
	              backgroundColor: pointercolor,
	            }
	          }
	          if (this.options.autoHideLimitLabels) {
	            this.shFloorCeil()
	          }
	        },
	
	        /**
	         * Show/hide floor/ceiling label
	         *
	         * @returns {undefined}
	         */
	        shFloorCeil: function() {
	          // Show based only on hideLimitLabels if pointer labels are hidden
	          if (this.options.hidePointerLabels) {
	            return
	          }
	          var flHidden = false,
	            clHidden = false,
	            isMinLabAtFloor = this.isLabelBelowFloorLab(this.minLab),
	            isMinLabAtCeil = this.isLabelAboveCeilLab(this.minLab),
	            isMaxLabAtCeil = this.isLabelAboveCeilLab(this.maxLab),
	            isCmbLabAtFloor = this.isLabelBelowFloorLab(this.cmbLab),
	            isCmbLabAtCeil = this.isLabelAboveCeilLab(this.cmbLab)
	
	          if (isMinLabAtFloor) {
	            flHidden = true
	            this.hideEl(this.flrLab)
	          } else {
	            flHidden = false
	            this.showEl(this.flrLab)
	          }
	
	          if (isMinLabAtCeil) {
	            clHidden = true
	            this.hideEl(this.ceilLab)
	          } else {
	            clHidden = false
	            this.showEl(this.ceilLab)
	          }
	
	          if (this.range) {
	            var hideCeil = this.cmbLabelShown ? isCmbLabAtCeil : isMaxLabAtCeil
	            var hideFloor = this.cmbLabelShown
	              ? isCmbLabAtFloor
	              : isMinLabAtFloor
	
	            if (hideCeil) {
	              this.hideEl(this.ceilLab)
	            } else if (!clHidden) {
	              this.showEl(this.ceilLab)
	            }
	
	            // Hide or show floor label
	            if (hideFloor) {
	              this.hideEl(this.flrLab)
	            } else if (!flHidden) {
	              this.showEl(this.flrLab)
	            }
	          }
	        },
	
	        isLabelBelowFloorLab: function(label) {
	          var isRTL = this.options.rightToLeft,
	            pos = label.rzsp,
	            dim = label.rzsd,
	            floorPos = this.flrLab.rzsp,
	            floorDim = this.flrLab.rzsd
	          return isRTL
	            ? pos + dim >= floorPos - 2
	            : pos <= floorPos + floorDim + 2
	        },
	
	        isLabelAboveCeilLab: function(label) {
	          var isRTL = this.options.rightToLeft,
	            pos = label.rzsp,
	            dim = label.rzsd,
	            ceilPos = this.ceilLab.rzsp,
	            ceilDim = this.ceilLab.rzsd
	          return isRTL ? pos <= ceilPos + ceilDim + 2 : pos + dim >= ceilPos - 2
	        },
	
	        /**
	         * Update restricted area bar
	         *
	         * @returns {undefined}
	         */
	        updateRestrictionBar: function() {
	          var position = 0,
	            dimension = 0
	          if (this.options.restrictedRange) {
	            var from = this.valueToPosition(this.options.restrictedRange.from),
	              to = this.valueToPosition(this.options.restrictedRange.to)
	            dimension = Math.abs(to - from)
	            position = this.options.rightToLeft
	              ? to + this.handleHalfDim
	              : from + this.handleHalfDim
	            this.setDimension(this.restrictedBar, dimension)
	            this.setPosition(this.restrictedBar, position)
	          }
	        },
	
	        /**
	         * Update slider selection bar, combined label and range label
	         *
	         * @returns {undefined}
	         */
	        updateSelectionBar: function() {
	          var position = 0,
	            dimension = 0,
	            isSelectionBarFromRight = this.options.rightToLeft
	              ? !this.options.showSelectionBarEnd
	              : this.options.showSelectionBarEnd,
	            positionForRange = this.options.rightToLeft
	              ? this.maxH.rzsp + this.handleHalfDim
	              : this.minH.rzsp + this.handleHalfDim
	
	          if (this.range) {
	            dimension = Math.abs(this.maxH.rzsp - this.minH.rzsp)
	            position = positionForRange
	          } else {
	            if (this.options.showSelectionBarFromValue !== null) {
	              var center = this.options.showSelectionBarFromValue,
	                centerPosition = this.valueToPosition(center),
	                isModelGreaterThanCenter = this.options.rightToLeft
	                  ? this.lowValue <= center
	                  : this.lowValue > center
	              if (isModelGreaterThanCenter) {
	                dimension = this.minH.rzsp - centerPosition
	                position = centerPosition + this.handleHalfDim
	              } else {
	                dimension = centerPosition - this.minH.rzsp
	                position = this.minH.rzsp + this.handleHalfDim
	              }
	            } else if (isSelectionBarFromRight) {
	              dimension =
	                Math.abs(this.maxPos - this.minH.rzsp) + this.handleHalfDim
	              position = this.minH.rzsp + this.handleHalfDim
	            } else {
	              dimension = this.minH.rzsp + this.handleHalfDim
	              position = 0
	            }
	          }
	          this.setDimension(this.selBar, dimension)
	          this.setPosition(this.selBar, position)
	          if (this.range && this.options.showOuterSelectionBars) {
	            if (this.options.rightToLeft) {
	              this.setDimension(this.rightOutSelBar, position)
	              this.setPosition(this.rightOutSelBar, 0)
	              this.setDimension(
	                this.leftOutSelBar,
	                this.getDimension(this.fullBar) - (position + dimension)
	              )
	              this.setPosition(this.leftOutSelBar, position + dimension)
	            } else {
	              this.setDimension(this.leftOutSelBar, position)
	              this.setPosition(this.leftOutSelBar, 0)
	              this.setDimension(
	                this.rightOutSelBar,
	                this.getDimension(this.fullBar) - (position + dimension)
	              )
	              this.setPosition(this.rightOutSelBar, position + dimension)
	            }
	          }
	          if (this.options.getSelectionBarColor) {
	            var color = this.getSelectionBarColor()
	            this.scope.barStyle = {
	              backgroundColor: color,
	            }
	          } else if (this.options.selectionBarGradient) {
	            var offset =
	                this.options.showSelectionBarFromValue !== null
	                  ? this.valueToPosition(this.options.showSelectionBarFromValue)
	                  : 0,
	              reversed = (offset - position > 0) ^ isSelectionBarFromRight,
	              direction = this.options.vertical
	                ? reversed
	                  ? 'bottom'
	                  : 'top'
	                : reversed
	                  ? 'left'
	                  : 'right'
	            this.scope.barStyle = {
	              backgroundImage:
	                'linear-gradient(to ' +
	                direction +
	                ', ' +
	                this.options.selectionBarGradient.from +
	                ' 0%,' +
	                this.options.selectionBarGradient.to +
	                ' 100%)',
	            }
	            if (this.options.vertical) {
	              this.scope.barStyle.backgroundPosition =
	                'center ' +
	                (offset +
	                  dimension +
	                  position +
	                  (reversed ? -this.handleHalfDim : 0)) +
	                'px'
	              this.scope.barStyle.backgroundSize =
	                '100% ' + (this.barDimension - this.handleHalfDim) + 'px'
	            } else {
	              this.scope.barStyle.backgroundPosition =
	                offset -
	                position +
	                (reversed ? this.handleHalfDim : 0) +
	                'px center'
	              this.scope.barStyle.backgroundSize =
	                this.barDimension - this.handleHalfDim + 'px 100%'
	            }
	          }
	        },
	
	        /**
	         * Wrapper around the getSelectionBarColor of the user to pass to
	         * correct parameters
	         */
	        getSelectionBarColor: function() {
	          if (this.range)
	            return this.options.getSelectionBarColor(
	              this.scope.rzSliderModel,
	              this.scope.rzSliderHigh
	            )
	          return this.options.getSelectionBarColor(this.scope.rzSliderModel)
	        },
	
	        /**
	         * Wrapper around the getPointerColor of the user to pass to
	         * correct parameters
	         */
	        getPointerColor: function(pointerType) {
	          if (pointerType === 'max') {
	            return this.options.getPointerColor(
	              this.scope.rzSliderHigh,
	              pointerType
	            )
	          }
	          return this.options.getPointerColor(
	            this.scope.rzSliderModel,
	            pointerType
	          )
	        },
	
	        /**
	         * Wrapper around the getTickColor of the user to pass to
	         * correct parameters
	         */
	        getTickColor: function(value) {
	          return this.options.getTickColor(value)
	        },
	
	        /**
	         * Update combined label position and value
	         *
	         * @returns {undefined}
	         */
	        updateCmbLabel: function() {
	          var isLabelOverlap = null
	          if (this.options.rightToLeft) {
	            isLabelOverlap =
	              this.minLab.rzsp - this.minLab.rzsd - 10 <= this.maxLab.rzsp
	          } else {
	            isLabelOverlap =
	              this.minLab.rzsp + this.minLab.rzsd + 10 >= this.maxLab.rzsp
	          }
	
	          if (isLabelOverlap) {
	            var lowTr = this.getDisplayValue(this.lowValue, 'model'),
	              highTr = this.getDisplayValue(this.highValue, 'high'),
	              labelVal = ''
	            if (this.options.mergeRangeLabelsIfSame && lowTr === highTr) {
	              labelVal = lowTr
	            } else {
	              labelVal = this.options.rightToLeft
	                ? highTr + this.options.labelOverlapSeparator + lowTr
	                : lowTr + this.options.labelOverlapSeparator + highTr
	            }
	
	            this.translateFn(labelVal, this.cmbLab, 'cmb', false)
	            var pos = this.options.boundPointerLabels
	              ? Math.min(
	                  Math.max(
	                    this.selBar.rzsp +
	                      this.selBar.rzsd / 2 -
	                      this.cmbLab.rzsd / 2,
	                    0
	                  ),
	                  this.barDimension - this.cmbLab.rzsd
	                )
	              : this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2
	
	            this.setPosition(this.cmbLab, pos)
	            this.cmbLabelShown = true
	            this.hideEl(this.minLab)
	            this.hideEl(this.maxLab)
	            this.showEl(this.cmbLab)
	          } else {
	            this.cmbLabelShown = false
	            this.updateHighHandle(this.valueToPosition(this.highValue))
	            this.updateLowHandle(this.valueToPosition(this.lowValue))
	            this.showEl(this.maxLab)
	            this.showEl(this.minLab)
	            this.hideEl(this.cmbLab)
	          }
	          if (this.options.autoHideLimitLabels) {
	            this.shFloorCeil()
	          }
	        },
	
	        /**
	         * Return the translated value if a translate function is provided else the original value
	         * @param value
	         * @param which if it's min or max handle
	         * @returns {*}
	         */
	        getDisplayValue: function(value, which) {
	          if (this.options.stepsArray && !this.options.bindIndexForStepsArray) {
	            value = this.getStepValue(value)
	          }
	          return this.customTrFn(value, this.options.id, which)
	        },
	
	        /**
	         * Round value to step and precision based on minValue
	         *
	         * @param {number} value
	         * @param {number} customStep a custom step to override the defined step
	         * @returns {number}
	         */
	        roundStep: function(value, customStep) {
	          var step = customStep ? customStep : this.step,
	            steppedDifference = parseFloat(
	              (value - this.minValue) / step
	            ).toPrecision(12)
	          steppedDifference = Math.round(+steppedDifference) * step
	          var newValue = (this.minValue + steppedDifference).toFixed(
	            this.precision
	          )
	          return +newValue
	        },
	
	        /**
	         * Hide element
	         *
	         * @param element
	         * @returns {jqLite} The jqLite wrapped DOM element
	         */
	        hideEl: function(element) {
	          return element.css({
	            visibility: 'hidden',
	          })
	        },
	
	        /**
	         * Show element
	         *
	         * @param element The jqLite wrapped DOM element
	         * @returns {jqLite} The jqLite
	         */
	        showEl: function(element) {
	          if (!!element.rzAlwaysHide) {
	            return element
	          }
	
	          return element.css({
	            visibility: 'visible',
	          })
	        },
	
	        /**
	         * Set element left/top position depending on whether slider is horizontal or vertical
	         *
	         * @param {jqLite} elem The jqLite wrapped DOM element
	         * @param {number} pos
	         * @returns {number}
	         */
	        setPosition: function(elem, pos) {
	          elem.rzsp = pos
	          var css = {}
	          css[this.positionProperty] = Math.round(pos) + 'px'
	          elem.css(css)
	          return pos
	        },
	
	        /**
	         * Get element width/height depending on whether slider is horizontal or vertical
	         *
	         * @param {jqLite} elem The jqLite wrapped DOM element
	         * @returns {number}
	         */
	        getDimension: function(elem) {
	          var val = elem[0].getBoundingClientRect()
	          if (this.options.vertical)
	            elem.rzsd = (val.bottom - val.top) * this.options.scale
	          else elem.rzsd = (val.right - val.left) * this.options.scale
	          return elem.rzsd
	        },
	
	        /**
	         * Set element width/height depending on whether slider is horizontal or vertical
	         *
	         * @param {jqLite} elem  The jqLite wrapped DOM element
	         * @param {number} dim
	         * @returns {number}
	         */
	        setDimension: function(elem, dim) {
	          elem.rzsd = dim
	          var css = {}
	          css[this.dimensionProperty] = Math.round(dim) + 'px'
	          elem.css(css)
	          return dim
	        },
	
	        /**
	         * Returns a value that is within slider range
	         *
	         * @param {number} val
	         * @returns {number}
	         */
	        sanitizeValue: function(val) {
	          return Math.min(Math.max(val, this.minValue), this.maxValue)
	        },
	
	        /**
	         * Translate value to pixel position
	         *
	         * @param {number} val
	         * @returns {number}
	         */
	        valueToPosition: function(val) {
	          var fn = this.linearValueToPosition
	          if (this.options.customValueToPosition)
	            fn = this.options.customValueToPosition
	          else if (this.options.logScale) fn = this.logValueToPosition
	
	          val = this.sanitizeValue(val)
	          var percent = fn(val, this.minValue, this.maxValue) || 0
	          if (this.options.rightToLeft) percent = 1 - percent
	          return percent * this.maxPos
	        },
	
	        linearValueToPosition: function(val, minVal, maxVal) {
	          var range = maxVal - minVal
	          return (val - minVal) / range
	        },
	
	        logValueToPosition: function(val, minVal, maxVal) {
	          val = Math.log(val)
	          minVal = Math.log(minVal)
	          maxVal = Math.log(maxVal)
	          var range = maxVal - minVal
	          return (val - minVal) / range
	        },
	
	        /**
	         * Translate position to model value
	         *
	         * @param {number} position
	         * @returns {number}
	         */
	        positionToValue: function(position) {
	          var percent = position / this.maxPos
	          if (this.options.rightToLeft) percent = 1 - percent
	          var fn = this.linearPositionToValue
	          if (this.options.customPositionToValue)
	            fn = this.options.customPositionToValue
	          else if (this.options.logScale) fn = this.logPositionToValue
	          return fn(percent, this.minValue, this.maxValue) || 0
	        },
	
	        linearPositionToValue: function(percent, minVal, maxVal) {
	          return percent * (maxVal - minVal) + minVal
	        },
	
	        logPositionToValue: function(percent, minVal, maxVal) {
	          minVal = Math.log(minVal)
	          maxVal = Math.log(maxVal)
	          var value = percent * (maxVal - minVal) + minVal
	          return Math.exp(value)
	        },
	
	        getEventAttr: function(event, attr) {
	          return event.originalEvent === undefined
	            ? event[attr]
	            : event.originalEvent[attr]
	        },
	
	        // Events
	        /**
	         * Get the X-coordinate or Y-coordinate of an event
	         *
	         * @param {Object} event  The event
	         * @param targetTouchId The identifier of the touch with the X/Y coordinates
	         * @returns {number}
	         */
	        getEventXY: function(event, targetTouchId) {
	          /* http://stackoverflow.com/a/12336075/282882 */
	          //noinspection JSLint
	          var clientXY = this.options.vertical ? 'clientY' : 'clientX'
	          if (event[clientXY] !== undefined) {
	            return event[clientXY]
	          }
	
	          var touches = this.getEventAttr(event, 'touches')
	
	          if (targetTouchId !== undefined) {
	            for (var i = 0; i < touches.length; i++) {
	              if (touches[i].identifier === targetTouchId) {
	                return touches[i][clientXY]
	              }
	            }
	          }
	
	          // If no target touch or the target touch was not found in the event
	          // returns the coordinates of the first touch
	          return touches[0][clientXY]
	        },
	
	        /**
	         * Compute the event position depending on whether the slider is horizontal or vertical
	         * @param event
	         * @param targetTouchId If targetTouchId is provided it will be considered the position of that
	         * @returns {number}
	         */
	        getEventPosition: function(event, targetTouchId) {
	          var sliderPos = this.sliderElem.rzsp,
	            eventPos = 0
	          if (this.options.vertical)
	            eventPos = -this.getEventXY(event, targetTouchId) + sliderPos
	          else eventPos = this.getEventXY(event, targetTouchId) - sliderPos
	          return eventPos * this.options.scale - this.handleHalfDim // #346 handleHalfDim is already scaled
	        },
	
	        /**
	         * Get event names for move and event end
	         *
	         * @param {Event}    event    The event
	         *
	         * @return {{moveEvent: string, endEvent: string}}
	         */
	        getEventNames: function(event) {
	          var eventNames = {
	            moveEvent: '',
	            endEvent: '',
	          }
	
	          if (this.getEventAttr(event, 'touches')) {
	            eventNames.moveEvent = 'touchmove'
	            eventNames.endEvent = 'touchend'
	          } else {
	            eventNames.moveEvent = 'mousemove'
	            eventNames.endEvent = 'mouseup'
	          }
	
	          return eventNames
	        },
	
	        /**
	         * Get the handle closest to an event.
	         *
	         * @param event {Event} The event
	         * @returns {jqLite} The handle closest to the event.
	         */
	        getNearestHandle: function(event) {
	          if (!this.range) {
	            return this.minH
	          }
	          var position = this.getEventPosition(event),
	            distanceMin = Math.abs(position - this.minH.rzsp),
	            distanceMax = Math.abs(position - this.maxH.rzsp)
	          if (distanceMin < distanceMax) return this.minH
	          else if (distanceMin > distanceMax) return this.maxH
	          else if (!this.options.rightToLeft)
	            //if event is at the same distance from min/max then if it's at left of minH, we return minH else maxH
	            return position < this.minH.rzsp ? this.minH : this.maxH
	          //reverse in rtl
	          else return position > this.minH.rzsp ? this.minH : this.maxH
	        },
	
	        /**
	         * Wrapper function to focus an angular element
	         *
	         * @param el {AngularElement} the element to focus
	         */
	        focusElement: function(el) {
	          var DOM_ELEMENT = 0
	          el[DOM_ELEMENT].focus()
	        },
	
	        /**
	         * Bind mouse and touch events to slider handles
	         *
	         * @returns {undefined}
	         */
	        bindEvents: function() {
	          var barTracking, barStart, barMove
	
	          if (this.options.draggableRange) {
	            barTracking = 'rzSliderDrag'
	            barStart = this.onDragStart
	            barMove = this.onDragMove
	          } else {
	            barTracking = 'lowValue'
	            barStart = this.onStart
	            barMove = this.onMove
	          }
	
	          if (!this.options.onlyBindHandles) {
	            this.selBar.on(
	              'mousedown',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.selBar.on(
	              'mousedown',
	              angular.bind(this, barMove, this.selBar)
	            )
	          }
	
	          if (this.options.draggableRangeOnly) {
	            this.minH.on(
	              'mousedown',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.maxH.on(
	              'mousedown',
	              angular.bind(this, barStart, null, barTracking)
	            )
	          } else {
	            this.minH.on(
	              'mousedown',
	              angular.bind(this, this.onStart, this.minH, 'lowValue')
	            )
	            if (this.range) {
	              this.maxH.on(
	                'mousedown',
	                angular.bind(this, this.onStart, this.maxH, 'highValue')
	              )
	            }
	            if (!this.options.onlyBindHandles) {
	              this.fullBar.on(
	                'mousedown',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.fullBar.on(
	                'mousedown',
	                angular.bind(this, this.onMove, this.fullBar)
	              )
	              this.ticks.on(
	                'mousedown',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.ticks.on(
	                'mousedown',
	                angular.bind(this, this.onTickClick, this.ticks)
	              )
	            }
	          }
	
	          if (!this.options.onlyBindHandles) {
	            this.selBar.on(
	              'touchstart',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.selBar.on(
	              'touchstart',
	              angular.bind(this, barMove, this.selBar)
	            )
	          }
	          if (this.options.draggableRangeOnly) {
	            this.minH.on(
	              'touchstart',
	              angular.bind(this, barStart, null, barTracking)
	            )
	            this.maxH.on(
	              'touchstart',
	              angular.bind(this, barStart, null, barTracking)
	            )
	          } else {
	            this.minH.on(
	              'touchstart',
	              angular.bind(this, this.onStart, this.minH, 'lowValue')
	            )
	            if (this.range) {
	              this.maxH.on(
	                'touchstart',
	                angular.bind(this, this.onStart, this.maxH, 'highValue')
	              )
	            }
	            if (!this.options.onlyBindHandles) {
	              this.fullBar.on(
	                'touchstart',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.fullBar.on(
	                'touchstart',
	                angular.bind(this, this.onMove, this.fullBar)
	              )
	              this.ticks.on(
	                'touchstart',
	                angular.bind(this, this.onStart, null, null)
	              )
	              this.ticks.on(
	                'touchstart',
	                angular.bind(this, this.onTickClick, this.ticks)
	              )
	            }
	          }
	
	          if (this.options.keyboardSupport) {
	            this.minH.on(
	              'focus',
	              angular.bind(this, this.onPointerFocus, this.minH, 'lowValue')
	            )
	            if (this.range) {
	              this.maxH.on(
	                'focus',
	                angular.bind(this, this.onPointerFocus, this.maxH, 'highValue')
	              )
	            }
	          }
	        },
	
	        /**
	         * Unbind mouse and touch events to slider handles
	         *
	         * @returns {undefined}
	         */
	        unbindEvents: function() {
	          this.minH.off()
	          this.maxH.off()
	          this.fullBar.off()
	          this.selBar.off()
	          this.ticks.off()
	        },
	
	        /**
	         * onStart event handler
	         *
	         * @param {?Object} pointer The jqLite wrapped DOM element; if null, the closest handle is used
	         * @param {?string} ref     The name of the handle being changed; if null, the closest handle's value is modified
	         * @param {Event}   event   The event
	         * @returns {undefined}
	         */
	        onStart: function(pointer, ref, event) {
	          var ehMove,
	            ehEnd,
	            eventNames = this.getEventNames(event)
	
	          event.stopPropagation()
	          event.preventDefault()
	
	          // We have to do this in case the HTML where the sliders are on
	          // have been animated into view.
	          this.calcViewDimensions()
	
	          if (pointer) {
	            this.tracking = ref
	          } else {
	            pointer = this.getNearestHandle(event)
	            this.tracking = pointer === this.minH ? 'lowValue' : 'highValue'
	          }
	
	          pointer.addClass('rz-active')
	
	          if (this.options.keyboardSupport) this.focusElement(pointer)
	
	          ehMove = angular.bind(
	            this,
	            this.dragging.active ? this.onDragMove : this.onMove,
	            pointer
	          )
	          ehEnd = angular.bind(this, this.onEnd, ehMove)
	
	          $document.on(eventNames.moveEvent, ehMove)
	          $document.on(eventNames.endEvent, ehEnd)
	          this.endHandlerToBeRemovedOnEnd = ehEnd
	
	          this.callOnStart()
	
	          var changedTouches = this.getEventAttr(event, 'changedTouches')
	          if (changedTouches) {
	            // Store the touch identifier
	            if (!this.touchId) {
	              this.isDragging = true
	              this.touchId = changedTouches[0].identifier
	            }
	          }
	        },
	
	        /**
	         * onMove event handler
	         *
	         * @param {jqLite} pointer
	         * @param {Event}  event The event
	         * @param {boolean}  fromTick if the event occured on a tick or not
	         * @returns {undefined}
	         */
	        onMove: function(pointer, event, fromTick) {
	          var changedTouches = this.getEventAttr(event, 'changedTouches')
	          var touchForThisSlider
	          if (changedTouches) {
	            for (var i = 0; i < changedTouches.length; i++) {
	              if (changedTouches[i].identifier === this.touchId) {
	                touchForThisSlider = changedTouches[i]
	                break
	              }
	            }
	          }
	
	          if (changedTouches && !touchForThisSlider) {
	            return
	          }
	
	          var newPos = this.getEventPosition(
	              event,
	              touchForThisSlider ? touchForThisSlider.identifier : undefined
	            ),
	            newValue,
	            ceilValue = this.options.rightToLeft
	              ? this.minValue
	              : this.maxValue,
	            flrValue = this.options.rightToLeft ? this.maxValue : this.minValue
	
	          if (newPos <= 0) {
	            newValue = flrValue
	          } else if (newPos >= this.maxPos) {
	            newValue = ceilValue
	          } else {
	            newValue = this.positionToValue(newPos)
	            if (fromTick && angular.isNumber(this.options.showTicks))
	              newValue = this.roundStep(newValue, this.options.showTicks)
	            else newValue = this.roundStep(newValue)
	          }
	          this.positionTrackingHandle(newValue)
	        },
	
	        /**
	         * onEnd event handler
	         *
	         * @param {Event}    event    The event
	         * @param {Function} ehMove   The bound move event handler
	         * @returns {undefined}
	         */
	        onEnd: function(ehMove, event) {
	          var changedTouches = this.getEventAttr(event, 'changedTouches')
	          if (changedTouches && changedTouches[0].identifier !== this.touchId) {
	            return
	          }
	          this.isDragging = false
	          this.touchId = null
	
	          if (!this.options.keyboardSupport) {
	            this.minH.removeClass('rz-active')
	            this.maxH.removeClass('rz-active')
	            this.tracking = ''
	          }
	          this.dragging.active = false
	
	          var eventName = this.getEventNames(event)
	          $document.off(eventName.moveEvent, ehMove)
	          $document.off(eventName.endEvent, this.endHandlerToBeRemovedOnEnd)
	          this.endHandlerToBeRemovedOnEnd = null
	          this.callOnEnd()
	        },
	
	        onTickClick: function(pointer, event) {
	          this.onMove(pointer, event, true)
	        },
	
	        onPointerFocus: function(pointer, ref) {
	          this.tracking = ref
	          pointer.one('blur', angular.bind(this, this.onPointerBlur, pointer))
	          pointer.on('keydown', angular.bind(this, this.onKeyboardEvent))
	          pointer.on('keyup', angular.bind(this, this.onKeyUp))
	          this.firstKeyDown = true
	          pointer.addClass('rz-active')
	
	          this.currentFocusElement = {
	            pointer: pointer,
	            ref: ref,
	          }
	        },
	
	        onKeyUp: function() {
	          this.firstKeyDown = true
	          this.callOnEnd()
	        },
	
	        onPointerBlur: function(pointer) {
	          pointer.off('keydown')
	          pointer.off('keyup')
	          pointer.removeClass('rz-active')
	          if (!this.isDragging) {
	            this.tracking = ''
	            this.currentFocusElement = null
	          }
	        },
	
	        /**
	         * Key actions helper function
	         *
	         * @param {number} currentValue value of the slider
	         *
	         * @returns {?Object} action value mappings
	         */
	        getKeyActions: function(currentValue) {
	          var increaseStep = currentValue + this.step,
	            decreaseStep = currentValue - this.step,
	            increasePage = currentValue + this.valueRange / 10,
	            decreasePage = currentValue - this.valueRange / 10
	
	          if (this.options.reversedControls) {
	            increaseStep = currentValue - this.step
	            decreaseStep = currentValue + this.step
	            increasePage = currentValue - this.valueRange / 10
	            decreasePage = currentValue + this.valueRange / 10
	          }
	
	          //Left to right default actions
	          var actions = {
	            UP: increaseStep,
	            DOWN: decreaseStep,
	            LEFT: decreaseStep,
	            RIGHT: increaseStep,
	            PAGEUP: increasePage,
	            PAGEDOWN: decreasePage,
	            HOME: this.options.reversedControls ? this.maxValue : this.minValue,
	            END: this.options.reversedControls ? this.minValue : this.maxValue,
	          }
	          //right to left means swapping right and left arrows
	          if (this.options.rightToLeft) {
	            actions.LEFT = increaseStep
	            actions.RIGHT = decreaseStep
	            // right to left and vertical means we also swap up and down
	            if (this.options.vertical) {
	              actions.UP = decreaseStep
	              actions.DOWN = increaseStep
	            }
	          }
	          return actions
	        },
	
	        onKeyboardEvent: function(event) {
	          var currentValue = this[this.tracking],
	            keyCode = event.keyCode || event.which,
	            keys = {
	              38: 'UP',
	              40: 'DOWN',
	              37: 'LEFT',
	              39: 'RIGHT',
	              33: 'PAGEUP',
	              34: 'PAGEDOWN',
	              36: 'HOME',
	              35: 'END',
	            },
	            actions = this.getKeyActions(currentValue),
	            key = keys[keyCode],
	            action = actions[key]
	          if (action == null || this.tracking === '') return
	          event.preventDefault()
	
	          if (this.firstKeyDown) {
	            this.firstKeyDown = false
	            this.callOnStart()
	          }
	
	          var self = this
	          $timeout(function() {
	            var newValue = self.roundStep(self.sanitizeValue(action))
	            if (!self.options.draggableRangeOnly) {
	              self.positionTrackingHandle(newValue)
	            } else {
	              var difference = self.highValue - self.lowValue,
	                newMinValue,
	                newMaxValue
	              if (self.tracking === 'lowValue') {
	                newMinValue = newValue
	                newMaxValue = newValue + difference
	                if (newMaxValue > self.maxValue) {
	                  newMaxValue = self.maxValue
	                  newMinValue = newMaxValue - difference
	                }
	              } else {
	                newMaxValue = newValue
	                newMinValue = newValue - difference
	                if (newMinValue < self.minValue) {
	                  newMinValue = self.minValue
	                  newMaxValue = newMinValue + difference
	                }
	              }
	              self.positionTrackingBar(newMinValue, newMaxValue)
	            }
	          })
	        },
	
	        /**
	         * onDragStart event handler
	         *
	         * Handles dragging of the middle bar.
	         *
	         * @param {Object} pointer The jqLite wrapped DOM element
	         * @param {string} ref     One of the refLow, refHigh values
	         * @param {Event}  event   The event
	         * @returns {undefined}
	         */
	        onDragStart: function(pointer, ref, event) {
	          var position = this.getEventPosition(event)
	          this.dragging = {
	            active: true,
	            value: this.positionToValue(position),
	            difference: this.highValue - this.lowValue,
	            lowLimit: this.options.rightToLeft
	              ? this.minH.rzsp - position
	              : position - this.minH.rzsp,
	            highLimit: this.options.rightToLeft
	              ? position - this.maxH.rzsp
	              : this.maxH.rzsp - position,
	          }
	
	          this.onStart(pointer, ref, event)
	        },
	
	        /**
	         * getValue helper function
	         *
	         * gets max or min value depending on whether the newPos is outOfBounds above or below the bar and rightToLeft
	         *
	         * @param {string} type 'max' || 'min' The value we are calculating
	         * @param {number} newPos  The new position
	         * @param {boolean} outOfBounds Is the new position above or below the max/min?
	         * @param {boolean} isAbove Is the new position above the bar if out of bounds?
	         *
	         * @returns {number}
	         */
	        getValue: function(type, newPos, outOfBounds, isAbove) {
	          var isRTL = this.options.rightToLeft,
	            value = null
	
	          if (type === 'min') {
	            if (outOfBounds) {
	              if (isAbove) {
	                value = isRTL
	                  ? this.minValue
	                  : this.maxValue - this.dragging.difference
	              } else {
	                value = isRTL
	                  ? this.maxValue - this.dragging.difference
	                  : this.minValue
	              }
	            } else {
	              value = isRTL
	                ? this.positionToValue(newPos + this.dragging.lowLimit)
	                : this.positionToValue(newPos - this.dragging.lowLimit)
	            }
	          } else {
	            if (outOfBounds) {
	              if (isAbove) {
	                value = isRTL
	                  ? this.minValue + this.dragging.difference
	                  : this.maxValue
	              } else {
	                value = isRTL
	                  ? this.maxValue
	                  : this.minValue + this.dragging.difference
	              }
	            } else {
	              if (isRTL) {
	                value =
	                  this.positionToValue(newPos + this.dragging.lowLimit) +
	                  this.dragging.difference
	              } else {
	                value =
	                  this.positionToValue(newPos - this.dragging.lowLimit) +
	                  this.dragging.difference
	              }
	            }
	          }
	          return this.roundStep(value)
	        },
	
	        /**
	         * onDragMove event handler
	         *
	         * Handles dragging of the middle bar.
	         *
	         * @param {jqLite} pointer
	         * @param {Event}  event The event
	         * @returns {undefined}
	         */
	        onDragMove: function(pointer, event) {
	          var newPos = this.getEventPosition(event),
	            newMinValue,
	            newMaxValue,
	            ceilLimit,
	            flrLimit,
	            isUnderFlrLimit,
	            isOverCeilLimit,
	            flrH,
	            ceilH
	
	          if (this.options.rightToLeft) {
	            ceilLimit = this.dragging.lowLimit
	            flrLimit = this.dragging.highLimit
	            flrH = this.maxH
	            ceilH = this.minH
	          } else {
	            ceilLimit = this.dragging.highLimit
	            flrLimit = this.dragging.lowLimit
	            flrH = this.minH
	            ceilH = this.maxH
	          }
	          isUnderFlrLimit = newPos <= flrLimit
	          isOverCeilLimit = newPos >= this.maxPos - ceilLimit
	
	          if (isUnderFlrLimit) {
	            if (flrH.rzsp === 0) return
	            newMinValue = this.getValue('min', newPos, true, false)
	            newMaxValue = this.getValue('max', newPos, true, false)
	          } else if (isOverCeilLimit) {
	            if (ceilH.rzsp === this.maxPos) return
	            newMaxValue = this.getValue('max', newPos, true, true)
	            newMinValue = this.getValue('min', newPos, true, true)
	          } else {
	            newMinValue = this.getValue('min', newPos, false)
	            newMaxValue = this.getValue('max', newPos, false)
	          }
	          this.positionTrackingBar(newMinValue, newMaxValue)
	        },
	
	        /**
	         * Set the new value and position for the entire bar
	         *
	         * @param {number} newMinValue   the new minimum value
	         * @param {number} newMaxValue   the new maximum value
	         */
	        positionTrackingBar: function(newMinValue, newMaxValue) {
	          if (
	            this.options.minLimit != null &&
	            newMinValue < this.options.minLimit
	          ) {
	            newMinValue = this.options.minLimit
	            newMaxValue = newMinValue + this.dragging.difference
	          }
	          if (
	            this.options.maxLimit != null &&
	            newMaxValue > this.options.maxLimit
	          ) {
	            newMaxValue = this.options.maxLimit
	            newMinValue = newMaxValue - this.dragging.difference
	          }
	
	          this.lowValue = newMinValue
	          this.highValue = newMaxValue
	          this.applyLowValue()
	          if (this.range) this.applyHighValue()
	          this.applyModel(true)
	          this.updateHandles('lowValue', this.valueToPosition(newMinValue))
	          this.updateHandles('highValue', this.valueToPosition(newMaxValue))
	        },
	
	        /**
	         * Set the new value and position to the current tracking handle
	         *
	         * @param {number} newValue new model value
	         */
	        positionTrackingHandle: function(newValue) {
	          var valueChanged = false
	          newValue = this.applyMinMaxLimit(newValue)
	          newValue = this.applyRestrictedRange(newValue)
	          if (this.range) {
	            if (this.options.pushRange) {
	              newValue = this.applyPushRange(newValue)
	              valueChanged = true
	            } else {
	              if (this.options.noSwitching) {
	                if (this.tracking === 'lowValue' && newValue > this.highValue)
	                  newValue = this.applyMinMaxRange(this.highValue)
	                else if (
	                  this.tracking === 'highValue' &&
	                  newValue < this.lowValue
	                )
	                  newValue = this.applyMinMaxRange(this.lowValue)
	              }
	              newValue = this.applyMinMaxRange(newValue)
	              /* This is to check if we need to switch the min and max handles */
	              if (this.tracking === 'lowValue' && newValue > this.highValue) {
	                this.lowValue = this.highValue
	                this.applyLowValue()
	                this.applyModel()
	                this.updateHandles(this.tracking, this.maxH.rzsp)
	                this.updateAriaAttributes()
	                this.tracking = 'highValue'
	                this.minH.removeClass('rz-active')
	                this.maxH.addClass('rz-active')
	                if (this.options.keyboardSupport) this.focusElement(this.maxH)
	                valueChanged = true
	              } else if (
	                this.tracking === 'highValue' &&
	                newValue < this.lowValue
	              ) {
	                this.highValue = this.lowValue
	                this.applyHighValue()
	                this.applyModel()
	                this.updateHandles(this.tracking, this.minH.rzsp)
	                this.updateAriaAttributes()
	                this.tracking = 'lowValue'
	                this.maxH.removeClass('rz-active')
	                this.minH.addClass('rz-active')
	                if (this.options.keyboardSupport) this.focusElement(this.minH)
	                valueChanged = true
	              }
	            }
	          }
	
	          if (this[this.tracking] !== newValue) {
	            this[this.tracking] = newValue
	            if (this.tracking === 'lowValue') this.applyLowValue()
	            else this.applyHighValue()
	            this.applyModel()
	            this.updateHandles(this.tracking, this.valueToPosition(newValue))
	            this.updateAriaAttributes()
	            valueChanged = true
	          }
	
	          if (valueChanged) this.applyModel(true)
	        },
	
	        applyMinMaxLimit: function(newValue) {
	          if (this.options.minLimit != null && newValue < this.options.minLimit)
	            return this.options.minLimit
	          if (this.options.maxLimit != null && newValue > this.options.maxLimit)
	            return this.options.maxLimit
	          return newValue
	        },
	
	        applyMinMaxRange: function(newValue) {
	          var oppositeValue =
	              this.tracking === 'lowValue' ? this.highValue : this.lowValue,
	            difference = Math.abs(newValue - oppositeValue)
	          if (this.options.minRange != null) {
	            if (difference < this.options.minRange) {
	              if (this.tracking === 'lowValue')
	                return this.highValue - this.options.minRange
	              else return this.lowValue + this.options.minRange
	            }
	          }
	          if (this.options.maxRange != null) {
	            if (difference > this.options.maxRange) {
	              if (this.tracking === 'lowValue')
	                return this.highValue - this.options.maxRange
	              else return this.lowValue + this.options.maxRange
	            }
	          }
	          return newValue
	        },
	
	        applyRestrictedRange: function(newValue) {
	          if (
	            this.options.restrictedRange != null &&
	            newValue > this.options.restrictedRange.from &&
	            newValue < this.options.restrictedRange.to
	          ) {
	            var halfWidth =
	              (this.options.restrictedRange.to -
	                this.options.restrictedRange.from) /
	              2
	            if (this.tracking === 'lowValue') {
	              return newValue > this.options.restrictedRange.from + halfWidth
	                ? this.options.restrictedRange.to
	                : this.options.restrictedRange.from
	            }
	            if (this.tracking === 'highValue') {
	              return newValue < this.options.restrictedRange.to - halfWidth
	                ? this.options.restrictedRange.from
	                : this.options.restrictedRange.to
	            }
	          }
	          return newValue
	        },
	
	        applyPushRange: function(newValue) {
	          var difference =
	              this.tracking === 'lowValue'
	                ? this.highValue - newValue
	                : newValue - this.lowValue,
	            minRange =
	              this.options.minRange !== null
	                ? this.options.minRange
	                : this.options.step,
	            maxRange = this.options.maxRange
	          // if smaller than minRange
	          if (difference < minRange) {
	            if (this.tracking === 'lowValue') {
	              this.highValue = Math.min(newValue + minRange, this.maxValue)
	              newValue = this.highValue - minRange
	              this.applyHighValue()
	              this.updateHandles(
	                'highValue',
	                this.valueToPosition(this.highValue)
	              )
	            } else {
	              this.lowValue = Math.max(newValue - minRange, this.minValue)
	              newValue = this.lowValue + minRange
	              this.applyLowValue()
	              this.updateHandles(
	                'lowValue',
	                this.valueToPosition(this.lowValue)
	              )
	            }
	            this.updateAriaAttributes()
	          } else if (maxRange !== null && difference > maxRange) {
	            // if greater than maxRange
	            if (this.tracking === 'lowValue') {
	              this.highValue = newValue + maxRange
	              this.applyHighValue()
	              this.updateHandles(
	                'highValue',
	                this.valueToPosition(this.highValue)
	              )
	            } else {
	              this.lowValue = newValue - maxRange
	              this.applyLowValue()
	              this.updateHandles(
	                'lowValue',
	                this.valueToPosition(this.lowValue)
	              )
	            }
	            this.updateAriaAttributes()
	          }
	          return newValue
	        },
	
	        /**
	         * Apply the model values using scope.$apply.
	         * We wrap it with the internalChange flag to avoid the watchers to be called
	         */
	        applyModel: function(callOnChange) {
	          this.internalChange = true
	          this.scope.$apply()
	          callOnChange && this.callOnChange()
	          this.internalChange = false
	        },
	
	        /**
	         * Call the onStart callback if defined
	         * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
	         *
	         * @returns {undefined}
	         */
	        callOnStart: function() {
	          if (this.options.onStart) {
	            var self = this,
	              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
	            this.scope.$evalAsync(function() {
	              self.options.onStart(
	                self.options.id,
	                self.scope.rzSliderModel,
	                self.scope.rzSliderHigh,
	                pointerType
	              )
	            })
	          }
	        },
	
	        /**
	         * Call the onChange callback if defined
	         * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
	         *
	         * @returns {undefined}
	         */
	        callOnChange: function() {
	          if (this.options.onChange) {
	            var self = this,
	              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
	            this.scope.$evalAsync(function() {
	              self.options.onChange(
	                self.options.id,
	                self.scope.rzSliderModel,
	                self.scope.rzSliderHigh,
	                pointerType
	              )
	            })
	          }
	        },
	
	        /**
	         * Call the onEnd callback if defined
	         * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
	         *
	         * @returns {undefined}
	         */
	        callOnEnd: function() {
	          if (this.options.onEnd) {
	            var self = this,
	              pointerType = this.tracking === 'lowValue' ? 'min' : 'max'
	            this.scope.$evalAsync(function() {
	              self.options.onEnd(
	                self.options.id,
	                self.scope.rzSliderModel,
	                self.scope.rzSliderHigh,
	                pointerType
	              )
	            })
	          }
	          this.scope.$emit('slideEnded')
	        },
	      }
	
	      return Slider
	    }])
	    .directive('rzslider', ['RzSlider', function(RzSlider) {
	      'use strict'
	
	      return {
	        restrict: 'AE',
	        replace: true,
	        scope: {
	          rzSliderModel: '=?',
	          rzSliderHigh: '=?',
	          rzSliderOptions: '&?',
	          rzSliderTplUrl: '@',
	        },
	
	        /**
	         * Return template URL
	         *
	         * @param {jqLite} elem
	         * @param {Object} attrs
	         * @return {string}
	         */
	        templateUrl: function(elem, attrs) {
	          //noinspection JSUnresolvedVariable
	          return attrs.rzSliderTplUrl || 'rzSliderTpl.html'
	        },
	
	        link: function(scope, elem) {
	          scope.slider = new RzSlider(scope, elem) //attach on scope so we can test it
	        },
	      }
	    }])
	
	  // IDE assist
	
	  /**
	   * @name ngScope
	   *
	   * @property {number} rzSliderModel
	   * @property {number} rzSliderHigh
	   * @property {Object} rzSliderOptions
	   */
	
	  /**
	   * @name jqLite
	   *
	   * @property {number|undefined} rzsp rzslider label position position
	   * @property {number|undefined} rzsd rzslider element dimension
	   * @property {string|undefined} rzsv rzslider label value/text
	   * @property {Function} css
	   * @property {Function} text
	   */
	
	  /**
	   * @name Event
	   * @property {Array} touches
	   * @property {Event} originalEvent
	   */
	
	  /**
	   * @name ThrottleOptions
	   *
	   * @property {boolean} leading
	   * @property {boolean} trailing
	   */
	
	  module.run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('rzSliderTpl.html',
	    "<div class=rzslider><span class=\"rz-bar-wrapper rz-left-out-selection\"><span class=rz-bar></span></span> <span class=\"rz-bar-wrapper rz-right-out-selection\"><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-selection\" ng-style=barStyle></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-restricted\" ng-style=restrictionStyle></span></span> <span class=\"rz-pointer rz-pointer-min\" ng-style=minPointerStyle></span> <span class=\"rz-pointer rz-pointer-max\" ng-style=maxPointerStyle></span> <span class=\"rz-bubble rz-limit rz-floor\"></span> <span class=\"rz-bubble rz-limit rz-ceil\"></span> <span class=\"rz-bubble rz-model-value\"></span> <span class=\"rz-bubble rz-model-high\"></span> <span class=rz-bubble></span><ul ng-show=showTicks class=rz-ticks><li ng-repeat=\"t in ticks track by $index\" class=rz-tick ng-class=\"{'rz-selected': t.selected}\" ng-style=t.style ng-attr-uib-tooltip=\"{{ t.tooltip }}\" ng-attr-tooltip-placement={{t.tooltipPlacement}} ng-attr-tooltip-append-to-body=\"{{ t.tooltip ? true : undefined}}\"><span ng-if=\"t.value != null\" class=rz-tick-value ng-attr-uib-tooltip=\"{{ t.valueTooltip }}\" ng-attr-tooltip-placement={{t.valueTooltipPlacement}}>{{ t.value }}</span> <span ng-if=\"t.legend != null\" class=rz-tick-legend>{{ t.legend }}</span></li></ul></div>"
	  );
	
	}]);
	
	  return module.name
	})
	;

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BodyComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _body = __webpack_require__(67);
	
	var _body2 = _interopRequireDefault(_body);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BodyComponent = exports.BodyComponent = ['$scope', '$rootScope', function BodyComponent($scope, $rootScope) {
	  'ngInject';
	
	  _classCallCheck(this, BodyComponent);
	
	  var $ctrl = this;
	
	  $scope.$on('$stateChangeSuccess', function (event, toState) {
	    if (toState.hasOwnProperty('theme') && _angular2.default.isDefined(toState.theme)) {
	      var currentStateName = toState.name.split('.').join('-');
	      $ctrl.theme = toState.theme + ' ' + currentStateName;
	    }
	  });
	
	  $ctrl.screen = {
	    width: window.screen.width,
	    height: window.screen.height
	  };
	
	  window.requestAnimFrame = function () {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
	      window.setTimeout(callback, 1000 / 60);
	    };
	  }($ctrl);
	  var screenChecked = false;
	  function checkScreenSize() {
	    if (window.screen.width !== $ctrl.screen.width || window.screen.height !== $ctrl.screen.height) {
	      $rootScope.$broadcast('ts:screenChanged');
	      screenChecked = false;
	    } else {
	      if (!screenChecked) {
	        $rootScope.$broadcast('ts:screenRestored');
	        screenChecked = true;
	      }
	    }
	  }
	
	  (function loop() {
	    window.animFramRef = window.requestAnimFrame(loop);
	    checkScreenSize();
	  })($ctrl);
	
	  $scope.$on('$destroy', function () {
	    window.cancelAnimationFrame(window.animFramRef);
	  });
	}];
	
	exports.default = _angular2.default.module('fplTruescapeComApp.body', [_angularUiRouter2.default]).config(_body2.default).component('body', {
	  controller: BodyComponent
	}).directive('bodyComponent', function () {
	  return {
	    scope: true,
	    controller: BodyComponent,
	    controllerAs: 'BodyController'
	  };
	}).name;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('body', {
	    template: '<ui-view />'
	  });
	}];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function () {
	  NavbarComponent.$inject = ['Auth', '$scope', '$state', '$timeout', '$localStorage', 'Util', 'appConfig'];
	  function NavbarComponent(Auth, $scope, $state, $timeout, $localStorage, Util, appConfig) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, NavbarComponent);
	
	    this.menu = [{
	      title: 'Home',
	      state: 'login',
	      icon: 'fa-home'
	    }, {
	      title: 'Map',
	      state: 'home',
	      icon: 'fa-globe'
	    }];
	    this.isCollapsed = true;
	    var $ctrl = this;
	    this.Util = Util;
	    this.appConfig = appConfig;
	    this.$state = $state;
	    this.$localStorage = $localStorage;
	    this.calibrated = $localStorage.calibrated || false;
	    this.isLoggedIn = Auth.isLoggedInSync;
	    this.isAdmin = Auth.isAdminSync;
	    this.getCurrentUser = Auth.getCurrentUserSync;
	    this.sectors = [];
	    this.screenChanged = false;
	
	    this.sectorsEnabled = appConfig.siteSectorsEnabled;
	
	    $scope.$on('$stateChangeStart', function (event, toState) {
	      _this.hideNavbar = toState.hideNavbar === true ? true : false;
	    });
	
	    $scope.$on('ts:screenCalibrated', function () {
	      $ctrl.calibrated = true;
	      $ctrl.screenChanged = false;
	      $timeout(function () {
	        $scope.$apply();
	      });
	    });
	    $scope.$on('ts:screenChanged', function () {
	      $ctrl.screenChanged = true;
	      $localStorage.calibrated = false;
	      $ctrl.calibrated = false;
	      $timeout(function () {
	        $scope.$apply();
	      });
	    });
	    $scope.$on('ts:screenRestored', function () {
	      $ctrl.screenChanged = false;
	      $localStorage.calibrated = true;
	      $ctrl.calibrated = true;
	      $timeout(function () {
	        $scope.$apply();
	      });
	    });
	
	    _.each($ctrl.appConfig.siteSectors, function (sectorName) {
	      $ctrl.sectors.push({
	        name: sectorName,
	        active: true,
	        icon: sectorName
	      });
	    });
	
	    $ctrl.selectedSectors = [$ctrl.sectors[0]];
	
	    $scope.$on('mapboxglMap:render', function () {
	      $ctrl.toggleSector();
	    });
	  }
	
	  _createClass(NavbarComponent, [{
	    key: 'back',
	    value: function back() {
	      this.Util.goBack();
	    }
	  }, {
	    key: 'toggleSector',
	    value: function toggleSector(sector) {
	      if (sector) {
	        if (this.selectedSectors.indexOf(sector) > -1) {
	          this.selectedSectors.splice(this.selectedSectors.indexOf(sector), 1);
	        } else {
	          this.selectedSectors.push(sector);
	        }
	      }
	
	      $('.marker').removeClass('active');
	      _.each(this.selectedSectors, function (sector) {
	        $('.icon-' + sector.name).addClass('active');
	      });
	    }
	  }, {
	    key: 'canGoBack',
	    value: function canGoBack() {
	      return this.$state.current.name !== 'home';
	    }
	  }]);
	
	  return NavbarComponent;
	}();
	
	exports.default = angular.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(69),
	  controller: NavbarComponent
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-fixed-top\" ng-if=\"!$ctrl.hideNavbar\">\n  <div class=\"container-fluid\" style=\"padding-left:50px; padding-right:50px;\">\n    <div class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\">\n        <li ng-repeat=\"item in $ctrl.menu\">\n          <a ng-hide=\"(item.title === 'Admin' || item.title === 'Report') && !$ctrl.isAdmin()\" ui-sref=\"{{item.state}}\" ui-sref-active=\"active\">\n            <p class=\"navbar-item text-capitalize\">\n              <i class=\"fa\" ng-class=\"item.icon\"></i>&nbsp;\n              <span translate=\"global.navbar.{{item.title}}\"></span></p>\n          </a>\n        </li>\n      </ul>\n      <ul class=\"nav navbar-nav navbar-right\">\n        <li ui-sref-active=\"active\">\n          <a ui-sref=\"settings\">\n            <i class=\"fa fa-cog\"></i>\n            <div class=\"label label-danger label-notification\" ng-show=\"$ctrl.screenChanged || !$ctrl.calibrated\">1</div>\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <div class=\"truescape-logo\"></div>\n\n</div>\n"

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(71);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(75);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(6);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(77);
	
	var _router = __webpack_require__(78);
	
	var _auth = __webpack_require__(79);
	
	var _user = __webpack_require__(82);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('fplTruescapeComApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('fplTruescapeComApp.constants', []).constant('appConfig', __webpack_require__(72)).constant('langConfig', __webpack_require__(73)).name;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin'],
	  env: ("production"),
	  errors: {
	    viewpoint: {
	      GENERAL_ERROR: 'An error occured while creating viewpoint.',
	      VIEWPOINT_TYPE_ERROR: 'Incorrect viewpoint type.',
	      NOT_FOUND: 'Missing or incorrect viewpoints.',
	      video: {
	        VIDEO_NOT_FOUND: 'This Video has not been loaded into the site yet.'
	      },
	      trueview: {
	        ERROR_404: 'The specified Trueview&trade; could not be found.',
	        ERROR_403: 'You are not allowed to access this page.',
	        ERROR_500: 'A server error has occurred.',
	        ERROR_UNKOWN: 'An unknown error has occurred.',
	        ERROR_LOAD_GENERAL: 'An error occured while loading the trueview',
	        DUPLICATE_ASSETS: 'One or both assets are duplicated, Please upload different images.'
	      }
	    },
	    modal: {
	      GENERAL_ERROR: 'A fatal error occurred.',
	      JSON_ERROR: 'Error parsing JSON'
	    },
	    site: {
	      GENERAL_ERROR: 'An error occured while creating site.',
	      SITE_LOAD_ERROR: 'An error occured while loading site.',
	      FORM_INCOMPLETE: 'Please make sure all required fields are filled out correctly.'
	    },
	    asset: {
	      UPLOAD_ERROR: 'An error occured while uploading file.'
	    }
	  },
	  user: {
	    errors: {
	      TOKEN_ERROR: 'Sorry, we could not log you in because the supplied token is not valid.',
	      PASSWORD_ERROR: 'Incorrect password',
	      USER_UPDATE_FAIL: 'Could not update user',
	      STATE_CHANGE: 'Oops, You have unsaved data! Are you sure you want to leave this page?'
	    },
	    PASSWORD_CHANGE: 'Password successfully changed.',
	    TOKEN_AUTHENTICATION: 'Please wait while we authenticate your token.',
	    AUTHENTICATION_FAIL: 'Authenticate failed'
	  },
	  paths: {
	    ASSETS: '/client/assets/uploads/',
	    IMAGES: '/assets/uploads/',
	    ICONS: '/assets/icons/sectors/',
	    ERROR_LOG_FILE: './server/components/errors/error.log'
	  },
	  viewpoints: {
	    INDEXES: ['trueview', 'video'],
	    TRUEVIEW: 0,
	    VIDEO: 1
	  },
	  viewpointStates: {
	    INDEXES: ['deleted', 'modified', 'new'],
	    DELETED: 0,
	    MODIFIED: 1,
	    NEW: 2
	  },
	  translate: {
	    ERROR: 'T_ERROR'
	  },
	  siteBannerIcons: {
	    HIDE:'fa fa-chevron-down',
	    SHOW:'fa fa-chevron-up'
	  },
	  report: {
	    SESSIONS_PER_PAGE: 10,
	    VISITED_URL: 'visited_url',
	    VIDEO_PLAY: 'video_play',
	    TRUEVIEW_ZOOM: 'trueview_zoom',
	    HEAT_MAP_INFO: [
	      'White means that portion of the video was not watched at all (the viewer skipped it)',
	      'Green tells you that the viewer watched that part exactly once.',
	      'Yellow means the viewer watched that part twice.',
	      'Orange, light red, and dark red show that the viewer watched that part of the video three, four, or five times respectively.'
	    ]
	  },
	  wistia: {
	    api_token: 'ed3f8f4fb742801585fc14b772689c035d3e1bbffa34c3a71c2f71ac66f2cd3b',
	    api_uri: 'https://api.wistia.com/v1/'
	  },
	  siteSectors : ['solar', 'wind', 'nuclear', 'natural_gas', 'fossils'],
	  siteSectorsEnabled: false
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	exports = module.exports = {
	  en: __webpack_require__(74)
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	exports = module.exports = {
	  test: {
	    value: 'PASS'
	  },
	  global: {
	    navbar: {
	      HOME: 'Home',
	      ADMIN: 'Admin',
	      REPORT:'Report',
	      MAP: 'Map',
	      LOGOUT: 'Home',
	      HELLO: 'Hi'
	    }
	  },
	  calibration: {
	    modal: {
	      BACK_BUTTON: 'Back',
	      NEXT: 'Next',
	      CANCEL_LINK: 'Cancel Calibration',
	      FINISH: 'Finish',
	      STEP: 'Step',
	      STEP_OF: 'of',
	      clearCacheModal: {
	        HEADING: 'Are You Sure?',
	        MODAL_BODY: 'Are you sure you want to clear the cache? This action is permanent and cannot be undone.',
	        CONFIRM_TEXT: 'Yes, delete the cache',
	        DENY_TEXT: 'No, take me back'
	      },
	      stepOne :{
	        HEADER: 'Screen Calibration Wizard',
	        WELCOME_MESSAGE: 'Welcome to the <br><strong>Texas COLT - Jones Creek Simulations</strong>',
	        LEAD_MESSAGE_ONE: 'This wizard will guide you through calibrating your screen for the best possible experience when viewing this site.',
	        LEAD_MESSAGE_TWO: 'During calibration, we will ask you to hold a gift/loyalty card up against your monitor.',
	        LEAD_MESSAGE_FOUR_STRONG: 'We do not capture, store or photograph any of your card details',
	        LEAD_MESSAGE_FOUR: ', but use the size of the card to calibrate your screen, as it is a standard size across the world.'
	      },
	      stepTwo : {
	        CALIBRATION: 'Screen Size',
	        LEAD: 'Center your loyalty or gift card on the screen with the red dot in the middle, then drag the slider until the virtual card is the same size as your actual one.',
	        SMALLER: 'Smaller',
	        BIGGER: 'Bigger'
	      },
	      stepThree : {
	        MONITOR_SIZE: 'YOUR MONITOR SIZE IS:',
	        APPROX: 'APPROX.',
	        CALIBRATION_COMPLETE: 'Screen Calibration Complete',
	        YOUR_MONITOR_SIZE: 'Your monitor appears to be around',
	        CALIBRATE_AGAIN_MESSAGE: '. If that does not seem right, press the back button to try calibration again. Otherwise, click finish to continue.',
	        ARMS_LENGTH_MESSAGE: 'When using the Zoom mode of this tool later on, please view simulations at a distance of 50cm (approximately arm\'s length) from the screen.'
	      }
	    }
	  },
	  home: {
	    HEADER: 'Projects',
	    SUBTEXT: 'Our universal solar energy centers generate zero-emissions power for all FPL customers using the sun for fuel',
	    SITES_FETCH_ERROR: 'There was an error fetching the sites from the database. Please try again later'
	  },
	  main: {
	    sectors: {
	      SOLAR: 'Solar',
	      WIND: 'Wind',
	      NUCLEAR: 'Nuclear',
	      NATURAL_GAS: 'Natural Gas',
	      FOSSILS: 'Fossils'
	    },
	    POPOVER_MESSAGE: 'Go to Site'
	  },
	  user: {
	    settings: {
	      CHANGE_PASSWORD_HEADER: 'Change Password',
	      CURRENT_PASSWORD: 'Current Password',
	      NEW_PASSWORD: 'New Password',
	      INVALID_NEW_PASSWORD: 'Password must be at least 3 characters.',
	      CONFIRM_NEW_PASSWORD: 'Confirm New Password',
	      PASSWORD_MATCH: 'Passwords must match.',
	      UPDATE_PWD_BUTTON: 'Update Password',
	      DIFFERENT_MONITOR_USED: 'It looks like you\'re using a different monitor than before. For best results, please re-calibrate your display.',
	      DANGER_ZONE: 'clear browsing data',
	      CLEAR_CACHE: 'clear cache',
	      CLEARED_CACHE: 'cached cleared',
	      CHANGED_DISPLAY: 'changed display?',
	      CALIBRATE_DISPLAY: 'Click Here To Calibrate Your Display'
	    },
	    login: {
	      EMAIL: 'Email',
	      PASSWORD: 'Password',
	      ENTER_EMAIL_PASSWORD_MESSAGE: 'Please enter your email and password',
	      INVALID_EMAIL_MESSAGE: 'Please enter a valid email.',
	      LOGIN_BUTTON_MESSAGE: 'Login',
	      POWERED_BY: 'Powered by '
	    }
	  },
	  site: {
	    banner: {
	      slidermessage: {
	        HIDE: 'click to hide',
	        SHOW: 'click to show'
	      },
	      disclaimers: {
	        TWO: 'Click on the view-cones to see simulations that show the Jones Creek Simulation.',
	        ONE: 'Texas COLT - Jones Creek Simulations'
	      }
	    }
	  },
	  trueview: {
	    BACK_PAGE:'Back to Previous Page',
	    ZOOM_FACTOR: 'Zoom Factor',
	    BEFORE_AFTER: 'Before/After',
	    TRUEVIEW_MODE_BUTTON: 'Zoom',
	    TRUEVIEW_MODE_SMALL: 'With TrueView&trade; Technology',
	
	    fullscreen: {
	      BEFORE: 'Before',
	      AFTER: 'After',
	      RESET_ZOOM: 'Reset Zoom',
	      DISCLAIMER: 'DISCLAIMER: Zoom provides visual context by magnifying scenes beyond the capabilities of the human eye.  Zoomed images are not a true view of what a person would see.',
	      EXIT_FULLSCREEN: 'Exit Zoom'
	    }
	  },
	  admin: {
	    SITES_HEADER: 'Sites',
	    USERS_HEADER: 'Users',
	    users: {
	      HEADING: 'Users',
	      BUTTON_NEW: 'Add New User'
	    },
	    sites: {
	      HEADING: 'Site List',
	      ADD_SITE_BUTTON: 'Add New Site',
	      EMPTY: 'You don\'t have any sites yet.',
	      create: {
	        HEADING: 'Create Site',
	        form: {
	          NAME: 'Name',
	          SLUG: 'Slug',
	          DESCRIPTION: 'Description',
	          LAT: 'Latitude',
	          LNG: 'Longitude',
	          BACKGROUND: 'Background Image',
	          DROP_BOX: 'Drop/Click Here to Upload',
	          SVG: 'SVG Image'
	        },
	        viewpoints: {
	          HEADING: 'Viewpoints',
	          ADD_VIEWPOINT_BUTTON: 'New Viewpoint',
	          SUB_HEADING: 'List of Viewpoints',
	          DISPLAY_TRUEVIEW_NUMBERS: 'Hide Trueviews Numbers'
	        },
	        buttons: {
	          CANCEL: 'Cancel',
	          SAVE: 'Save Site'
	        }
	      },
	      edit: {
	        HEADING: 'Edit Site',
	        form: {
	          NAME: 'Name',
	          SLUG: 'Slug',
	          DESCRIPTION: 'Description',
	          LAT: 'Latitude',
	          LNG: 'Longitude',
	          DROP_BOX: 'Drop/Click Here to Upload',
	          BACKGROUND: 'Background Image',
	          SVG: 'SVG Image'
	        },
	        viewpoints: {
	          HEADING: 'Viewpoints',
	          ADD_VIEWPOINT_BUTTON: 'New Viewpoint',
	          SUB_HEADING: 'List of Viewpoints',
	          DISPLAY_TRUEVIEW_NUMBERS: 'Hide Trueviews Numbers'
	        },
	        buttons: {
	          CANCEL: 'Cancel',
	          UPDATE: 'Update Site'
	        }
	      },
	      viewpointModal: {
	        HEADING: 'Viewpoints',
	        dropdown: {
	          SELECT: 'Select a Viewpoint',
	          TRUEVIEW: 'Trueview',
	          VIDEO: 'Video'
	        },
	        form: {
	          NAME: 'Viewpoint Name',
	          DESCRIPTION: 'Description',
	          BEFORE: 'Drop/Click Here To Upload Before Image',
	          AFTER: 'Drop/Click Here To Upload After Image',
	          VIDEO_ID: 'Wistia Hash Id',
	          THUMBNAIL: 'Thumbnail'
	        }
	      }
	    }
	  },
	  errorModal : {
	    DISSMISS: 'Dismiss',
	    SHOW_MORE_DETAILS: 'More Information'
	  },
	  progress: {
	    UPLOADING_VIEWPOINT_ASSETS: 'Uploading viewpoint assets',
	    UPLOADING_SITE_ASSETS: 'Uploading site assets',
	    ALL_SAVED_SUCCESSFULLY: 'Site is saved successfully'
	  },
	  report: {
	    HEADER: 'Report',
	    WHO: 'Who',
	    WHEN: 'When',
	    WHAT_PAGE: 'What Page',
	    WHAT_VIDEO: 'What Video',
	    WHAT_TRUEVIEW: 'What Trueview',
	    WHAT_SITE: 'What Site',
	    SHOW_MORE: 'show more',
	    NO_REPORT: 'There is nothing to report yet',
	    NO_EVENT: 'No events to display',
	    VISITED_URL: 'visited_url'
	  }
	}


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('fplTruescapeComApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return angular.isFunction(cb) ? cb : angular.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    },
	    detectIE: function detectIE() {
	      var ua = window.navigator.userAgent;
	
	      var msie = ua.indexOf('MSIE ');
	      if (msie > 0) {
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	      }
	
	      var trident = ua.indexOf('Trident/');
	      if (trident > 0) {
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	      }
	
	      var edge = ua.indexOf('Edge/');
	      if (edge > 0) {
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	      }
	
	      return false;
	    },
	    goBack: function goBack() {
	      $window.history.back();
	    },
	    isFile: function isFile(file) {
	      return file instanceof File || file instanceof Blob;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('login');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'main' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(80);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    loginHash: function loginHash(_ref2, callback) {
	      var hash = _ref2.hash;
	
	      return $http.get('/auth/hash/' + hash).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      $cookies.remove('ts-session');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _lodash2.default.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _lodash2.default.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_lodash2.default.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_lodash2.default.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_lodash2.default.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      return Auth.hasRole.apply(Auth, _toConsumableArray([].concat.apply(['admin'], arguments)));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('../../database/users.json', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(14);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(84);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(87);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _settings = __webpack_require__(89);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('fplTruescapeComApp.account', [_angularUiRouter2.default, _login2.default, _settings2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/',
	    template: __webpack_require__(85),
	    controller: 'LoginController',
	    controllerAs: 'vm',
	    hideNavbar: true,
	    theme: 'homepage'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(86),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    theme: 'light'
	  });
	}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = "  <div class=\"row\">\n      <div class=\"header-bottom-bar\"></div>\n    <div class=\"welcome-page__header col-xs-12\">\n      <!-- <div class=\"welcome-page__logo text-center\">\n        <img src=\"../../../assets/logos/texas-colt-logo-white.png\" alt=\"Texas COLT logo\" width=\"250\">\n      </div> -->\n    </div>\n\n    <div class=\"col-xs-8 col-xs-offset-2 welcome-page__upper-text\">\n      <h1 class=\"text-center text-capitalize main-header\">texas cOLT <br> Jones Creek Simulations</h1>\n    </div>\n\n\n    <div class=\"welcome-page__footer\">\n      <div class=\"wlecome-page__btn\">\n        <span tooltip-class=\"homepage-popover\" tooltip-placement=\"top\" uib-tooltip=\"Pressing 'Continue' will take you through a one-time wizard identifying the size of your computer screen. This will allow for an optimum viewing experience and depiction of the project simulations at correct size.\" tooltip-append-to-body=\"true\" ng-click=\"vm.enter();\">continue</span>\n      </div>\n    </div>\n    <!-- <div class=\"footer-top-bar\"></div> -->\n    <div class=\"truescape-logo\"></div>\n"

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row center-xs middle-xs\">\n    <div class=\"col-xs-12 spacer-10\" ng-if=\"!vm.calibrated\">\n      <div uib-alert ng-class=\"'alert-danger'\" class=\"no-margin\">\n        <span translate=\"user.settings.DIFFERENT_MONITOR_USED\"></span>\n      </div>\n    </div>\n    <div class=\"col-xs-12\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <h1 class=\"pos-relative\" style=\"font-size:96pt\">\n            <span class=\"fa fa-desktop\"></span>\n            <span class=\"display-size\">{{vm.monitorSize | number: 1}}\"</span>\n          </h1>\n          <h3 class=\"text-capitalize\"><span translate=\"user.settings.CHANGED_DISPLAY\"></span></h3>\n          <button ng-click=\"vm.startCalibration()\" class=\"btn btn-lg btn-primary text-capitalize\">\n            <span class=\"fa fa-sliders\"></span>  <span translate=\"user.settings.CALIBRATE_DISPLAY\"></span>\n          </button>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-6 col-xs-offset-3 user-settings-section center-xs\">\n          <h3 class=\"no-margin text-uppercase\"><span class=\"fa fa-exclamation-triangle text-danger\"></span> <span translate=\"user.settings.DANGER_ZONE\"></span></h3>\n          <div class=\"spacer-20\">\n            <button class=\"btn btn-lg btn-block btn-danger\" ng-click=\"vm.confirmClearCache()\" ng-disabled=\"vm.storageReset\">\n              <i class=\"fa\" ng-class=\"{'fa-eraser': !vm.storageReset, 'fa-check': vm.storageReset}\"></i>&nbsp;\n              <span class=\"text-capitalize\" ng-if=\"!vm.storageReset\"><span translate=\"user.settings.CLEAR_CACHE\"></span></span>\n              <span class=\"text-capitalize\" ng-if=\"vm.storageReset\"><span translate=\"user.settings.CLEARED_CACHE\"></span></span>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n</div>\n</div>\n"

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(88);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('fplTruescapeComApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  LoginController.$inject = ['Auth', '$state', 'User'];
	  function LoginController(Auth, $state, User) {
	    _classCallCheck(this, LoginController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	    this.User = User;
	  }
	
	  _createClass(LoginController, [{
	    key: 'enter',
	    value: function enter() {
	      this.$state.go('home');
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(90);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('fplTruescapeComApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['$scope', '$timeout', 'Auth', 'appConfig', 'Modal', '$localStorage', 'TranslationManager'];
	  function SettingsController($scope, $timeout, Auth, appConfig, Modal, $localStorage, TranslationManager) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    var $ctrl = this;
	    this.Auth = Auth;
	    this.TranslationManager = TranslationManager;
	    this.appConfig = appConfig;
	    this.Modal = Modal;
	    this.$localStorage = $localStorage;
	    this.storageReset = false;
	    this.calibrated = $localStorage.calibrated || false;
	    this.monitorSize = '??';
	    if ($localStorage.hasOwnProperty('screen')) {
	      this.monitorSize = $localStorage.screen.actualHypotenuse / 25.4;
	    }
	    var screenChangeListener = $scope.$on('ts:screenChanged', function () {
	      $ctrl.calibrated = false;
	      $timeout(function () {
	        $scope.$apply();
	      });
	    });
	    var calibrateListener = $scope.$on('ts:screenCalibrated', function () {
	      console.log('calibrated!');
	      $ctrl.calibrated = true;
	      $timeout(function () {
	        $scope.$apply();
	      });
	    });
	
	    var destroyListener = $scope.$on('$destroy', function () {
	      screenChangeListener();
	      calibrateListener();
	      destroyListener();
	    });
	  }
	
	  _createClass(SettingsController, [{
	    key: 'startCalibration',
	    value: function startCalibration() {
	      var _this = this;
	
	      this.Modal.custom.calibrationWizard().then(function () {
	        _this.monitorSize = _this.$localStorage.screen.actualHypotenuse / 25.4;
	      }, _.noop);
	    }
	  }, {
	    key: 'confirmClearCache',
	    value: function confirmClearCache() {
	      var $ctrl = this;
	
	      var cacheClearWarningModalContents = {
	        heading: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.HEADING'),
	        body: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.MODAL_BODY'),
	        confirmText: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.CONFIRM_TEXT'),
	        denyText: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.DENY_TEXT')
	      };
	
	      this.Modal.confirm.custom('danger', function () {
	        $ctrl.$localStorage.$reset();
	        $ctrl.storageReset = true;
	      })(cacheClearWarningModalContents);
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this2 = this;
	
	      this.submitted = true;
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this2.message = _this2.appConfig.user.PASSWORD_CHANGE;
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this2.errors.other = _this2.appConfig.user.errors.PASSWORD_ERROR;
	          _this2.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _home = __webpack_require__(92);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _sites = __webpack_require__(93);
	
	var _sites2 = _interopRequireDefault(_sites);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var uiRouter = __webpack_require__(14);
	
	var HomeComponent = exports.HomeComponent = function () {
	  /*@ngInject*/
	  HomeComponent.$inject = ['Sites', 'Errors', 'FilesUtil', '$localStorage', 'Modal', 'Auth', '$location', 'Util', '$compile', '$scope', '$timeout'];
	  function HomeComponent(Sites, Errors, FilesUtil, $localStorage, Modal, Auth, $location, Util, $compile, $scope, $timeout) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, HomeComponent);
	
	    var $ctrl = this;
	    this.Util = Util;
	    this.$compile = $compile;
	    $ctrl.Sites = Sites;
	    $ctrl.Errors = Errors;
	    $ctrl.FilesUtil = FilesUtil;
	    $ctrl.sites = [];
	    $ctrl.$timeout = $timeout;
	    $ctrl.$localStorage = $localStorage;
	    $ctrl.Modal = Modal;
	    $ctrl.Auth = Auth;
	    this.$scope = $scope;
	    $ctrl.$location = $location;
	    this.siteIndex = 0;
	    this.sites = _sites2.default;
	    this.$timeout(function () {
	      _this.$scope.$broadcast('ts:siteReady');
	    }, 500);
	  }
	
	  _createClass(HomeComponent, [{
	    key: 'getSiteBySlug',
	    value: function getSiteBySlug(slug) {
	      var site = this.sites.find(function (site) {
	        return site.slug == slug;
	      });
	      this.$localStorage.site = _.cloneDeep(site);
	
	      this.$location.url('/viewpoints/' + site.viewpoints.slice(-1)[0]);
	    }
	  }, {
	    key: 'getSiteThumbnail',
	    value: function getSiteThumbnail(image) {
	      return this.FilesUtil.getThumbnail(image);
	    }
	  }, {
	    key: 'getSiteImage',
	    value: function getSiteImage(image) {
	      return this.FilesUtil.getImage(image);
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var $ctrl = this;
	
	      function resizeSvgToBackgroundSize(img) {
	        $('svg').height(img.height);
	        $('svg').width(img.width);
	      }
	
	      var currentBackgroundSize = {
	        width: null,
	        height: null
	      };
	      var lastBackgroundSize = {
	        width: null,
	        height: null
	      };
	
	      function checkForSizeChanges() {
	        $ctrl.$timeout(function () {
	          var backgroundImage = $('img.background')[0];
	          currentBackgroundSize.width = backgroundImage.clientWidth;
	          currentBackgroundSize.height = backgroundImage.clientHeight;
	          if (!_.isEqual(currentBackgroundSize, lastBackgroundSize)) {
	            lastBackgroundSize = _.cloneDeep(currentBackgroundSize);
	            checkForSizeChanges();
	          } else {
	            resizeSvgToBackgroundSize(currentBackgroundSize);
	          }
	        }, 1000);
	      }
	
	      var ieVersion = this.Util.detectIE();
	      if (ieVersion) {
	        this.$scope.$on('ts:siteReady', function () {
	          checkForSizeChanges();
	        });
	        $(window).on('resize', _.debounce(function () {
	          lastBackgroundSize = {
	            width: null,
	            height: null
	          };
	          checkForSizeChanges();
	        }, 100));
	        this.$scope.$on('$destroy', function () {
	          $(window).off('resize');
	        });
	      }
	
	      if (!$ctrl.$localStorage.hasOwnProperty('screen')) {
	        $ctrl.Modal.custom.calibrationWizard();
	      } else {
	        $ctrl.screen = $ctrl.$localStorage.screen;
	      }
	    }
	  }, {
	    key: 'videoLinkHoveredIn',
	    value: function videoLinkHoveredIn(id) {
	      $('#' + id).css('stroke', 'hsl(22, 100%, 45%)');
	    }
	  }, {
	    key: 'videoLinkHoveredOut',
	    value: function videoLinkHoveredOut(id) {
	      $('#' + id).css('stroke', '#4899c3');
	    }
	  }, {
	    key: 'addSite',
	    value: function addSite(element, id) {
	      var $ctrl = this;
	      element.attr('ng-click', '$ctrl.getSiteBySlug(' + id + ')');
	      element.addClass('svg-clickable');
	
	      $('path').filter(function () {
	        var fill = $(this).css('fill');
	        var rgb = fill.substring(4, fill.length - 1).replace(/ /g, '').split(',');
	        return parseInt(rgb[2], 10) > parseInt(rgb[1], 10) && parseInt(rgb[2], 10) > parseInt(rgb[0], 10);
	      }).map(function (index, path) {
	        $(path).addClass('site');
	        return true;
	      });
	      $ctrl.$compile(element)($ctrl.$scope);
	      $ctrl.$timeout(function () {
	        $ctrl.$scope.$apply();
	      }, 0);
	    }
	  }, {
	    key: 'addVideo',
	    value: function addVideo(element, index) {
	      var $ctrl = this;
	      element.attr('ng-click', '$ctrl.openComponentModal($ctrl.site.viewpoints.videos[' + index + '])');
	      element.addClass('svg-clickable pathTarget');
	      $ctrl.$compile(element)($ctrl.$scope);
	      $ctrl.$timeout(function () {
	        $ctrl.$scope.$apply();
	      }, 0);
	    }
	  }, {
	    key: 'svgOnLoad',
	    value: function svgOnLoad() {
	      var _this2 = this;
	
	      var $ctrl = this;
	      var svgGroups = $($('svg>g').get().reverse());
	      _.each(svgGroups, function (group) {
	        var el = angular.element(group);
	        if ($(group).find('g').length > 0) {
	          $ctrl.addSite(el, _this2.siteIndex);
	          _this2.siteIndex++;
	        }
	      });
	    }
	  }, {
	    key: 'getImagePath',
	    value: function getImagePath(image) {
	      return this.FilesUtil.getImage(image);
	    }
	  }, {
	    key: 'trueViewPostConstructionExample',
	    value: function trueViewPostConstructionExample() {
	      this.getSiteBySlug(5);
	    }
	  }]);
	
	  return HomeComponent;
	}();
	
	exports.default = angular.module('fplTruescapeComApp.home', [uiRouter]).config(_home2.default).component('home', {
	  template: __webpack_require__(94),
	  controller: HomeComponent,
	  controllerAs: '$ctrl'
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('home', {
	    url: '/map',
	    template: '<home></home>',
	    theme: 'dark'
	  });
	}];

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = [{"_id":"5cfec775849dbe5f391e0a1b","desc":"Viewpoint 01","slug":"0","name":"3220","sector":"solar","lat":40,"long":180,"assets":{"background":"5cfec774849dbe5f391e0a1a"},"viewpoints":["5cfec821849dbe5f391e0a2c"],"__v":0},{"_id":"5cfec78e849dbe5f391e0a1e","name":"720","slug":"1","desc":"Viewpoint 02","sector":"solar","lat":40,"long":180,"assets":{"background":"5cfec774849dbe5f391e0a1a"},"viewpoints":["5cfec860849dbe5f391e0a31"],"__v":0},{"_id":"5cfec7ae849dbe5f391e0a21","name":"1500","slug":"2","desc":"Viewpoint 03","sector":"solar","lat":40,"long":160,"assets":{"background":"5cfec774849dbe5f391e0a1a"},"viewpoints":["5cfec8e2849dbe5f391e0a3b","5cfec8a5849dbe5f391e0a36"],"__v":0},{"_id":"5cfec7c7849dbe5f391e0a24","name":"1770","slug":"3","desc":"Viewpoint 04","sector":"solar","lat":40,"long":160,"assets":{"background":"5cfec774849dbe5f391e0a1a"},"viewpoints":["5cfec92e849dbe5f391e0a40"],"__v":0},{"_id":"5cfec7e9849dbe5f391e0a27","name":"750","slug":"4","desc":"Viewpoint 05","sector":"solar","lat":40,"long":180,"assets":{"background":"5cfec774849dbe5f391e0a1a"},"viewpoints":["5cfeca07849dbe5f391e0a4e","5cfec9cf849dbe5f391e0a4a","5cfec97a849dbe5f391e0a45","cfec97a849dbe5f391e0a999"],"__v":0},{"_id":"5d000b28f612689ab515ddb1","slug":"5","desc":"TrueView Post Construction Example","sector":"solar","lat":40,"long":140,"assets":{"background":"5d000b27f612689ab515ddb0"},"viewpoints":["5d000b9bf612689ab515ddb6"],"__v":0}]

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid no-padding main-map-page\">\n  <div class=\"row-fluid no-padding no-margin center-xs middle-xs\">\n    <div class=\"col-xs-12 siteLayers\">\n      <div class=\"middle-xs center-xs no-margin\">\n        <lazy-load class=\"background no-overflow\" image=\"{{$ctrl.getImagePath('../../assets/map-assets/map.jpg')}}\" />\n        <div class=\"overlay no-overflow\" data-onload=\"$ctrl.svgOnLoad()\" ng-include=\"$ctrl.getImagePath('../../assets/map-assets/cones.svg')\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n<div id=\"wistia-video-template\"></div>\n<div class=\"showSiteBanner\">\n  <div class=\"row siteBanner-wrapper\">\n    <div class=\"col-xs-2 siteBanner-icon-wrapper-altalink\">\n      <img class=\"mg-responsive btn-block siteBanner-altalink-icon\" src=\"../../assets/logos/viewpoint-enbridge-logo.png\" />\n    </div>\n    <div class=\"col-xs-5 siteBanner-details-wrapper top-xs start-xs\">\n      <ul class=\"site-text\">\n        <li><span translate=\"site.banner.disclaimers.ONE\"></span></li>\n        <li><span translate=\"site.banner.disclaimers.TWO\"></span></li>\n      </ul>\n    </div>\n    <div class=\"col-xs-3 siteBanner-media-altalink\">\n      <div class=\"middle-xs map-btn info-btn\">\n          <span class=\"post-example\" ng-click=\"$ctrl.trueViewPostConstructionExample()\">Click here to see TrueView post construction example <br>(Not related to this project)</span>\n      </div>\n    </div>\n    <div class=\"col-xs-2 banner-truescape\">\n      <img class=\"btn-block\" src=\"/assets/logos/bottom-nav-logo--light-theme.png\" />\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewpointsComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _viewpoints = __webpack_require__(96);
	
	var _viewpoints2 = _interopRequireDefault(_viewpoints);
	
	var _viewpoints3 = __webpack_require__(97);
	
	var _viewpoints4 = _interopRequireDefault(_viewpoints3);
	
	var _files = __webpack_require__(98);
	
	var _files2 = _interopRequireDefault(_files);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var uiRouter = __webpack_require__(14);
	
	var ViewpointsComponent = exports.ViewpointsComponent = function () {
	  /*@ngInject*/
	  ViewpointsComponent.$inject = ['$stateParams', '$timeout', '$state', '$scope', '$compile', 'Errors', '$localStorage'];
	  function ViewpointsComponent($stateParams, $timeout, $state, $scope, $compile, Errors, $localStorage) {
	    var _this = this;
	
	    _classCallCheck(this, ViewpointsComponent);
	
	    _initialiseProps.call(this);
	
	    var $ctrl = this;
	    this.$state = $state;
	    this.site = $localStorage.site;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.zoomedIn = false;
	    this.$compile = $compile;
	    this.Errors = Errors;
	    this.$localStorage = $localStorage;
	    this.highlightenedTrueview = this.site.highlight;
	    this.zoomOpts = {
	      prefixUrl: '/assets/uploads/',
	      tileSources: []
	    };
	    if (!$localStorage.screen) {
	      $localStorage.screen = {
	        width: window.screen.width,
	        height: window.screen.height
	      };
	    }
	
	    this.beforeAfterToggle = true;
	
	    this.trueviews = this.extractTrueviewsFromSiteInLocalStorage();
	
	    var viewpoint = _viewpoints4.default.find(function (viewpoint) {
	      return viewpoint._id == _this.$stateParams.id;
	    });
	
	    this.zoomFactor = 1503.93 / $localStorage.screen.actualWidth || 4.5;
	
	    $timeout(function () {
	      $('.juxtapose-container').css({
	        'max-height': '1050px'
	      });
	    }, 1000);
	
	    $ctrl.trueview = viewpoint;
	    $ctrl.trueview.zoomOpts = {
	      prefixUrl: '/assets/uploads/' + viewpoint.assets.before + '/',
	      tileSources: ['/assets/uploads/' + viewpoint.assets.before + '/tiles.dzi.dzi', '/assets/uploads/' + viewpoint.assets.after + '/tiles.dzi.dzi'],
	      constrainDuringPan: true,
	      visibilityRatio: 1.0,
	
	      minZoomImageRatio: 1,
	      zoomPerClick: 1.0,
	      showZoomControl: false,
	      showHomeControl: false,
	      showFullPageControl: false,
	      showRotationControl: false,
	      showSequenceControl: false,
	      sequenceMode: true,
	      preserveViewport: true,
	      showNavigator: true,
	      navigatorAutoFade: false,
	
	      navigatorPosition: 'TOP_RIGHT',
	      navigatorHeight: '90px',
	      navigatorWidth: '250px'
	    };
	
	    $(document).on('mousedown', 'div.jx-handle', function () {
	      $('div.jx-handle').on('mousemove', function () {
	        $('div.jx-controller, div.jx-arrow').fadeOut(250);
	      });
	    }).mouseup(function () {
	      $('div.jx-handle').off('mousemove');
	      $('div.jx-controller, div.jx-arrow').fadeIn(250);
	    });
	  }
	
	  _createClass(ViewpointsComponent, [{
	    key: 'back',
	    value: function back() {
	      this.$window.history.back();
	    }
	  }, {
	    key: 'getImagePath',
	    value: function getImagePath(id) {
	      var trueview = _files2.default.find(function (file) {
	        return file._id === id;
	      });
	      return '/assets/uploads/' + trueview._id + '/' + trueview.filename;
	    }
	  }, {
	    key: 'toggleBeforeAfter',
	    value: function toggleBeforeAfter($event) {
	      $event.preventDefault();
	      var $ctrl = this;
	      var state = $ctrl.beforeAfterToggle ? 1 : 0;
	      var $openSeadragon = $ctrl.$scope.$openSeadragon;
	      $openSeadragon.goToPage(state);
	    }
	  }, {
	    key: 'toggleHighlightViewpoints',
	    value: function toggleHighlightViewpoints() {
	      if (!this.$localStorage.site.highlight) {
	        this.trueviews = this.trueviews;
	      } else {
	        this.trueviews = this.nightTrueviews;
	      }
	
	      console.log(this.trueviews);
	      this.switchTrueviewView(this.trueviews[0]._id);
	    }
	  }, {
	    key: 'resetZoom',
	    value: function resetZoom() {
	      this.$scope.$openSeadragon.viewport.zoomTo(this.zoomFactor);
	    }
	  }, {
	    key: 'zoom',
	    value: function zoom($openSeadragon) {
	      var $ctrl = this;
	      $openSeadragon = $openSeadragon || $ctrl.$scope.$openSeadragon || false;
	      $ctrl.beforeAfterToggle = false;
	      $openSeadragon.goToPage(0);
	      $openSeadragon.setFullScreen(true);
	      window.$openSeadragon = $openSeadragon;
	
	      var fullScreenSwitch = __webpack_require__(99);
	      var fullScreenDisclaimer = __webpack_require__(100);
	
	      $openSeadragon.addHandler('full-screen', function (event) {
	        $ctrl.$timeout(function () {
	          $ctrl.resetZoom();
	          $openSeadragon.forceRedraw();
	        }, 1000);
	        if (event.fullScreen) {
	          var el = angular.element('.canvas-overlay-box');
	          if (el.length <= 0) {
	            $('.openseadragon-canvas:first').append($ctrl.$compile(fullScreenSwitch)($ctrl.$scope));
	            $('.openseadragon-canvas:first').append($ctrl.$compile(fullScreenDisclaimer)($ctrl.$scope));
	          }
	        }
	      });
	    }
	  }, {
	    key: 'switchTrueviewView',
	    value: function switchTrueviewView(id) {
	      if (id === this.trueviews._id) {
	        return false;
	      }
	      this.$stateParams.id = id;
	      this.$state.go('.');
	    }
	  }]);
	
	  return ViewpointsComponent;
	}();
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.extractTrueviewsFromSiteInLocalStorage = function () {
	    var populatedTrueviews = [];
	    _this2.site.viewpoints.forEach(function (id) {
	      var newTV = _viewpoints4.default.find(function (viewpoint) {
	        return viewpoint._id === id;
	      });
	      populatedTrueviews.push(newTV);
	    });
	    return populatedTrueviews;
	  };
	};
	
	exports.default = angular.module('fplTruescapeComApp.trueviews', [uiRouter]).config(_viewpoints2.default).component('trueviews', {
	  template: __webpack_require__(101),
	  controller: ViewpointsComponent,
	  controllerAs: '$ctrl'
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('viewpoints', {
	    abstract: true,
	    url: '/viewpoints',
	    template: '<ui-view />',
	    theme: 'dark'
	  }).state('viewpoints.view', {
	    url: '/:id',
	    template: '<trueviews></trueviews>',
	    theme: 'dark'
	  });
	}];

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = [{"_id":"5cfec821849dbe5f391e0a2c","name":"Stephen F Austin Road","desc":"VP01","message":"The yellow model represents the position and scale of the tank farm which is obscured by natural foreground vegetation and buildings.","assets":{"before":"5cfec816849dbe5f391e0a2a","after":"5cfec816849dbe5f391e0a2b"},"__v":0},{"_id":"5cfec860849dbe5f391e0a31","name":"Bryan Road (East)","desc":"VP02","message":"The yellow model represents the position and scale of the tank farm which is obscured by natural foreground vegetation.","assets":{"before":"5cfec856849dbe5f391e0a2f","after":"5cfec856849dbe5f391e0a30"},"__v":0},{"_id":"5cfec8a5849dbe5f391e0a36","name":"Durazno Road","desc":"VP03","message":"The yellow model represents the position and scale of the tank farm which is obscured by natural foreground vegetation and buildings.","assets":{"before":"5cfec89c849dbe5f391e0a34","after":"5cfec89c849dbe5f391e0a35"},"__v":0},{"_id":"5cfec8e2849dbe5f391e0a3b","name":"Durazno Road (NIGHT)","desc":"VP03","message":"The blue model represents the position and scale of the tank farm which is obscured by natural foreground vegetation.","assets":{"before":"5cfec8d9849dbe5f391e0a39","after":"5cfec8d9849dbe5f391e0a3a"},"__v":0},{"_id":"5cfec92e849dbe5f391e0a40","name":"Lee Avenue","desc":"VP04","message":"The yellow model represents the position and scale of the tank farm which is obscured by natural foreground vegetation and buildings.","assets":{"before":"5cfec923849dbe5f391e0a3e","after":"5cfec923849dbe5f391e0a3f"},"__v":0},{"_id":"5cfec97a849dbe5f391e0a45","name":"Durazno Plantation Road (WITH OVERLAY)","desc":"VP05","message":"The yellow model represents the position and scale of the tank farm which is obscured by natural foreground vegetation and building.","assets":{"before":"5cfec96f849dbe5f391e0a43","after":"5d005df0d157d43ea3323d44"},"__v":0},{"_id":"cfec97a849dbe5f391e0a999","name":"Durazno Plantation Road","desc":"VP05","assets":{"before":"5cfec96f849dbe5f391e0a43","after":"5d0078b65b8cf295cbff5d18"},"__v":0},{"_id":"5cfec9cf849dbe5f391e0a4a","name":"Durazno Plantation Road (NIGHT)","desc":"VP05","assets":{"before":"5cfec9c5849dbe5f391e0a48","after":"5cfec9c5849dbe5f391e0a49"},"__v":0},{"_id":"5cfeca07849dbe5f391e0a4e","name":"Durazno Platation Road (NIGHT WITH OVERLAY)","desc":"VP05","message":"The blue model represents the position and scale of the tank farm which is partially obscured by natural foreground vegetation.","assets":{"before":"5cfec9c5849dbe5f391e0a48","after":"5cfec9fd849dbe5f391e0a4d"},"__v":0},{"_id":"5d000b9bf612689ab515ddb6","name":"(Not related to this project)","desc":"TrueView Post Construction Example","type":false,"assets":{"before":"5d000b95f612689ab515ddb4","after":"5d000b95f612689ab515ddb5"},"__v":0}]

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = [{"_id":"5cfec774849dbe5f391e0a1a","filename":"a2c1ccc738e818b4b84091db296080d40d2cf4345fd3d467e0c05ab94c0aca1b.png","__v":0},{"_id":"5cfec816849dbe5f391e0a2a","filename":"8366cf58ae7ccdbac95b4e96961741fb874d77c5ecd83a893009dd894496df82.jpg","__v":0},{"_id":"5cfec816849dbe5f391e0a2b","filename":"dee30c7b46651309a22047942bf85b02675dd90cb8e338e07fc430ba1c49a374.jpg","__v":0},{"_id":"5cfec856849dbe5f391e0a2f","filename":"16e9356c64ccd7d7076438241d16b014e0be2c78f64d27bec65aa58cbced2ca5.jpg","__v":0},{"_id":"5cfec856849dbe5f391e0a30","filename":"c7e697d0a319f9386ea5364b09687dca816468806c257ecece51315ab0539000.jpg","__v":0},{"_id":"5cfec89c849dbe5f391e0a34","filename":"d3bfbb5b97334d5dc33c5c990703e25c5cf081ac933df0dec0fb4b814f7a9c5e.jpg","__v":0},{"_id":"5cfec89c849dbe5f391e0a35","filename":"479ac2fc5a79ec515719a85521a8e4a1017078bd9c5d9658e49bbcaafeb505a4.jpg","__v":0},{"_id":"5cfec8d9849dbe5f391e0a39","filename":"bdcd64b58db3d3ad1d59b5d0a5b32d0fef1415729e82404ccf8d1b75a358e03a.jpg","__v":0},{"_id":"5cfec8d9849dbe5f391e0a3a","filename":"10468de436f24726edc3eec97772a075526912cdcc24ecf89aa84e1fac5d8867.jpg","__v":0},{"_id":"5cfec923849dbe5f391e0a3e","filename":"cfe2278ab464431cfcd3afaa45954c3c1264f43c58866eee8927ac23a40c898c.jpg","__v":0},{"_id":"5cfec923849dbe5f391e0a3f","filename":"5df612ee3cbd990cd257d8e98b94f102ad822600e8b64792c528ffc8cb52cfc4.jpg","__v":0},{"_id":"5cfec96f849dbe5f391e0a43","filename":"23e272e2aa96e4adc05f923204714e5c24d7e91ee9e149683924ecf7fc5809d4.jpg","__v":0},{"_id":"5cfec970849dbe5f391e0a44","filename":"2d70eec9c502c225c083426b1b1e8ea8d8b13aa6a5fa4eca182e548eb27ca0f4.jpg","__v":0},{"_id":"5cfec9c5849dbe5f391e0a48","filename":"a65577e6c3708311bcf5219c19bcdb2ec0b3dba9a4c94a0d065ea13d6eb8624d.jpg","__v":0},{"_id":"5cfec9c5849dbe5f391e0a49","filename":"55eba983b96354230b208655d1dee7860a37d2c3dcb7b710e8d89be8d7c92d9c.jpg","__v":0},{"_id":"5cfec9fd849dbe5f391e0a4d","filename":"0867009b43470ed8c31a5d05f5702454c63be7c719c66235b3634c8c906cabd2.jpg","__v":0},{"_id":"5d000b27f612689ab515ddb0","filename":"a2c1ccc738e818b4b84091db296080d40d2cf4345fd3d467e0c05ab94c0aca1b.png","__v":0},{"_id":"5d000b95f612689ab515ddb4","filename":"4ca403dc4a6d361b633080c7aedf5776af0de589a0daa25c7803d05b786bd9be.jpg","__v":0},{"_id":"5d000b95f612689ab515ddb5","filename":"5d80fd3381cabd130d40eedd7f4b7dae633fac021a1ba3a752da8b6f98454970.jpg","__v":0},{"_id":"5d005d96d157d43ea3323d3f","filename":"a2c1ccc738e818b4b84091db296080d40d2cf4345fd3d467e0c05ab94c0aca1b.png","__v":0},{"_id":"5d005df0d157d43ea3323d43","filename":"f63733a29946c93d32aaf9fc4e93239e6382931ab36335065e138965fd004bfb.jpg","__v":0},{"_id":"5d005df0d157d43ea3323d44","filename":"05b657492a0392bfec588ad39f838248007f093972eef5b3bbd2ec2d21915f59.jpg","__v":0},{"_id":"5d0078885b8cf295cbff5d13","filename":"a2c1ccc738e818b4b84091db296080d40d2cf4345fd3d467e0c05ab94c0aca1b.png","__v":0},{"_id":"5d0078b65b8cf295cbff5d17","filename":"23e272e2aa96e4adc05f923204714e5c24d7e91ee9e149683924ecf7fc5809d4.jpg","__v":0},{"_id":"5d0078b65b8cf295cbff5d18","filename":"f63733a29946c93d32aaf9fc4e93239e6382931ab36335065e138965fd004bfb.jpg","__v":0}]

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"canvas-overlay-box row middle-xs\">\n  <button class=\"btn btn-link btn-lg light reset-zoom-button\" ng-click=\"$ctrl.resetZoom()\" type=\"button\">\n    <span class=\"fa fa-eye\"></span>\n    <span translate=\"trueview.fullscreen.RESET_ZOOM\"></span>\n  </button>\n  <label>\n    <span ng-if=\"$ctrl.trueview.type !== false\">Existing</span>\n    <span ng-if=\"$ctrl.trueview.type === false\">Simulated</span>\n  </label>\n  <switch class=\"blue\" name=\"before/after\" ng-change=\"$ctrl.toggleBeforeAfter($event)\" ng-model=\"$ctrl.beforeAfterToggle\"></switch>\n  <label>\n      <span ng-if=\"$ctrl.trueview.type !== false\">Proposed</span>\n      <span ng-if=\"$ctrl.trueview.type === false\">Post Construction</span>\n  </label>\n  <button class=\"btn btn-link btn-lg light exit-fullscreen-button\" ng-click=\"$ctrl.$scope.$openSeadragon.setFullScreen(false)\" type=\"button\">\n    <span class=\"fa fa-compress\"></span>\n    <span translate=\"trueview.fullscreen.EXIT_FULLSCREEN\"></span>\n  </button>\n</div>\n"

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"full-screen-disclaimer\"\n     ng-show=\"$ctrl.zoomFactor !== $ctrl.$scope.$openSeadragon.viewportInfo.zoom\">\n  <div class=\"container\">\n    <div class=\"disclaimer row middle-xs\">\n      <h3 class=\"col-xs-12\">\n        <span translate=\"trueview.fullscreen.DISCLAIMER\"></span>\n      </h3>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row no-margin full-height\" ng-if=\"!$ctrl.trueview\">\n  <div class=\"col-xs-12 no-margin-no-padding\">\n    <h1 class=\"loading large-ellipses\" ng-if=\"!$ctrl.hasErrors\">\n      <span>.</span>\n      <span>.</span>\n      <span>.</span>\n    </h1>\n    <h1 class=\"error-code-icon\" ng-if=\"$ctrl.hasErrors && $ctrl.errorCode\">\n      <span class=\"fa fa-exclamation-triangle\"></span>\n    </h1>\n    <h1 class=\"error-code\" ng-if=\"$ctrl.hasErrors && $ctrl.errorCode\">{{$ctrl.errorCode}}</h1>\n    <h1 ng-bind-html=\"$ctrl.errorMessage\" ng-if=\"$ctrl.hasErrors\"></h1>\n    <button class=\"btn btn-lg btn-primary\" ng-click=\"$ctrl.back()\" ng-if=\"$ctrl.hasErrors\" style=\"margin-top:25px;\">\n      <span class=\"fa fa-arrow-left\"></span><span translate=\"trueview.BACK_PAGE\"></button>\n  </div>\n</div>\n<div class=\"no-margin no-padding navbar-padding  top-xs\">\n  <div id=\"viewportNavigator\"></div>\n  <div class=\"col-xs-12 no-margin no-padding juxtapose-container trueview-{{$ctrl.site.sector}}\">\n    <div class=\"zoomed-juxta\">\n      <div class=\"col-xs-12 no-margin no-padding zoom-container no-animate\">\n        <!-- zoom tile thing -->\n        <seadragon options=\"$ctrl.trueview.zoomOpts\" name=\"$openSeadragon\" />\n        <div class=\"magnification-factor\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 magnification-number\">\n              <h1 class=\"no-padding no-margin\">{{$ctrl.zoomFactor | number:2}}x</h1>\n              <p class=\"no-padding no-margin\"><span translate=\"trueview.ZOOM_FACTOR\"></p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n    <style ng-if=\"$ctrl.trueview.type !== false\">\n      div.jx-controller::before {\n        content: \"existing\";\n        left: 15px;\n      }\n\n      div.jx-controller::after {\n        content: \"proposed\";\n        left: 100px;\n      }\n\n    </style>\n\n    <style ng-if=\"$ctrl.trueview.type === false\">\n      div.jx-controller {\n        width: 260px;\n        margin-left: -93px;\n      }\n\n      div.jx-controller::before {\n        content: \"Simulated\";\n        left: 10px;\n      }\n\n      div.jx-controller::after {\n        content: \"Post Construction\";\n        left: 100px;\n      }\n\n    </style>\n\n    <juxtapose after-image-url=\"$ctrl.getImagePath($ctrl.trueview.assets.after)\" before-image-url=\"$ctrl.getImagePath($ctrl.trueview.assets.before)\" ng-style=\"$ctrl.sliderStyles\">\n    </juxtapose>\n  </div>\n  <div class=\"col-xs-12 site-trueviewView\">\n    <div class=\"row start-xs\">\n\n      <div class=\"col-xs-3 start-xs  site-description\">\n        <div class=\"pull-left\">\n          <img class=\"viewpointBanner-altalink-icon pull-left\" src=\"../../assets/logos/texas-colt-logo-white.png\" width=\"300\" />\n        </div>\n      </div>\n      <div class=\"trueviews-list col-xs-6\">\n        <ul class=\"list-unstyled\">\n          <li class=\"h2 text-uppercase text-center\">{{$ctrl.site.desc}}</li>\n          <li class=\"h5 text-center distance-text\" ng-if=\"$ctrl.site.name\">Distance to the nearest tank {{$ctrl.site.name}} feet</li>\n          <li class=\"list-inline trueview-item\" ng-click=\"$ctrl.switchTrueviewView(trueview._id);\" ng-repeat=\"trueview in $ctrl.trueviews | orderBy:'+':true\" ng-class=\"{'current-trueview': trueview._id === $ctrl.trueview._id}\">\n            <h5 class=\"text-capitalize\">\n              <i class=\"fa fa-map-marker\" ng-if=\"trueview.type !== false\"></i>\n              {{trueview.name}} </h5>\n          </li>\n        </ul>\n      </div>\n      <div class=\"col-xs-1 text-center highlight-btn-wrapper\">\n        <span ng-show=\"$ctrl.nightTrueviews.length > 0 \">\n          <label class=\"highlight-text text-center\">Night Phase</label><br>\n          <switch class=\"highlight\" ng-change=\"$ctrl.toggleHighlightViewpoints()\" ng-model=\"$ctrl.$localStorage.site.highlight\"></switch>\n        </span>\n      </div>\n      <div class=\"col-xs-2 center-xs\">\n        <div class=\"center-xs middle-xs\">\n          <a class=\"btn trueview-btn-{{$ctrl.site.sector}}\" ng-click=\"$ctrl.zoom($ctrl.$scope.$openSeadragon);\">\n            <i class=\"fa zoom-icon\"></i>\n            <span ng-hide=\"$ctrl.zoomedIn\">\n              <i class=\"fa fa-search\"></i>\n              <span translate=\"trueview.TRUEVIEW_MODE_BUTTON\"></span>\n            </span>\n          </a>\n          <div class=\"tv-tech\">\n            <small><span translate=\"trueview.TRUEVIEW_MODE_SMALL\"></span></small>\n          </div>\n        </div>\n        <img class=\"viewpointBanner-truescape-icon\" src=\"/assets/logos/bottom-nav-logo--dark-theme.png\" />\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"col-xs-12 pull-left info-text\" ng-if=\"$ctrl.trueview.message\">\n  <p>{{$ctrl.trueview.message}}</p>\n</div>\n"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	/*@ngInject*/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalizeFilter = capitalizeFilter;
	function capitalizeFilter() {
	  return function (input) {
	    return !!input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
	  };
	}
	
	exports.default = angular.module('fplTruescapeComApp.capitalize', []).filter('capitalize', capitalizeFilter).name;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	SitesService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SitesService = SitesService;
	function SitesService($resource) {
	  return $resource('/api/sites/:id/:slug', {
	    slug: '@slug',
	    id: '@_id'
	  }, {
	    getBySlug: {
	      method: 'GET',
	      params: {
	        slug: '@slug',
	        id: 'slug'
	      },
	      isArray: false
	    },
	    save: {
	      method: 'POST',
	      params: {
	        slug: '',
	        id: '@_id'
	      }
	    },
	    remove: {
	      method: 'DELETE',
	      params: {
	        slug: '',
	        id: '@_id'
	      }
	    },
	    update: {
	      method: 'PUT',
	      params: {
	        slug: '',
	        id: '@_id'
	      }
	    }
	  });
	}
	
	exports.default = angular.module('fplTruescapeComApp.Sites', []).factory('Sites', SitesService).name;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	UsersService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UsersService = UsersService;
	function UsersService($resource) {
	  return $resource('/api/users/:id', {
	    id: '@_id'
	  }, {
	    update: {
	      method: 'PUT',
	      params: {
	        id: '@_id'
	      }
	    }
	  });
	}
	
	exports.default = angular.module('fplTruescapeComApp.Users', []).factory('Users', UsersService).name;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(CryptoJS) {'use strict';
	
	/*@ngInject*/
	
	FilesUtilFactory.$inject = ['$q', '$state', '$rootScope', 'appConfig', 'Files'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilesUtilFactory = FilesUtilFactory;
	function FilesUtilFactory($q, $state, $rootScope, appConfig, Files) {
	  function remove(id) {
	    var deferred = $q.defer();
	    Files.delete({
	      id: id
	    }).$promise.then(function (res) {
	      deferred.resolve(res);
	    }, function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function read(id) {
	    var deferred = $q.defer();
	    Files.read({
	      id: id
	    }).$promise.then(function (res) {
	      deferred.resolve({
	        _id: res._id,
	        filename: res.filename
	      });
	    }, function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function checksum(file) {
	    var deferred = $q.defer();
	    var reader = new FileReader();
	    reader.onloadend = function () {
	      var content = CryptoJS.lib.WordArray.create(reader.result);
	      var hash = CryptoJS.SHA256(content).toString();
	      deferred.resolve(hash);
	    };
	    reader.onerror = function (err) {
	      deferred.reject(err);
	    };
	
	    reader.onprogress = function (evt) {
	      deferred.notify(evt);
	    };
	
	    reader.readAsArrayBuffer(file);
	    return deferred.promise;
	  }
	
	  function getImage(image) {
	    if (image && image.hasOwnProperty('filename') && _.isString(image.filename)) {
	      return appConfig.paths.IMAGES + image.filename;
	    }
	    return image;
	  }
	
	  function getThumbnail(image) {
	    if (image && image.hasOwnProperty('filename') && _.isString(image.filename)) {
	      return appConfig.paths.IMAGES + image._id + '/thumb.jpg';
	    }
	    return image;
	  }
	
	  return {
	    read: read,
	    remove: remove,
	    checksum: checksum,
	    getThumbnail: getThumbnail,
	    getImage: getImage
	  };
	}
	
	exports.default = angular.module('fplTruescapeComApp.FilesUtil', []).factory('FilesUtil', FilesUtilFactory).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';
	
	/*@ngInject*/
	
	FilesService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilesService = FilesService;
	function FilesService($resource) {
	  return $resource('/api/files/:id', {
	    id: '@_id'
	  }, {
	    read: {
	
	      method: 'GET',
	      params: {
	        id: '@_id'
	      }
	    },
	    remove: {
	      method: 'DELETE',
	      params: {
	        id: '@_id'
	      }
	    }
	  });
	}
	
	exports.default = angular.module('fplTruescapeComApp.Files', []).service('Files', FilesService).name;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	/*@ngInject*/
	
	Errors.$inject = ['appConfig', 'Modal', '$log'];
	ExceptionHandler.$inject = ['$injector'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Errors = Errors;
	exports.ExceptionHandler = ExceptionHandler;
	function Errors(appConfig, Modal, $log) {
	  'ngInject';
	
	  return {
	    error: function error(alert) {
	      Modal.alert.error(alert);
	      $log.error(alert.error);
	      throw new Error(alert.error);
	    },
	    warn: function warn(alert) {
	      Modal.alert.warn(alert);
	    },
	    silent: function silent(error) {
	      $log.error(error);
	    },
	    handleUncaught: function handleUncaught(exception, cause) {
	      $log.error(exception, cause);
	    }
	  };
	}
	
	function ExceptionHandler($injector) {
	  'ngInject';
	
	  return function (exception, cause) {
	    var Errors = $injector.get('Errors');
	    Errors.handleUncaught(exception, cause);
	  };
	}
	
	exports.default = angular.module('fplTruescapeComApp.Errors', []).factory('Errors', Errors).factory('$exceptionHandler', ExceptionHandler).name;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	/*@ngInject*/
	
	viewpointService.$inject = ['$q', '$rootScope', 'appConfig', 'FilesUtil', 'Util', 'Viewpoint'];
	ViewpointResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.viewpointService = viewpointService;
	function ViewpointResource($resource) {
	  return $resource('/api/viewpoints/:id', {
	    id: '@_id'
	  }, {
	    getById: {
	      method: 'GET',
	      params: {
	        id: '@_id'
	      }
	    },
	    update: {
	      method: 'PUT',
	      params: {
	        id: '@_id'
	      }
	    },
	    save: {
	      method: 'POST',
	      isArray: true
	    }
	  });
	}
	function viewpointService($q, $rootScope, appConfig, FilesUtil, Util, Viewpoint) {
	  'ngInject';
	
	  var service = {
	    viewpoints: [],
	    hashMatrix: [],
	    viewpointToDelete: null
	  };
	
	  function _flattenAssets(viewpoint) {
	    var assets = {};
	    for (var key in viewpoint.assets) {
	      if (Util.isFile(viewpoint.assets[key])) {
	        assets[key] = viewpoint.assets[key];
	      } else {
	        assets[key] = viewpoint.assets[key]._id;
	      }
	    }
	    return assets;
	  }
	
	  function _hasFiles(assets) {
	    var hasFiles = false;
	    for (var key in assets) {
	      if (Util.isFile(assets[key])) {
	        hasFiles = true;
	      }
	    }
	    return hasFiles;
	  }
	
	  function _uploadViewpointAssets(viewpoints) {
	    var deferred = $q.defer();
	    if (viewpoints.length <= 0) {
	      deferred.resolve();
	      return deferred.promise;
	    }
	
	    var promiseChain = [];
	    var orderArray = [];
	
	    _.each(viewpoints, function (viewpoint, index) {
	      if (viewpoint.type === appConfig.viewpoints.TRUEVIEW) {
	        viewpoint.assets = _flattenAssets(viewpoint);
	      }
	      if (viewpoint.type === appConfig.viewpoints.TRUEVIEW && (_hasFiles(viewpoint.assets) || _hasFiles(viewpoint.zoom))) {
	        promiseChain.push(FilesUtil.upload(viewpoint.assets, true));
	        orderArray.push({
	          index: index,
	          type: 'assets'
	        });
	      }
	    });
	    $q.all(promiseChain).then(function (results) {
	      _.each(results, function (viewpoint, idx) {
	        var currentVp = orderArray[idx];
	        for (var key in viewpoint) {
	          viewpoints[currentVp.index][currentVp.type][key] = viewpoint[key]._id;
	        }
	      });
	      deferred.resolve(viewpoints);
	    }, function (err) {
	      deferred.reject(err);
	    });
	
	    $rootScope.$on('ts:trueviewProgress', function (event, evt) {
	      deferred.notify(evt);
	    });
	
	    return deferred.promise;
	  }
	
	  function _checkStates() {
	    var deletedViewpoints = [];
	    var modifiedViewpoints = [];
	    var newViewpoints = [];
	    var untouchedViewpoints = [];
	    _.each(service.viewpoints, function (viewpoint) {
	      switch (viewpoint.state) {
	        case appConfig.viewpointStates.DELETED:
	          deletedViewpoints.push(viewpoint);
	          break;
	        case appConfig.viewpointStates.MODIFIED:
	          modifiedViewpoints.push(viewpoint);
	          break;
	        case appConfig.viewpointStates.NEW:
	          newViewpoints.push(viewpoint);
	          break;
	        default:
	          untouchedViewpoints.push(viewpoint._id);
	          break;
	      }
	    });
	    return {
	      deleted: deletedViewpoints,
	      modified: modifiedViewpoints,
	      new: newViewpoints,
	      untouched: untouchedViewpoints
	    };
	  }
	
	  function _deleteViewpoints(viewpoints) {
	    var deferred = $q.defer();
	    if (_.isEmpty(viewpoints)) {
	      deferred.resolve();
	      return deferred.promise;
	    }
	    var deletedPromises = [];
	    _.each(viewpoints, function (viewpoint) {
	      deletedPromises.push(Viewpoint.delete({ id: viewpoint._id }).$promise);
	    });
	    $q.all(deletedPromises).then(function () {
	      deferred.resolve();
	    }, deferred.reject);
	    return deferred.promise;
	  }
	
	  function _updateViewpoints(viewpoints) {
	    var deferred = $q.defer();
	    if (_.isEmpty(viewpoints)) {
	      deferred.resolve();
	      return deferred.promise;
	    }
	    var updatedPromises = [];
	    _.each(viewpoints, function (viewpoint) {
	      updatedPromises.push(Viewpoint.update({ id: viewpoint._id }, viewpoint));
	    });
	    $q.all(updatedPromises).then(function (res) {
	      var viewpoints = res.map(function (item) {
	        return item._id;
	      });
	      deferred.resolve(viewpoints);
	    }, deferred.reject);
	    return deferred.promise;
	  }
	
	  function _saveViewpoints(viewpoints) {
	    var deferred = $q.defer();
	    if (_.isEmpty(viewpoints)) {
	      deferred.resolve();
	      return deferred.promise;
	    }
	    Viewpoint.save(viewpoints).$promise.then(deferred.resolve, deferred.reject);
	    return deferred.promise;
	  }
	
	  function _compareHashesWithMatrix(hashes) {
	    var hasDupes = false;
	    service.hashMatrix.forEach(function (pair) {
	      if (_.isEqual(pair, hashes.sort())) {
	        hasDupes = true;
	      }
	    });
	    return hasDupes;
	  }
	
	  function _checkForDuplicateTrueviews(viewpoint) {
	    var deferred = $q.defer();
	    var checksumPromises = [];
	
	    for (var key in viewpoint.assets) {
	      if (Util.isFile(viewpoint.assets[key])) {
	        checksumPromises.push(FilesUtil.checksum(viewpoint.assets[key]));
	      }
	    }
	    $q.all(checksumPromises).then(function (checksums) {
	      var sortedChecksums = checksums.sort();
	      if (_.isEmpty(service.hashMatrix)) {
	        service.hashMatrix.push(sortedChecksums);
	        viewpoint.hashes = sortedChecksums;
	        deferred.resolve(viewpoint);
	      } else if (!_compareHashesWithMatrix(checksums)) {
	        service.hashMatrix.push(sortedChecksums);
	        viewpoint.hashes = sortedChecksums;
	        deferred.resolve(viewpoint);
	      } else {
	        deferred.reject(appConfig.errors.viewpoint.trueview.DUPLICATE_ASSETS);
	      }
	    });
	    return deferred.promise;
	  }
	
	  function _addTrueviewsToHashMatrix(viewpoints) {
	    _.each(viewpoints, function (viewpoint) {
	      if (viewpoint.type === appConfig.viewpoints.TRUEVIEW) {
	        var matrix = [];
	        _.each(viewpoint.assets, function (file) {
	          var hash = file.filename.split('.').shift();
	          matrix.push(hash);
	        });
	        var sortedMatrix = matrix.sort();
	        service.hashMatrix.push(sortedMatrix);
	        viewpoint.hashes = sortedMatrix;
	      }
	    });
	  }
	
	  function _removeFromHashMatrix(viewpoint) {
	    if (service.hashMatrix.indexOf(viewpoint.hashes) > -1) {
	      service.hashMatrix.splice(service.hashMatrix.indexOf(viewpoint.hashes), 1);
	    }
	  }
	
	  service.init = function (viewpoints) {
	    service.viewpoints = viewpoints || [];
	    _addTrueviewsToHashMatrix(viewpoints);
	    return service.viewpoints;
	  };
	
	  service.markAsDeleted = function () {
	    switch (service.viewpointToDelete.state) {
	      case appConfig.viewpointStates.NEW:
	        service.viewpoints.splice(service.viewpoints.indexOf(service.viewpointToDelete), 1);
	        break;
	
	      default:
	        service.viewpointToDelete.state = appConfig.viewpointStates.DELETED;
	        break;
	    }
	    _removeFromHashMatrix(service.viewpointToDelete);
	    service.viewpointToDelete = null;
	  };
	
	  service.create = function (viewpoint) {
	    if (viewpoint.type === appConfig.viewpoints.VIDEO) {
	      service.viewpoints.push(viewpoint);
	      return $q.resolve(viewpoint);
	    }
	    if (viewpoint.type === appConfig.viewpoints.TRUEVIEW) {
	      return _checkForDuplicateTrueviews(viewpoint);
	    }
	  };
	
	  service.get = function (id) {
	    return ViewpointResource.get(id);
	  };
	
	  service.update = function (viewpoint) {
	    return ViewpointResource.update({
	      _id: viewpoint._id
	    }, viewpoint);
	  };
	
	  service.delete = function (id) {
	    return ViewpointResource.delete(id);
	  };
	
	  service.commit = function () {
	    var deferred = $q.defer();
	    var statePromises = [];
	    var states = _checkStates();
	
	    _uploadViewpointAssets(states.modified).then(function (res) {
	      states.modified = res;
	      return _uploadViewpointAssets(states.new);
	    }, function (err) {
	      return $q.reject(err);
	    }, function (evt) {
	      deferred.notify(evt);
	    }).then(function (res) {
	      states.new = res;
	      statePromises.push(_deleteViewpoints(states.deleted), _updateViewpoints(states.modified), _saveViewpoints(states.new));
	      return $q.all(statePromises);
	    }, function (err) {
	      return $q.reject(err);
	    }, function (evt) {
	      deferred.notify(evt);
	    }).then(function (res) {
	      res.push(states.untouched);
	      var viewpoints = [].concat.apply([], res).filter(_.isString);
	      deferred.resolve(viewpoints);
	    }, function (err) {
	      deferred.reject(err);
	    }, function (evt) {
	      deferred.notify(evt);
	    });
	
	    return deferred.promise;
	  };
	
	  service.hasActiveViewpoints = function () {
	    if (_.isEmpty(service.viewpoints)) {
	      return false;
	    }
	    var length = service.viewpoints.reduce(function (total, viewpoint) {
	      var isMarkedForDeletion = _.isEqual(viewpoint, service.viewpointToDelete);
	      return viewpoint.state === appConfig.viewpointStates.DELETED || isMarkedForDeletion ? total : total + 1;
	    }, 0);
	    return length > 0;
	  };
	
	  service.getActualViewpointsUploadCount = function () {
	    if (_.isEmpty(service.viewpoints)) {
	      return 0;
	    }
	    var count = service.viewpoints.reduce(function (total, viewpoint) {
	      var isMarkedForDeletion = _.isEqual(viewpoint, service.viewpointToDelete);
	      return viewpoint.state === appConfig.viewpointStates.DELETED || isMarkedForDeletion || !viewpoint.hasOwnProperty('assets') || !_hasFiles(viewpoint.assets) ? total : total + 1;
	    }, 0);
	    return count;
	  };
	
	  return service;
	}
	
	exports.default = angular.module('fplTruescapeComApp.viewpoint', []).service('Viewpoint', ViewpointResource).service('ViewpointManager', viewpointService).name;

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	/*@ngInject*/
	
	translationService.$inject = ['langConfig', 'appConfig'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translationService = translationService;
	function translationService(langConfig, appConfig) {
	  'ngInject';
	
	  var service = {};
	  service.getReference = function (s, o) {
	    o = o || service.language;
	    if (!s) {
	      return appConfig.translate.ERROR;
	    }
	
	    s = s.replace(/\[(\w+)\]/g, '.$1');
	
	    s = s.replace(/^\./, '');
	    var a = s.split('.');
	    for (var i = 0, n = a.length; i < n; ++i) {
	      var k = a[i];
	      if (k in o) {
	        o = o[k];
	      } else {
	        return appConfig.translate.ERROR;
	      }
	    }
	    return o;
	  };
	
	  service.init = function (languageCode) {
	    service.language = langConfig[languageCode] || langConfig.en;
	  };
	
	  return service;
	}
	
	exports.default = angular.module('fplTruescapeComApp.translation', []).service('TranslationManager', translationService).name;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Modal.$inject = ['$rootScope', '$uibModal', 'appConfig'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modal = Modal;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modal = __webpack_require__(111);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(112);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _modal5 = __webpack_require__(113);
	
	var _modal6 = _interopRequireDefault(_modal5);
	
	var _modal7 = __webpack_require__(114);
	
	var _modal8 = _interopRequireDefault(_modal7);
	
	var _modal9 = __webpack_require__(115);
	
	var _modal10 = _interopRequireDefault(_modal9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Modal($rootScope, $uibModal, appConfig) {
	  'ngInject';
	
	  function openModal() {
	    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var modalClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modal-default';
	
	    var modalScope = $rootScope.$new();
	
	    _angular2.default.extend(modalScope, scope);
	
	    return $uibModal.open({
	      size: scope.size || 'md',
	      template: __webpack_require__(116),
	      windowClass: modalClass,
	      scope: modalScope
	    });
	  }
	
	  function createAlert(type) {
	    return function () {
	      var alert = Array.prototype.slice.call(arguments).shift();
	      var errorModalOpts = {
	        animation: true,
	        template: __webpack_require__(117),
	        controller: _modal10.default,
	        controllerAs: '$ctrl',
	        resolve: {
	          currentError: null
	        }
	      };
	      if (alert) {
	        alert.type = type;
	
	        var defaultHeader = type === 'danger' ? 'Error' : type;
	        alert.title = alert.title || defaultHeader;
	
	        try {
	          alert.error = JSON.stringify(alert.error, null, 1);
	        } catch (ex) {
	          console.error(alert.error);
	          alert.error = appConfig.errors.modal.JSON_ERROR;
	        }
	        errorModalOpts.resolve.currentError = function () {
	          return alert;
	        };
	      }
	
	      var modalInstance = $uibModal.open(errorModalOpts);
	      return modalInstance.result;
	    };
	  }
	
	  return {
	
	    custom: {
	      viewpoint: function viewpoint() {
	        var instance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	        var modalOpts = {
	          animation: true,
	          template: __webpack_require__(118),
	          controller: _modal2.default,
	          controllerAs: '$ctrl',
	          resolve: {
	            currentViewpoint: null
	          }
	        };
	        if (instance) {
	          modalOpts.resolve.currentViewpoint = function () {
	            return instance;
	          };
	        }
	
	        var modalInstance = $uibModal.open(modalOpts);
	        return modalInstance.result;
	      },
	      video: function video(instance, year) {
	        var modalOpts = {
	          animation: true,
	          size: 'lg',
	          template: __webpack_require__(119),
	          controller: _modal4.default,
	          controllerAs: '$ctrl',
	          resolve: {
	            selectedVideo: instance,
	            selectedYear: year
	          }
	        };
	        if (instance) {
	          modalOpts.resolve.selectedVideo = function () {
	            return instance;
	          };
	        }
	
	        var modalInstance = $uibModal.open(modalOpts);
	        return modalInstance.result;
	      },
	      calibrationWizard: function calibrationWizard() {
	        var modalOpts = {
	          animation: true,
	          size: 'lg',
	          template: __webpack_require__(120),
	          controller: _modal8.default,
	          controllerAs: '$ctrl',
	          windowClass: 'calibration',
	          backdrop: 'static',
	          keyboard: false
	        };
	
	        var modalInstance = $uibModal.open(modalOpts);
	        return modalInstance.result;
	      },
	      generalInfo: function generalInfo() {
	        var modalOpts = {
	          animation: true,
	          template: __webpack_require__(121),
	          controller: _modal6.default,
	          controllerAs: '$ctrl',
	          windowClass: 'info-modal',
	          backdrop: 'static',
	          keyboard: false
	        };
	
	        var modalInstance = $uibModal.open(modalOpts);
	        return modalInstance.result;
	      }
	    },
	
	    confirm: {
	      delete: function _delete() {
	        var del = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          var args = Array.prototype.slice.call(arguments);
	          var name = args.shift();
	          var deleteModal;
	
	          deleteModal = openModal({
	            modal: {
	              dismissable: true,
	              title: 'Confirm Delete',
	              html: '<p>Are you sure you want to delete <strong>' + name + '</strong> ?</p>',
	              buttons: [{
	                classes: 'btn-danger',
	                text: 'Delete',
	                click: function click(e) {
	                  deleteModal.close(e);
	                }
	              }, {
	                classes: 'btn-default',
	                text: 'Cancel',
	                click: function click(e) {
	                  deleteModal.dismiss(e);
	                }
	              }]
	            }
	          }, 'modal-danger');
	
	          deleteModal.result.then(function (event) {
	            del.apply(event, args);
	          });
	        };
	      },
	      custom: function custom(type) {
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _angular2.default.noop;
	
	        return function () {
	          var args = Array.prototype.slice.call(arguments),
	              warningModalContents = args.shift(),
	              confirmModal = void 0;
	          confirmModal = openModal({
	            modal: {
	              dismissable: true,
	              title: '<i class="fa fa-exclamation-triangle"></i>&nbsp;' + warningModalContents.heading,
	              html: '<p>' + warningModalContents.body + '</p>',
	              buttons: [{
	                classes: 'btn-' + type,
	                text: warningModalContents.confirmText,
	                click: function click(e) {
	                  confirmModal.close(e);
	                }
	              }, {
	                classes: 'btn-default',
	                text: warningModalContents.denyText,
	                click: function click(e) {
	                  confirmModal.dismiss(e);
	                }
	              }]
	            }
	          }, 'modal-' + type);
	          confirmModal.result.then(function (event) {
	            action.apply(event, args);
	          }, _angular2.default.noop);
	        };
	      }
	    },
	
	    alert: {
	      error: function error(alert) {
	        return createAlert('danger')(alert);
	      },
	      warn: function warn(alert) {
	        return createAlert('warning')(alert);
	      }
	    }
	  };
	}
	
	exports.default = _angular2.default.module('fplTruescapeComApp.Modal', []).factory('Modal', Modal).name;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminSitesViewpointsModalController = function () {
	  /* @ngInject*/
	  AdminSitesViewpointsModalController.$inject = ['$uibModalInstance', '$q', '$scope', 'currentViewpoint', 'ViewpointManager', 'Modal', 'appConfig', 'Errors'];
	  function AdminSitesViewpointsModalController($uibModalInstance, $q, $scope, currentViewpoint, ViewpointManager, Modal, appConfig, Errors) {
	    var _this = this;
	
	    _classCallCheck(this, AdminSitesViewpointsModalController);
	
	    this.setThumbnailStatus = function (asset, boolean) {
	      _this.thumbnailStatus[asset] = boolean;
	    };
	
	    this.sendViewpointToParent = function (form) {
	      var $ctrl = _this;
	      if (form.$valid) {
	        if (_this.modalPayload.type === _this.appConfig.viewpoints.TRUEVIEW) {
	          $ctrl.uploadInProgress = true;
	          $ctrl.ViewpointManager.create(_this.modalPayload).then(function (viewpoint) {
	            $ctrl.$uibModalInstance.close(viewpoint);
	          }, function (err) {
	            $ctrl.uploadInProgress = false;
	            _this.Errors.error({
	              message: _this.appConfig.errors.viewpoint.GENERAL_ERROR,
	              error: err
	            });
	          });
	        } else {
	          $ctrl.$uibModalInstance.close(_this.modalPayload);
	        }
	      } else {
	        _this.Errors.error({
	          message: _this.appConfig.errors.site.FORM_INCOMPLETE,
	          error: form.$errors
	        });
	      }
	    };
	
	    this.getViewpointPayload = function (type) {
	      var $ctrl = _this;
	      var payload = null;
	      $ctrl.resetViewpoint();
	      switch (type) {
	        case 0:
	        case 'trueview':
	          $ctrl.viewpoint.type = $ctrl.appConfig.viewpoints.TRUEVIEW;
	          $ctrl.viewpoint.assets = {
	            before: null,
	            after: null
	          };
	          payload = $ctrl.viewpoint;
	          break;
	        case 1:
	        case 'video':
	
	          $ctrl.viewpoint.type = $ctrl.appConfig.viewpoints.VIDEO;
	          $ctrl.viewpoint.video = {
	            id: null,
	            thumb: null
	          };
	          payload = $ctrl.viewpoint;
	          break;
	        default:
	          _this.Errors.error({
	            message: _this.appConfig.errors.viewpoint.VIEWPOINT_TYPE_ERROR,
	            error: _this.appConfig.errors.viewpoint.VIEWPOINT_TYPE_ERROR
	          });
	      }
	      return payload;
	    };
	
	    this.appConfig = appConfig;
	    this.Errors = Errors;
	    this.Modal = Modal;
	    this.ViewpointManager = ViewpointManager;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$q = $q;
	    this.viewpointTypes = appConfig.viewpoints.INDEXES;
	    this.selectedViewpoint = false;
	    this.modalPayload = {};
	    this.$scope = $scope;
	    this.viewpoint = {
	      name: '',
	      desc: ''
	    };
	
	    this.filePreview = {
	      before: null,
	      after: null
	    };
	    this.thumbnailStatus = {
	      backfore: false,
	      after: false
	    };
	
	    if (currentViewpoint) {
	      this.selectedViewpoint = appConfig.viewpoints.INDEXES[currentViewpoint.type];
	      this.modalPayload = currentViewpoint;
	      this.viewpoint = currentViewpoint;
	    }
	  }
	
	  _createClass(AdminSitesViewpointsModalController, [{
	    key: 'resetViewpoint',
	    value: function resetViewpoint() {
	      this.viewpoint = {
	        name: '',
	        desc: ''
	      };
	    }
	  }, {
	    key: 'selectViewpointType',
	    value: function selectViewpointType(type) {
	      this.modalPayload = this.getViewpointPayload(type);
	      this.selectedViewpoint = type;
	    }
	  }, {
	    key: 'cancelUpload',
	    value: function cancelUpload(event, image) {
	      event.preventDefault();
	      this.viewpoint.assets[image] = null;
	      this.filePreview[image] = null;
	    }
	  }, {
	    key: 'dismissModal',
	    value: function dismissModal() {
	      this.$uibModalInstance.dismiss();
	    }
	  }, {
	    key: 'onFileChange',
	    value: function onFileChange($files, key) {
	      var $ctrl = this;
	      var fileinput = $files[0];
	
	      var reader = new FileReader();
	      reader.onload = function (loadEvent) {
	        $ctrl.$scope.$apply(function () {
	          $ctrl.filePreview[key] = loadEvent.target.result;
	        });
	      };
	      reader.readAsDataURL(fileinput);
	    }
	  }, {
	    key: 'getThumbnail',
	    value: function getThumbnail(image) {
	      if (!image) {
	        return null;
	      }
	      if (image && image.hasOwnProperty('filename') && _.isString(image.filename)) {
	        return this.appConfig.paths.IMAGES + image._id + '/' + image.filename;
	      }
	    }
	  }]);
	
	  return AdminSitesViewpointsModalController;
	}();
	
	exports.default = AdminSitesViewpointsModalController;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VideoModalController = function () {
	  /* @ngInject*/
	  VideoModalController.$inject = ['selectedVideo', 'selectedYear', '$uibModalInstance', '$compile', '$scope'];
	  function VideoModalController(selectedVideo, selectedYear, $uibModalInstance, $compile, $scope) {
	    _classCallCheck(this, VideoModalController);
	
	    this.$uibModalInstance = $uibModalInstance;
	    this.$compile = $compile;
	    this.$scope = $scope;
	    this.video = selectedVideo;
	    this.videoToPlay = selectedYear;
	  }
	
	  _createClass(VideoModalController, [{
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'playVideo',
	    value: function playVideo(video) {
	      console.log(video);
	      var popoverEmbedCode = '<video width="100%" controls autoplay>\n    <source src="../../assets/videos/' + video.fileName + '" type="video/mp4"></video>';
	      var compiledeHTML = this.$compile(popoverEmbedCode)(this.$scope);
	      $('#modal-video-template').fadeOut(500, function () {
	        $('#modal-video-template').empty();
	      });
	      $('#modal-video-template').fadeIn(500, function () {
	        $('#modal-video-template').append(compiledeHTML);
	      });
	    }
	  }]);
	
	  return VideoModalController;
	}();
	
	exports.default = VideoModalController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CalibrationModalController = function () {
	  /* @ngInject*/
	  CalibrationModalController.$inject = ['$uibModalInstance', 'Modal'];
	  function CalibrationModalController($uibModalInstance, Modal) {
	    _classCallCheck(this, CalibrationModalController);
	
	    this.Modal = Modal;
	    this.$uibModalInstance = $uibModalInstance;
	  }
	
	  _createClass(CalibrationModalController, [{
	    key: "closeModal",
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return CalibrationModalController;
	}();
	
	exports.default = CalibrationModalController;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CalibrationModalController = function () {
	  /* @ngInject*/
	  CalibrationModalController.$inject = ['$scope', '$rootScope', '$timeout', '$localStorage', '$uibModalInstance', 'Modal', 'appConfig'];
	  function CalibrationModalController($scope, $rootScope, $timeout, $localStorage, $uibModalInstance, Modal, appConfig) {
	    var _this = this;
	
	    _classCallCheck(this, CalibrationModalController);
	
	    var $ctrl = this;
	    $ctrl.Modal = Modal;
	    $ctrl.$uibModalInstance = $uibModalInstance;
	    $ctrl.appConfig = appConfig;
	    $ctrl.$scope = $scope;
	    $ctrl.$rootScope = $rootScope;
	    $ctrl.$timeout = $timeout;
	    $ctrl.$localStorage = $localStorage;
	    $ctrl.canCancelCalibration = false;
	    $ctrl.ccSize = 175;
	    $ctrl.ccRatio = 1.585772508336421;
	    $ctrl.ccBase = 100;
	    $ctrl.screenSize = 0;
	
	    $ctrl.screen = {
	      width: window.screen.width,
	      height: window.screen.height
	    };
	
	    this.sliderOpts = {
	      floor: -30,
	      ceil: 320,
	      step: 1,
	      precision: 2,
	      minLimit: null,
	      maxLimit: null,
	      minRange: null,
	      maxRange: null,
	      pushRange: false,
	      id: null,
	      translate: null,
	      getLegend: null,
	      stepsArray: null,
	      bindIndexForStepsArray: false,
	      draggableRange: false,
	      draggableRangeOnly: false,
	      showSelectionBar: false,
	      showSelectionBarEnd: false,
	      showSelectionBarFromValue: null,
	      hidePointerLabels: true,
	      hideLimitLabels: true,
	      autoHideLimitLabels: true,
	      readOnly: false,
	      disabled: false,
	      interval: 350,
	      showTicks: false,
	      showTicksValues: false,
	      ticksArray: null,
	      ticksTooltip: null,
	      ticksValuesTooltip: null,
	      vertical: false,
	      getSelectionBarColor: null,
	      getTickColor: null,
	      getPointerColor: null,
	      keyboardSupport: true,
	      scale: 1,
	      enforceStep: true,
	      enforceRange: false,
	      noSwitching: false,
	      onlyBindHandles: false,
	      onStart: null,
	      onChange: function onChange() {
	        $ctrl.updateSize();
	      },
	      onEnd: null,
	      rightToLeft: false,
	      boundPointerLabels: false,
	      mergeRangeLabelsIfSame: false,
	      customTemplateScope: null,
	      logScale: false,
	      customValueToPosition: null,
	      customPositionToValue: null,
	      selectionBarGradient: null,
	      ariaLabel: null,
	      ariaLabelledBy: null,
	      ariaLabelHigh: null,
	      ariaLabelledByHigh: null
	    };
	    if ($localStorage.hasOwnProperty('screen')) {
	      $ctrl.canCancelCalibration = true;
	    }
	    $ctrl.updateSize();
	    $ctrl.wizardStepActive = 0;
	    $ctrl.wizardStepTotal = 1;
	
	    $uibModalInstance.rendered.then(function () {
	      _this.wizardStepTotal = $('.wizard-steps').length;
	    });
	  }
	
	  _createClass(CalibrationModalController, [{
	    key: 'tutorialPrev',
	    value: function tutorialPrev() {
	      this.wizardStepActive--;
	    }
	  }, {
	    key: 'tutorialNext',
	    value: function tutorialNext() {
	      var _this2 = this;
	
	      this.wizardStepActive++;
	      this.$timeout(function () {
	        _this2.$scope.$broadcast('rzSliderForceRender');
	      });
	    }
	  }, {
	    key: 'tutorialFinish',
	    value: function tutorialFinish() {
	      var $ctrl = this;
	      $ctrl.screen.calibratedAt = new Date().getTime();
	      $ctrl.$localStorage.screen = $ctrl.screen;
	      $ctrl.$localStorage.calibrated = true;
	      $ctrl.$rootScope.$broadcast('ts:screenCalibrated');
	      $ctrl.closeModal();
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize() {
	      var $ctrl = this;
	      $ctrl.screen = {
	        width: window.screen.width,
	        height: window.screen.height
	      };
	
	      $ctrl.ccWidth = $ctrl.ccBase * $ctrl.ccRatio + $ctrl.ccSize * $ctrl.ccRatio;
	      $ctrl.ccHeight = $ctrl.ccBase + $ctrl.ccSize;
	      var pixelHypotenuse = Math.sqrt(Math.pow($ctrl.screen.width, 2) + Math.pow($ctrl.screen.height, 2));
	      $ctrl.rPixel = $ctrl.ccWidth / 85.6;
	      var screenHypotenuse = pixelHypotenuse / $ctrl.rPixel;
	      $ctrl.screenSize = screenHypotenuse / 25.4;
	
	      $ctrl.screen.hypotenuse = pixelHypotenuse;
	      $ctrl.screen.rPixel = $ctrl.rPixel;
	      $ctrl.screen.actualHypotenuse = screenHypotenuse;
	      $ctrl.screen.actualWidth = $ctrl.screen.width / $ctrl.rPixel;
	      $ctrl.screen.actualHeight = $ctrl.screen.height / $ctrl.rPixel;
	    }
	  }, {
	    key: 'cancelCalibration',
	    value: function cancelCalibration() {
	      this.$uibModalInstance.dismiss();
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return CalibrationModalController;
	}();
	
	exports.default = CalibrationModalController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ErrorModalController = function () {
	  /* @ngInject*/
	  ErrorModalController.$inject = ['currentError', '$uibModalInstance'];
	  function ErrorModalController(currentError, $uibModalInstance) {
	    _classCallCheck(this, ErrorModalController);
	
	    this.errorContent = currentError;
	    this.$uibModalInstance = $uibModalInstance;
	    this.isErrorDetailsCollapsed = true;
	  }
	
	  _createClass(ErrorModalController, [{
	    key: "closeModal",
	    value: function closeModal() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return ErrorModalController;
	}();
	
	exports.default = ErrorModalController;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button ng-if=\"modal.dismissable\" type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button>\n  <h4 ng-if=\"modal.title\" ng-bind-html=\"modal.title\" class=\"modal-title\"></h4>\n</div>\n<div class=\"modal-body\">\n  <p ng-if=\"modal.text\" ng-bind=\"modal.text\"></p>\n  <div ng-if=\"modal.html\" ng-bind-html=\"modal.html\"></div>\n</div>\n<div class=\"modal-footer\">\n  <button ng-repeat=\"button in modal.buttons\" ng-class=\"button.classes\" ng-click=\"button.click($event)\" ng-bind=\"button.text\" class=\"btn\"></button>\n</div>\n"

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header modal-header--{{$ctrl.errorContent.type}}\">\n  <h4 class=\"modal-title text-uppercase\">\n    <i class=\"fa fa-exclamation-triangle fa-1x\"></i>&nbsp;<span>{{$ctrl.errorContent.title}}</span>\n  </h4>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-capitalize\">{{$ctrl.errorContent.message}}</p>\n  <div uib-collapse=\"$ctrl.isErrorDetailsCollapsed\">\n    <div class=\"well well-lg\">\n      <pre>{{$ctrl.errorContent.error}}</pre>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"$ctrl.isErrorDetailsCollapsed = !$ctrl.isErrorDetailsCollapsed\" type=\"button\" class=\"btn btn-link\"><i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i> <span translate=\"errorModal.SHOW_MORE_DETAILS\"></span></button>\n  <button ng-click=\"$ctrl.closeModal()\" class=\"btn btn-{{$ctrl.errorContent.type}}\"><span translate=\"errorModal.DISSMISS\"></span></button>\n</div>\n"

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h2 class=\"modal-title\">Viewpoints</h3>\n</div>\n<div class=\"modal-body viewpoint-modal-body\">\n  <div class=\"btn-group btn-group--viewpoints\" uib-dropdown>\n    <button type=\"button\" class=\"btn btn-block\" uib-dropdown-toggle>\n        <h4 ng-if=\"$ctrl.selectedViewpoint\">\n          <span class=\"fa fa-street-view\"></span> {{$ctrl.selectedViewpoint | capitalize}} <span class=\"caret\"></span>\n        </h4>\n        <h4 ng-if=\"!$ctrl.selectedViewpoint\">\n          <span class=\"fa fa-street-view\"></span> Select A Viewpoint <span class=\"caret\"></span>\n        </h4>\n      </button>\n    <ul uib-dropdown-menu>\n\n      <li ng-repeat=\"type in $ctrl.viewpointTypes\">\n        <a href ng-click=\"$ctrl.selectViewpointType(type)\">{{ type | capitalize }}</a>\n      </li>\n    </ul>\n  </div>\n  <hr>\n  <!--trueview section-->\n  <div ng-if=\"$ctrl.selectedViewpoint\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <form class=\"form\" name=\"viewpointForm\" ng-submit=\"$ctrl.sendViewpointToParent(viewpointForm)\" novalidate>\n          <div class=\"form-group\">\n            <label>Site Image Name</label>\n            <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"$ctrl.viewpoint.name\">\n          </div>\n          <div class=\"form-group\">\n            <label>Description</label>\n            <textarea rows=\"5\" name=\"desc\" class=\"form-control\" ng-model=\"$ctrl.viewpoint.desc\"></textarea>\n          </div>\n          <div class=\"form-group\" ng-if=\"$ctrl.selectedViewpoint === 'video'\">\n            <label>Wistia Hash Id</label>\n            <input type=\"text\" name=\"link\" class=\"form-control\" ng-model=\"$ctrl.viewpoint.video.id\" required>\n          </div>\n          <div class=\"form-group\" ng-if=\"$ctrl.selectedViewpoint === 'video'\">\n            <label>Thumbnail</label>\n            <input type=\"text\" name=\"thumb\" class=\"form-control\" ng-model=\"$ctrl.viewpoint.video.thumb\" required>\n          </div>\n          <div class=\"row center-xs\" ng-if=\"$ctrl.selectedViewpoint === 'trueview'\">\n            <label class=\"col-xs-6 form-group\">Existing View</label>\n            <label class=\"col-xs-6 form-group\">Proposed View</label>\n            <!--upload BEFORE image-->\n            <div class=\"col-xs-6\">\n              <!-- TODO: Fix the Pattern fail error -->\n              <div ngf-drop ngf-select ngf-before-model-change=\"$ctrl.setThumbnailStatus('before', false);\" ng-model=\"$ctrl.viewpoint.assets.before\"\n                class=\"drop-box middle-xs center-xs\" ng-class=\"{'preview': $ctrl.viewpoint.assets.before}\" ngf-drag-over-class=\"'dragover'\"\n                ngf-multiple=\"false\" ngf-allow-dir=\"false\" accept=\"image/*,!audio/*,!video/*\" required ngf-pattern=\"'image/*,!audio/*,!video/*'\"\n                ngf-change=\"$ctrl.onFileChange($files, 'before');\" ng-show=\"!$ctrl.viewpoint.assets.before\">\n                <div class=\"col-xs-12\" ng-if=\"!$ctrl.viewpoint.assets.before\">\n                    <i class=\"fa fa-file-image-o fa-4x\"></i>\n                  <p class=\"drop-text--top\">\n                    <strong>\n                    Drop/Click here to upload\n                    </strong>\n                  </p>\n                </div>\n                </div>\n                <div ng-show=\"$ctrl.filePreview.before\">\n                  <img ng-load=\"$ctrl.setThumbnailStatus('before', true)\"\n                       class=\"upload-preview-img\"\n                       ng-src=\"{{$ctrl.filePreview.before}}\" />\n                </div>\n                <div class=\"col-xs-12\" ng-if=\"$ctrl.viewpoint.assets.before\">\n                  <div class=\"col-xs-12\">\n                    <i class=\" col-xs-12 loader fa fa-circle-o-notch fa-spin site-imageUploader-spinner\" ng-hide=\"$ctrl.thumbnailStatus.before\"></i>\n                  </div>\n                  <div class=\"col-xs-12\">\n                    <button class=\"btn btn-link\" ng-click=\"$event.stopPropagation();$ctrl.cancelUpload($event, 'before')\">Cancel</button>\n                  </div>\n                </div>\n\n\n            </div>\n            <!--END upload BEFORE image-->\n            <!--upload AFTER  image-->\n            <div class=\"col-xs-6 form-group\">\n              <div ngf-drop ngf-select ngf-before-model-change=\"$ctrl.setThumbnailStatus('after', false);\" ng-model=\"$ctrl.viewpoint.assets.after\"\n                class=\"drop-box middle-xs center-xs\" ng-class=\"{'preview': $ctrl.viewpoint.assets.after}\" ngf-drag-over-class=\"'dragover'\"\n                ngf-multiple=\"false\" ngf-allow-dir=\"false\" accept=\"image/*,!audio/*,!video/*\" required ngf-pattern=\"'image/*,!audio/*,!video/*'\"\n                ngf-change=\"$ctrl.onFileChange($files, 'after');\" ng-show=\"!$ctrl.viewpoint.assets.after\">\n                <div class=\"col-xs-12\" ng-if=\"!$ctrl.viewpoint.assets.after\">\n                    <i class=\"fa fa-file-image-o fa-4x\"></i>\n                  <p class=\"drop-text--top\">\n                    <strong>\n                    Drop/Click here to upload\n                    </strong>\n                  </p>\n                </div>\n                </div>\n                <div ng-show=\"$ctrl.filePreview.after\">\n                  <img ng-load=\"$ctrl.setThumbnailStatus('after', true)\"\n                       class=\"upload-preview-img\"\n                       ng-src=\"{{$ctrl.filePreview.after}}\" />\n                </div>\n                <div class=\"col-xs-12\" ng-if=\"$ctrl.viewpoint.assets.after\">\n                  <div class=\"col-xs-12\">\n                    <i class=\"loader fa fa-circle-o-notch fa-spin site-imageUploader-spinner\" ng-hide=\"$ctrl.thumbnailStatus.after\"></i>\n                  </div>\n                  <div class=\"col-xs-12\">\n                    <button type=\"button\" class=\"btn btn-link\" ng-click=\"$event.stopPropagation();$ctrl.cancelUpload($event, 'after')\">Cancel</button>\n                  </div>\n                </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <button class=\"btn btn-default btn-lg\" type=\"button\" ng-click=\"$ctrl.dismissModal()\">\n        Cancel\n      </button>\n            <button class=\"btn btn-lg btn-primary\" type=\"submit\" ng-disabled=\"$ctrl.uploadInProgress\">\n         <span ng-hide=\"$ctrl.uploadInProgress\">Save</span>\n         <span ng-show=\"$ctrl.uploadInProgress\"><i class=\"fa fa-circle-o-notch fa-spin\" ></i> Validating Uploads</span>\n      </button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n  <!--modal end-->\n</div>\n"

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button ng-if=\"modal.dismissable\" type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button>\n  <h3 class=\"modal-title text-center modal-title-video text-uppercase\">{{$ctrl.video.location}} - {{$ctrl.videoToPlay.year}} </h3>\n</div>\n<div class=\"modal-body modal-body-video\">\n    <div class=\"video-overlay\"></div>\n    <div id=\"modal-video-template\">\n      <video width=\"100%\" controls autoplay controlsList=\"nodownload\">\n    <source src=\"../../assets/videos/{{$ctrl.videoToPlay.fileName}}\" type=\"video/mp4\"></video>\n    </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row\">\n    <div class=\"col-xs-8\">\n      <div class=\"btn-group pull-left\">\n        <label ng-repeat=\"video in $ctrl.video.years\" class=\"btn btn-default btn-lg btn-video-years\" ng-model=\"$ctrl.videoToPlay\" ng-change=\"$ctrl.playVideo(video)\" uib-btn-radio=\"{{video}}\">{{video.year}}</label>\n      </div>\n    </div>\n    <div class=\"col-xs-4\">\n      <button ng-click=\"$ctrl.closeModal()\" class=\"pull-right btn btn-lg btn-altalink-video\"><span translate=\"errorModal.DISSMISS\"></span></button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body\">\n  <div class=\"wizard-steps step-1\" ng-show=\"$ctrl.wizardStepActive === 0\">\n    <div class=\"modal-text\">\n      <h2 class=\"modal-title\"><span translate=\"calibration.modal.stepOne.HEADER\"></span></h3>\n        <div class=\"row center-xs middle-xs\">\n          <div class=\"col-xs-12\">\n            <p class=\"lead\">\n              <span translate=\"calibration.modal.stepOne.WELCOME_MESSAGE\"></span>\n            </p>\n            <p class=\"lead\">\n              <span translate=\"calibration.modal.stepOne.LEAD_MESSAGE_ONE\"></span>\n            </p>\n            <p class=\"lead\">\n              <span translate=\"calibration.modal.stepOne.LEAD_MESSAGE_TWO\"></span>\n            </p>\n            <p class=\"lead\">\n              <strong>\n                  <span translate=\"calibration.modal.stepOne.LEAD_MESSAGE_FOUR_STRONG\"></span>\n              </strong>\n              <span translate=\"calibration.modal.stepOne.LEAD_MESSAGE_FOUR\"></span>\n            </p>\n          </div>\n        </div>\n    </div>\n  </div>\n  <div class=\"wizard-steps step-2\" ng-show=\"$ctrl.wizardStepActive === 1\">\n    <div class=\"modal-text\">\n      <h2 class=\"modal-title\"><span translate=\"calibration.modal.stepTwo.CALIBRATION\"></span>: {{$ctrl.screenSize | number: 1}}\"</h2>\n        <div class=\"row center-xs middle-xs\">\n          <div class=\"col-xs-10 pos-relative\">\n            <p class=\"lead\"><span translate=\"calibration.modal.stepTwo.LEAD\"></span></p>\n            <div class=\"row center-xs middle-xs\">\n              <div class=\"col-xs-10\">\n                <div class=\"row center-xs middle-xs\">\n                  <label for=\"sizeFactor\" class=\"col-xs-2 size-label\"><span translate=\"calibration.modal.stepTwo.SMALLER\"></span></label>\n                  <div class=\"col-xs-8\">\n                    <rzslider rz-slider-model=\"$ctrl.ccSize\" rz-slider-options=\"$ctrl.sliderOpts\"></rzslider>\n                  </div>\n                  <label for=\"sizeFactor\" class=\"col-xs-2 size-label\"><span translate=\"calibration.modal.stepTwo.BIGGER\"></span></label>\n                </div>\n              </div>\n            </div>\n            <div class=\"row center-xs middle-xs spacer-50\">\n              <div class=\"col-xs-12\">\n                <div class=\"credit-card outlined\" ng-style=\"{width: $ctrl.ccWidth, height: $ctrl.ccHeight}\">\n                  <div class=\"dot\"></div>\n                </div>\n              </div>\n\n            </div>\n          </div>\n        </div>\n    </div>\n  </div>\n  <div class=\"wizard-steps step-2\" ng-show=\"$ctrl.wizardStepActive === 2\">\n    <div class=\"row center-xs middle-xs\">\n      <div class=\"col-xs-12 col-md-6 center-xs\">\n        <div class=\"monitor-size\">\n          <h4 class=\"text-uppercase\"><span translate=\"calibration.modal.stepThree.MONITOR_SIZE\"></span></h4>\n          <h1>{{$ctrl.screenSize | number: 1}}\"</h1>\n          <h5><span translate=\"calibration.modal.stepThree.APPROX\"></span></h5>\n        </div>\n      </div>\n      <div class=\"col-xs-12 col-md-6 start-xs\">\n        <h2><span translate=\"calibration.modal.stepThree.CALIBRATION_COMPLETE\"></span></h2>\n        <p class=\"lead\">\n          <span translate=\"calibration.modal.stepThree.YOUR_MONITOR_SIZE\"></span> {{$ctrl.screenSize | number: 1}}\"\n          <span translate=\"calibration.modal.stepThree.CALIBRATE_AGAIN_MESSAGE\"></span>\n        </p>\n        <p class=\"lead\">\n          <strong>\n            <span translate=\"calibration.modal.stepThree.ARMS_LENGTH_MESSAGE\"></span>\n          </strong>\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row center-xs middle-xs spacer-50\">\n    <div class=\"col-xs-4\">\n      <button class=\"btn btn-primary btn-lg\" ng-disabled=\"$ctrl.wizardStepActive <= 0\" ng-click=\"$ctrl.tutorialPrev()\"><i class=\"fa fa-arrow-left\"></i> <span translate=\"calibration.modal.BACK_BUTTON\"></span></button>\n    </div>\n    <div class=\"col-xs-4\">\n      <h4><span translate=\"calibration.modal.STEP\"></span> {{$ctrl.wizardStepActive + 1}} <span translate=\"calibration.modal.STEP_OF\"></span> {{$ctrl.wizardStepTotal}}</h4>\n      <a class=\"clickable\" ng-if=\"$ctrl.canCancelCalibration\" ng-click=\"$ctrl.cancelCalibration()\"><span translate=\"calibration.modal.CANCEL_LINK\"></span></a>\n    </div>\n    <div class=\"col-xs-4\">\n      <button class=\"btn btn-primary btn-lg\" ng-if=\"$ctrl.wizardStepActive < $ctrl.wizardStepTotal -1\" ng-click=\"$ctrl.tutorialNext()\"><span translate=\"calibration.modal.NEXT\"></span> <i class=\"fa fa-arrow-right\"></i></button>\n      <button class=\"btn btn-success btn-lg\" ng-if=\"$ctrl.wizardStepActive >= $ctrl.wizardStepTotal -1\" ng-click=\"$ctrl.tutorialFinish()\"><i class=\"fa fa-arrow-check\"></i> <span translate=\"calibration.modal.FINISH\"></span></button>\n    </div>\n  </div>\n</div>\n</div>\n"

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header modal-header--legend\">\n  <h4 class=\"pull-left modal-title modal-title-map text-uppercase\">\n    <i class=\"fa fa-map-o fa-1x\"></i>&nbsp;&nbsp;<span>LEGEND</span>\n  </h4>\n  <i ng-click=\"$ctrl.closeModal()\" class=\"map-legend-close-btn fa fa-times-circle fa-2x pull-right\" aria-hidden=\"true\"></i>\n\n</div>\n<div class=\"modal-body map-legend\">\n    <li><img height=\"25\" src=\"../../../assets/icons/map-legends-icons/viewpoint-location.png\">&nbsp;&nbsp;Viewpoint Location</li>\n</div>\n"

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(CryptoJS) {'use strict';
	
	ProgressService.$inject = ['ViewpointManager'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgressService = ProgressService;
	function ProgressService(ViewpointManager) {
	  /*@ngInject*/
	  var serviceProvider = function serviceProvider() {
	    var _this = this;
	
	    this.progress = {};
	
	    this.siteUploadFactor = 1;
	    this.progressTotal = 0;
	
	    this.updateProgress = function (evt, type) {
	      if (typeof evt !== 'undefined') {
	        _this.message = _this.setProgressMessage(type);
	        var eventId = _this._idEvent(evt);
	        var progressPercentage = parseInt(evt.loaded / evt.total * 100, 10);
	        _this.progress[eventId] = progressPercentage / _this.getProgressFactor();
	        _this.progressTotal = _this.calculateProgress();
	      }
	    };
	
	    this.getProgress = function () {
	      return {
	        value: _this.progressTotal,
	        message: _this.message,
	        type: _this.progressTotal === 100 ? 'success' : 'warning'
	      };
	    };
	
	    this.setProgress = function () {
	      return {
	        value: 100,
	        message: 'progress.ALL_SAVED_SUCCESSFULLY',
	        type: 'success'
	      };
	    };
	
	    this._idEvent = function (evt) {
	      var files = evt.config.data.files;
	      var stringToHash = '';
	      for (var key in files) {
	        if (_.isObject(files[key])) {
	          stringToHash += key + files[key].name + files[key].size + files[key].lastModifiedDate;
	        }
	      }
	      return CryptoJS.SHA256(JSON.stringify(stringToHash)).toString();
	    };
	
	    this.setProgressMessage = function (data) {
	      var message = void 0;
	      switch (data) {
	        case 'viewpoint':
	          message = _this.progressTotal >= 100 ? 'progress.ALL_SAVED_SUCCESSFULLY' : 'progress.UPLOADING_VIEWPOINT_ASSETS';
	          return message;
	        case 'site':
	          message = _this.progressTotal >= 100 ? 'progress.ALL_SAVED_SUCCESSFULLY' : 'progress.UPLOADING_SITE_ASSETS';
	          return message;
	      }
	    };
	
	    this.calculateProgress = function () {
	      if (Object.keys(_this.progress).length <= 0) {
	        return 0;
	      }
	      var progress = 0;
	
	      _.each(_this.progress, function (value) {
	        progress += value;
	      });
	      return progress;
	    };
	
	    this.getProgressFactor = function () {
	      var viewpointsUploadCount = ViewpointManager.getActualViewpointsUploadCount();
	      return viewpointsUploadCount + _this.siteUploadFactor;
	    };
	  };
	
	  return {
	    instance: function instance() {
	      return new serviceProvider();
	    }
	  };
	}
	
	exports.default = angular.module('fplTruescapeComApp.Progress', []).factory('Progress', ProgressService).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	WistiaService.$inject = ['$q', '$http'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WistiaService = WistiaService;
	function WistiaService($q, $http) {
	  function _httpHandler(params, payload) {
	    if (!params.hasOwnProperty('endpoint') || !params.hasOwnProperty('method')) {
	      return $q.reject({
	        error: 'WISTIA_MISSING_ENDPOINT',
	        message: 'params.endpoint and params.method is required in Wistia Service'
	      });
	    }
	
	    var url = '/api/wistia/' + params.endpoint;
	
	    if (params.hasOwnProperty('id')) {
	      url += '/' + params.id;
	    }
	
	    var httpOpts = {
	      url: url,
	      method: params.method
	    };
	
	    if (payload) {
	      httpOpts.data = payload;
	    }
	
	    return $http(httpOpts);
	  }
	
	  var self = {};
	
	  self.events = {};
	
	  self.events.get = function (id) {
	    var params = {
	      method: 'GET',
	      endpoint: 'events',
	      id: id
	    };
	    return _httpHandler(params);
	  };
	
	  return self;
	}
	
	exports.default = angular.module('fplTruescapeComApp.Wistia', []).factory('Wistia', WistiaService).name;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.mapPin', []).directive('mapPin', ['$rootScope', '$compile', '$timeout', '$window', 'Modal', 'appConfig', function ($rootScope, $compile, $timeout, $window, Modal, appConfig) {
	  'ngInject';
	
	  return {
	    scope: {
	      mapPin: '='
	    },
	    link: function link($scope, $element) {
	      var mapObject;
	      $scope.$on('mapboxglMap:load', function (evt, map) {
	        mapObject = map.target;
	      });
	
	      $scope.sectorsEnabled = appConfig.siteSectorsEnabled;
	
	      $element.attr('ng-mouseenter', 'hover = true');
	      $element.attr('ng-mouseleave', 'hover = false');
	
	      function _resetMap() {
	        var coords = {
	          lat: 26.859655,
	          lng: -81.154691
	        };
	        var lngLat = new $window.mapboxgl.LngLat(coords.lng, coords.lat);
	        mapObject.flyTo({
	          center: lngLat,
	          zoom: 7,
	          pitch: 55,
	          bearing: 35,
	          speed: 0.75,
	          curve: 1,
	          easing: function easing(t) {
	            return t;
	          }
	        });
	      }
	
	      function _openModal(instance) {
	        Modal.custom.map(instance).then(_resetMap, _resetMap);
	      }
	
	      $scope.clickHandler = function () {
	        var instance = $scope.marker;
	        if (mapObject && mapObject.getZoom() < 8) {
	          var lng = $scope.marker.coordinates[0];
	          var lat = $scope.marker.coordinates[1];
	          var lngLat = new $window.mapboxgl.LngLat(lng, lat);
	          mapObject.flyTo({
	            center: lngLat,
	            zoom: 7,
	            pitch: 60,
	            bearing: 55,
	            speed: 0.5,
	            curve: 1,
	            easing: function easing(t) {
	              return t;
	            }
	          });
	          var moveEndListener = $scope.$on('mapboxglMap:moveend', function () {
	            $timeout(function () {
	              _openModal(instance);
	            }, 0);
	            moveEndListener();
	          });
	        } else {
	          _openModal(instance);
	        }
	      };
	      $scope.$watch('mapPin', function (newVal) {
	        if (!_.isEmpty(newVal)) {
	          $scope.marker = $scope.mapPin;
	
	          if ($scope.sectorsEnabled) {
	            $element.attr('ng-class', '{"icon-' + $scope.mapPin.site.sector + '-hover": hover}');
	          } else {
	            $element.attr('ng-class', '{"icon-solar-hover": hover}');
	          }
	          $element.attr('ng-click', 'clickHandler()');
	          $compile($element)($scope);
	        }
	      });
	    }
	  };
	}]).name;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.translateDirective', []).directive('translate', ['TranslationManager', '$sce', '$compile', function (TranslationManager, $sce, $compile) {
	  TranslationManager.init();
	  return {
	    scope: {
	      translate: '@'
	    },
	    restrict: 'EA',
	    link: function link(scope, element) {
	      function _translate() {
	        var html = '<span ng-bind-html="translatedText"></span>';
	        var constant = scope.translate.split('.').pop();
	
	        constant = constant.toUpperCase();
	        scope.translate = scope.translate.substr(0, scope.translate.lastIndexOf('.')) + '.' + constant;
	        scope.translatedText = TranslationManager.getReference(scope.translate);
	        html = $compile(html)(scope);
	        element.replaceWith(html);
	      }
	      scope.$watch('translate', function () {
	        if (scope.translate) {
	          _translate();
	        }
	      });
	    }
	  };
	}]).name;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.ngLoad', []).directive('ngLoad', ['$parse', function ($parse) {
	  return {
	    restrict: 'A',
	    link: function link(scope, elem, attrs) {
	      var fn = $parse(attrs.ngLoad);
	      elem.on('load', function (event) {
	        scope.$apply(function () {
	          fn(scope, { $event: event });
	        });
	      });
	    }
	  };
	}]).name;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.passwordMatch', []).directive('passwordMatch', [function () {
	  return {
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ctrl) {
	      var password = '#' + attrs.passwordMatch;
	      elem.add(password).on('keyup', function () {
	        scope.$apply(function () {
	          var value = elem.val() === $(password).val();
	          ctrl.$setValidity('passwordMatch', value);
	        });
	      });
	    }
	  };
	}]).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.progressBarDirective', []).directive('progressBar', function () {
	  return {
	    restrict: 'EA',
	    scope: {
	      progress: '='
	    },
	    template: __webpack_require__(129)
	  };
	}).name;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = "<h1 class=\"progress--description\">\n  <span translate=\"{{progress.message}}\"></span>\n</h1>\n<uib-progressbar animate=\"false\"\n                 class=\"progress-striped active\"\n                 type=\"{{progress.type}}\"\n                 value=\"progress.value\"></uib-progressbar>\n<h1 class=\"progress--percentage\">\n  <span>{{progress.value | number: 0}}%</span>\n</h1>\n"

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.slideableDirective', []).directive('slidable', ['TranslationManager', function (TranslationManager) {
	  TranslationManager.init();
	  return {
	    restrict: 'E',
	    compile: function compile(element, attributes) {
	      var slideTabMessages = attributes.slideTabTooltipMessage.split('|');
	
	      var translatedSlideTabMessages = slideTabMessages.map(function (slideTabMessage) {
	        return TranslationManager.getReference(slideTabMessage);
	      });
	      var siteBanner = document.getElementsByClassName('showSiteBanner')[0];
	      siteBanner.insertAdjacentHTML('afterbegin', '<div id="sliderSwitch" tooltip-placement="top" uib-tooltip="{{tooltipMessage}}" tooltip-class="tooltip-altalink"><i id="sliderSwitchIcon"></i></div>');
	      return {
	        pre: function pre(scope) {
	          scope.tooltipMessage = translatedSlideTabMessages[0];
	        },
	        post: function post(scope, element, attributes) {
	          var sliderSwitch = document.getElementById('sliderSwitch');
	          var sliderSwitchIcon = document.getElementById('sliderSwitchIcon');
	          var sliderSwitchIconClasses = attributes.slideTabIcons.split('|');
	          sliderSwitchIcon.className = sliderSwitchIconClasses[0];
	          sliderSwitchIcon.addEventListener('click', function () {
	            siteBanner.classList.toggle('hideSiteBanner');
	
	            sliderSwitchIcon.className = sliderSwitchIcon.className === sliderSwitchIconClasses[0] ? sliderSwitchIconClasses[1] : sliderSwitchIconClasses[0];
	
	            sliderSwitch.getAttribute('uib-tooltip') === translatedSlideTabMessages[0] ? scope.tooltipMessage = translatedSlideTabMessages[1] : scope.tooltipMessage = translatedSlideTabMessages[0];
	          });
	        }
	      };
	    }
	  };
	}]).name;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('fplTruescapeComApp.lazyLoad', []).directive('lazyLoad', function () {
	  return {
	    restrict: 'EA',
	    scope: {
	      image: '@',
	      blur: '@',
	      class: '@'
	    },
	    link: function link(scope, element) {
	      var smallImg = angular.element(element[0].children.blur);
	      var realImg = angular.element(element[0].children.image);
	
	      realImg.on('load', function () {
	        smallImg.addClass('img-hide');
	        realImg.removeClass('img-hide');
	        realImg.addClass(scope.class);
	        realImg.addClass('img-show');
	      }).on('error', function (err) {
	        console.error(err);
	      });
	    },
	    template: __webpack_require__(132)
	  };
	}).name;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports = "<img class=\"blur\"\n     id=\"blur\"\n     ng-src=\"{{blur}}\" />\n<img class=\"img-hide\"\n     id=\"image\"\n     ng-src=\"{{image}}\" />\n"

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(134);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(146)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	exports.i(__webpack_require__(136), "");
	exports.i(__webpack_require__(137), "");
	exports.i(__webpack_require__(138), "");
	exports.i(__webpack_require__(139), "");
	exports.push([module.id, "@import url(/assets/fonts/proxima-nova/stylesheet.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/oswald/stylesheet.css);", ""]);
	exports.i(__webpack_require__(140), "");
	exports.i(__webpack_require__(141), "");
	exports.i(__webpack_require__(142), "");
	exports.i(__webpack_require__(143), "");
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.truncate{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}[ui-view].ng-enter{animation:fadeIn 1s}[ui-view].ng-enter-active{opacity:1}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}div.full-height{position:relative;height:100vh;max-height:100vh;max-width:100%;overflow:hidden}div.full-height.with-navbar{margin-top:-100px}div.full-height.navbar-padding{height:calc(100vh - 100px)}.mCSB_container{padding:10px}.viewpointBanner-altalink-icon{padding:20px}.viewpointBanner-truescape-icon{max-height:20px;margin-top:20px}.siteBanner-altalink-icon{max-width:75%}div.half-height{position:relative;height:25vh;max-height:25vh;max-width:100%;overflow:hidden}.no-margin{margin:0}.no-padding{padding:0}.no-overflow{overflow:hidden}a:link:not(.btn),a:visited:not(.btn){color:#545453}.large-ellipses{font-size:96pt}.error-code-icon{font-size:108pt;font-weight:700;margin:0}.error-code{font-size:54pt;font-weight:700;margin:0;margin-bottom:15px}.jx-image>img{height:auto;width:auto}.mapboxgl-ctrl-bottom-left{display:none}.user-settings-section{background:#f8f8f8;padding:30px;margin-top:25px;border:2px solid #ddd;border-radius:3px}h1>span.display-size{font-size:18pt;position:absolute;top:30px;left:50%;margin-left:-25px}.clickable{cursor:pointer}.label-notification{position:absolute;border-radius:100%;height:20px;width:20px;max-height:15px;max-width:15px;line-height:10px;font-size:10px;margin:0;text-align:left;padding:3px 5px;top:10px;right:5px;color:#fff!important}.alert-danger{background-color:#ec6a65;border-color:transparent;color:#fff;font-size:1.4em}.progress--description,.progress--percentage{margin:50px 0}.progress--description,.progress--percentage{font-family:Oswald,Arial,Helvetica,sans-serif}.welcome-page__header{background-color:#363636;height:68px;width:100%}.welcome-page__header .welcome-page__logo{max-width:400px;margin:0 auto}.welcome-page__upper-text{padding-top:150px;margin-top:15px;color:#e9e9ec;margin-bottom:15px}.welcome-page__upper-text h1{font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:700;font-size:80px;color:#e9e9ec;text-shadow:2px 2px #363636}@media (max-width:1200px){.welcome-page__upper-text h1{font-size:50px}}.welcome-page__footer{position:absolute;bottom:0;right:0;left:0;background-color:#363636;height:200px}@media (max-width:1440px){.welcome-page__footer{height:150px}}.welcome-page__logo{margin:0 auto}.welcome-page__logo img{display:inline-block;margin-top:10px}.wlecome-page__btn{width:100%;color:#363636;background-color:#ffb61a;text-align:center;line-height:70px;font-size:36px;text-transform:uppercase;font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:700}.wlecome-page__btn span{cursor:pointer;color:#e9e9ec;text-shadow:1px 1px #363636}.wlecome-page__btn span:hover{color:#828282;text-shadow:1px 1px #e9e9ec}.welcome-page__middle-boxes p{background:rgba(26,26,26,.3);font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:400;font-size:20px;color:#e9e9ec;text-align:center;padding:25px;margin-left:10px;margin-right:10px;min-height:200px;box-shadow:inset -3px -3px #e9e9ec}@media (max-width:1200px){.welcome-page__middle-boxes p{min-height:200px;font-size:16px}}.header-bottom-bar{width:100%;height:17.1px;background-color:#e9e9ec}.bottom-paraghraph{font-family:Oswald,Arial,Helvetica,sans-serif}.bottom-paraghraph,.upper-paraghraph{font-size:16px;color:#1a1a1a;padding-top:50px}.upper-paraghraph{padding-bottom:50px}.tooltip.homepage-popover .tooltip-inner{color:#ffb61a;background:rgba(54,54,54,.9);font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:100;font-size:16px;box-shadow:0 6px 12px rgba(0,0,0,.175);min-width:500px;padding:10px;position:relative}.tooltip.homepage-popover .tooltip-arrow{border-top-color:rgba(26,26,26,.75)!important}.my-drop-zone{border:3px dotted #d3d3d3}.nv-file-over{border:3px dotted red}.danger{color:#d15b47}a.admin-icon{font-size:100px;cursor:pointer;align-items:center;justify-content:center;text-decoration:none}a.admin-icon *{color:#545453}a.admin-icon h2{text-decoration:none;text-align:center;margin:-15px 0 0}a.admin-icon:hover *{color:#3c3c3b}.sites-header{display:flex;align-items:center;margin:20px 0}.sites-header h2{margin:0}.btn-group--viewpoints{display:flex;align-items:center;justify-content:center}.btn-group--viewpoints ul{width:100%;text-align:center;font-size:24px}.dropdown-menu--list{width:100%}#trueview,#video{width:100%;height:200px}.sites-list{border:1px solid #d3d3d3;border-radius:5px}.sites-list li{display:flex;border:none;border-bottom:1px solid #d3d3d3;margin-bottom:0}.sites-list li:last-child{border-bottom:none}.sites-list li .site-info{flex-grow:1}.sites-list li .edit,.sites-list li .site,.sites-list li .trash{display:flex;align-items:center;text-decoration:none;margin:0 5px}.users-list,.viewpoints-list{border:1px solid #d3d3d3;border-radius:5px}.users-list.no-border,.viewpoints-list.no-border{border:none}.users-list li,.viewpoints-list li{display:flex;border:none;border-bottom:1px solid #d3d3d3;margin-bottom:0}.users-list li:last-child,.viewpoints-list li:last-child{border-bottom:none}.users-list li .user-info,.users-list li .viewpoint-info,.viewpoints-list li .user-info,.viewpoints-list li .viewpoint-info{flex-grow:1}.users-list li .viewpoint-info .viewpoint-type,.viewpoints-list li .viewpoint-info .viewpoint-type{margin:0 10px 0 5px;font-size:3em;float:left}.users-list li .edit,.users-list li .trash,.users-list li .user,.viewpoints-list li .edit,.viewpoints-list li .trash,.viewpoints-list li .user{display:flex;align-items:center;text-decoration:none;margin:0 5px}.users-list li.new-viewpoint,.viewpoints-list li.new-viewpoint{display:flex;background:transparent;border:2px dashed #d3d3d3;margin-bottom:0;padding:25px 5px;cursor:pointer;transition:color .1s ease-in;-webkit-transition:color .1s ease-in;-moz-transition:color .1s ease-in;-o-transition:color .1s ease-in}.users-list li.new-viewpoint .viewpoint-info,.viewpoints-list li.new-viewpoint .viewpoint-info{flex-grow:1}.users-list li.new-viewpoint .viewpoint-info a,.viewpoints-list li.new-viewpoint .viewpoint-info a{transition:color .1s ease-in;-webkit-transition:color .1s ease-in;-moz-transition:color .1s ease-in;-o-transition:color .1s ease-in;color:#d3d3d3;text-decoration:none}.users-list li.new-viewpoint:hover,.viewpoints-list li.new-viewpoint:hover{border-color:#545453}.users-list li.new-viewpoint:hover .viewpoint-info a,.viewpoints-list li.new-viewpoint:hover .viewpoint-info a{color:#545453}.drop-box{padding:10px;border:3px dashed #ccc;min-height:175px;display:flex;flex-wrap:wrap;color:#ccc;text-transform:uppercase}.drop-box.dragover{border:2px dashed #777;color:#777}.drop-box.preview{border:none}.btn--new-viewpoint{align-items:center;margin:15px 0 0;text-decoration:none}img.upload-preview-img{max-height:150px;max-width:100%;margin-bottom:10px}img.upload-preview-img.svg-preview{min-width:150px}ul.ng-toast__list{list-style-type:none}.no-animate{transition:none!important}.site-imageUploader-spinner{font-size:48px;margin-bottom:25px}@keyframes blink{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}.loading span{animation-name:blink;animation-duration:1.4s;animation-iteration-count:infinite;animation-fill-mode:both}.loading span:nth-child(2){animation-delay:.2s}.loading span:nth-child(3){animation-delay:.4s}body{font-family:Proxima Nova}body.homepage{color:#f0f0f0;background:url(" + __webpack_require__(145) + ") no-repeat 50% fixed;background-size:cover}body.homepage .navbar-item{color:#f0f0f0;font-weight:200}body.homepage .navbar-item:hover:not(.hi-admin){color:#b0b0b0}body.homepage .logo{background-image:url(\"/assets/logos/top-nav-logo--homepage-theme.png\");background-repeat:no-repeat;background-size:cover;width:65px;height:65px;margin-top:-10px}body.homepage .truescape-logo{background-image:url(\"/assets/logos/bottom-nav-logo--dark-theme.png\");background-repeat:no-repeat;background-size:cover;width:135px;height:25px;position:fixed;bottom:49px;right:55px;z-index:125}@media (max-width:1440px){body.homepage .truescape-logo{bottom:20px;right:20px}}body.light{background:#f0f0f0;color:#3b3b3a}body.light .navbar-item{font-weight:200;color:#3b3b3a}body.light .navbar-item:hover:not(.hi-admin){color:#7c7c79}body.light .logo{background-image:url(\"/assets/logos/top-nav-logo--light-theme.png\");width:65px;height:65px;margin-top:-10px}body.light .logo,body.light .truescape-logo{background-repeat:no-repeat;background-size:cover}body.light .truescape-logo{background-image:url(\"/assets/logos/bottom-nav-logo--dark-theme.png\");width:135px;height:25px;position:fixed;bottom:49px;right:55px;z-index:125}@media (max-width:1440px){body.light .truescape-logo{bottom:20px;right:20px}}body.dark{color:#f0f0f0;background:#363636}body.dark .navbar-item{color:#f0f0f0;font-weight:200}body.dark .navbar-item:hover:not(.hi-admin){color:#b0b0b0}body.gradient{color:#f0f0f0;background:radial-gradient(circle,#e9e9ec 0,#1a1a1a 75%);background-color:#1a1a1a}body.gradient ::-webkit-input-placeholder{color:#e3e3e3}body.gradient :-moz-placeholder,body.gradient ::-moz-placeholder{color:#e3e3e3;opacity:1}body.gradient :-ms-input-placeholder,body.gradient ::-ms-input-placeholder{color:#e3e3e3}body.gradient .navbar-item{color:#f0f0f0;font-weight:200}body.gradient .navbar-item:hover:not(.hi-admin){color:#b0b0b0}body.gradient .logo{background-image:url(\"/assets/logos/top-nav-logo--gradient-theme.png\");background-repeat:no-repeat;background-size:cover;width:65px;height:65px;margin-top:-10px}body.gradient .truescape-logo{background-image:url(\"/assets/logos/bottom-nav-logo--dark-theme.png\");background-repeat:no-repeat;background-size:cover;width:135px;height:25px;position:fixed;bottom:49px;right:55px;z-index:125}@media (max-width:1440px){body.gradient .truescape-logo{bottom:20px;right:20px}}body.map,body.sites-viewpoint,body.viewpoints-view{min-height:100vh}body.map [ui-view],body.sites-viewpoint [ui-view],body.viewpoints-view [ui-view]{margin-top:0}body.sites-viewpoint{overflow:hidden}body.sites-viewpoint .truescape-logo,body.viewpoints-view .truescape-logo{display:none}body.sites-viewpoint .modal-danger .modal-header>*,body.sites-viewpoint .modal-danger button,body.sites-viewpoint .modal-danger i,body.viewpoints-view .modal-danger .modal-header>*,body.viewpoints-view .modal-danger button,body.viewpoints-view .modal-danger i{color:#fff}body.map .navbar,body.sites-viewpoint .navbar{background:linear-gradient(180deg,rgba(0,0,0,.65) 0,transparent);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#a6000000\",endColorstr=\"#00000000\",GradientType=0)}.btn{transition:all .1s}.btn:disabled,.btn:disabled:hover{background-color:#eee;color:#ccc}.btn-danger{border-radius:3px;border:none;color:#fff;background-color:#d43f3a}.btn-danger:hover:not(:disabled){background-color:#d9534f;box-shadow:0 3px 6px rgba(0,0,0,.25),0 1px 3px rgba(0,0,0,.22)}.btn-danger:active{background-color:#c9312c!important;box-shadow:0 1px 3px rgba(0,0,0,.25),0 1px 1px rgba(0,0,0,.22)!important}.btn-danger:disabled,.btn-danger:disabled:hover{background-color:#eb8d89;color:#fff}.btn-link{border-radius:3px;border:2px solid #008dd1;color:#008dd1;background-color:transparent;text-decoration:none!important}.btn-link:hover:not(:disabled){color:#05aeff;border-color:#05aeff}.btn-link:active{color:#007cb8!important;border-color:#007cb8!important}.btn-link:disabled,.btn-link:disabled:hover{background-color:transparent;color:#ccc}.btn-link.light{border-radius:3px;border:2px solid #fff;color:#fff;background-color:transparent;text-decoration:none!important}.btn-link.light:hover:not(:disabled){color:#008dd1;background-color:#fff;border-color:#fff}.btn-link.light:active{color:#007cb8!important;border-color:#007cb8!important}.btn-link.light:disabled,.btn-link.light:disabled:hover{background-color:transparent;color:#ccc}.btn-primary{border-radius:3px;border:none;color:#fff;background-color:#008dd1}.btn-primary:hover:not(:disabled){background-color:#009eeb;box-shadow:0 3px 6px rgba(0,0,0,.25),0 1px 3px rgba(0,0,0,.22)}.btn-primary:active{background-color:#007cb8!important;box-shadow:0 1px 3px rgba(0,0,0,.25),0 1px 1px rgba(0,0,0,.22)!important}.btn-fpl,.btn-fpl.active,.btn-fpl:active,.btn-fpl:focus,.btn-fpl:hover,.open .dropdown-toggle.btn-fpl{color:#fff;background-color:#007fd8;border-color:#005ea0}.btn-fpl.active,.btn-fpl:active,.open .dropdown-toggle.btn-fpl{background-image:none}.btn-fpl.disabled,.btn-fpl.disabled.active,.btn-fpl.disabled:active,.btn-fpl.disabled:focus,.btn-fpl.disabled:hover,.btn-fpl[disabled],.btn-fpl[disabled].active,.btn-fpl[disabled]:active,.btn-fpl[disabled]:focus,.btn-fpl[disabled]:hover,fieldset[disabled] .btn-fpl,fieldset[disabled] .btn-fpl.active,fieldset[disabled] .btn-fpl:active,fieldset[disabled] .btn-fpl:focus,fieldset[disabled] .btn-fpl:hover{background-color:#6c9ec2;border-color:#337ab7;color:#e2f0fb}.btn-fpl .badge{color:#005ea0;background-color:#fff}.btn-trueview,.btn-trueview:focus{outline:none;transition:all .1s ease-in;color:#faf9f3;background-color:transparent;border-color:transparent}.btn-trueview.active,.btn-trueview:active,.btn-trueview:hover,.open .dropdown-toggle.btn-trueview{color:#06141b;background-color:#faf9f3;border-color:#06141b}.btn-trueview.active,.btn-trueview:active,.open .dropdown-toggle.btn-trueview{background-image:none}.btn-trueview.disabled,.btn-trueview.disabled.active,.btn-trueview.disabled:active,.btn-trueview.disabled:focus,.btn-trueview.disabled:hover,.btn-trueview[disabled],.btn-trueview[disabled].active,.btn-trueview[disabled]:active,.btn-trueview[disabled]:focus,.btn-trueview[disabled]:hover,fieldset[disabled] .btn-trueview,fieldset[disabled] .btn-trueview.active,fieldset[disabled] .btn-trueview:active,fieldset[disabled] .btn-trueview:focus,fieldset[disabled] .btn-trueview:hover{color:#ccc;background-color:transparent;border-color:transparent}.btn-trueview .badge{color:#bf7346;background-color:#fff}.cls-1{clip-path:url(#clip-cones)}.cls-2{opacity:.8}.cls-3{fill:#fff;stroke:transparent;font-size:27px;font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:400}.cls-4,.cls-5{fill:#ffb61a;stroke-linecap:square}.cls-5{stroke:#fff5f5;stroke-linejoin:bevel;stroke-width:3px}.cls-6,.cls-7{stroke:none}.cls-7{fill:#fff5f5}.cls-8{fill:none}.cls-9{fill:hsla(0,0%,100%,0)}g{pointer-events:bounding-box;cursor:pointer}g:hover{opacity:.8}.projects{max-height:calc(100vh - 200px);margin-top:-100px;padding:5px 15px;z-index:1000}.pad-bottom{padding-bottom:50px}.mCSB_inside>.mCSB_container{margin-right:30px;padding:0 5px}.projects--container{font-family:Oswald,Helvetica,Arial,sans-serif;max-width:90%;margin:0 5%}.projects--heading{font-size:5em;font-weight:200;color:#0397d7}.projects--subtext{font-weight:100;margin:25px 0}.projects--project{padding-top:28%;max-height:225px;min-height:225px;overflow:hidden;background-position:50%;border:3px solid transparent;background-repeat:no-repeat!important;background-size:90%!important;position:relative;cursor:pointer;transition:all .1s ease-in}.projects--project:hover{border:3px solid #0397d7}.projects--project:hover .project--background{transform:scale(1.1)}.projects--project:hover .project--overlay{opacity:1}.project--background,.project--overlay{position:absolute;top:0;bottom:0;right:0;left:0}.project--background{transition:transform .1s ease-in}.project--background img{height:100%;width:auto}.project--overlay{z-index:1000;transition:opacity .1s ease-in;background:rgba(0,0,0,.5);opacity:0}.project--body{z-index:1050;position:absolute;bottom:15px;left:15px;right:15px}.project--body h2{color:#fff;font-weight:600;line-height:1em;margin-bottom:0}.project--body p{color:#0397d7;font-weight:700;line-height:1.25em}.projects--logo{max-height:100px}.projects--logo--header{max-height:1em;margin-top:-15px}.projects--input{background:hsla(0,0%,100%,.25);border-bottom:0;padding:10px;justify-content:space-around;min-height:40px;font-weight:400;width:100%;text-align:justify;border-radius:0;color:#e9e9ec}#sliderSwitch{position:relative;left:calc(50% - 30px);width:60px;height:30px;top:-30px;display:inline-block;vertical-align:middle;text-align:center;background:rgba(0,0,0,.5);font-size:24px;cursor:pointer}#sliderSwitch :hover{font-size:26px}.hideSiteBanner{height:0!important;padding-bottom:0!important;bottom:0!important}.hideSiteBanner,.showSiteBanner{transition:height .1s ease-in-out}.showSiteBanner{color:#e9e9ec;width:100%;margin:0 auto;z-index:150}.showSiteBanner .siteBanner-wrapper{max-height:80px}.showSiteBanner .siteBanner-icon-wrapper-solar{background:#e9e9ec;display:flex;align-items:center;justify-content:center}.showSiteBanner .siteBanner-icon-wrapper-solar .icon-solar-site{color:#fff;font-size:8vw}.showSiteBanner .siteBanner-icon-wrapper-wind{background:#e9e9ec;display:flex;align-items:center;justify-content:center}.showSiteBanner .siteBanner-icon-wrapper-wind .icon-wind-site{color:#fff;font-size:8vw}.showSiteBanner .siteBanner-icon-wrapper-nuclear{background:#e9e9ec;display:flex;align-items:center;justify-content:center}.showSiteBanner .siteBanner-icon-wrapper-nuclear .icon-nuclear-site{color:#fff;font-size:8vw}.showSiteBanner .siteBanner-icon-wrapper-natural_gas{background:#e9e9ec;display:flex;align-items:center;justify-content:center}.showSiteBanner .siteBanner-icon-wrapper-natural_gas .icon-natural_gas-site{color:#fff;font-size:8vw}.showSiteBanner .siteBanner-icon-wrapper-fossils{background:#e9e9ec;display:flex;align-items:center;justify-content:center}.showSiteBanner .siteBanner-icon-wrapper-fossils .icon-fossils-site{color:#fff;font-size:8vw}.showSiteBanner .siteBanner-icon-wrapper-altalink{background:#e9e9ec;display:flex;align-items:center;justify-content:center}.showSiteBanner .siteBanner-icon-wrapper-altalink .icon-altalink-site{color:#fff;font-size:8vw}.showSiteBanner .siteBanner-details-wrapper{background:#363636;padding-top:5px;width:100%;overflow:hidden;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.showSiteBanner .siteBanner-details-wrapper .site-text{font-family:Oswald,Arial,Helvetica,sans-serif;width:95%;margin:0 auto;height:100%;padding-left:0!important;box-sizing:content-box}.showSiteBanner .siteBanner-details-wrapper .site-text li:first-child{font-weight:400;font-size:24px;list-style-type:none}.showSiteBanner .siteBanner-details-wrapper .site-text li:last-child{font-weight:100;list-style-type:none;font-size:14px}.showSiteBanner .siteBanner-details-wrapper .site-text h1,.showSiteBanner .siteBanner-details-wrapper .site-text h3{text-transform:uppercase;margin:0;font-family:Oswald,Arial,Helvetica,sans-serif}.showSiteBanner .siteBanner-details-wrapper .site-text h1{font-weight:700;font-size:28px}.showSiteBanner .siteBanner-details-wrapper .site-text h3{font-size:18px}@media screen and (max-width:1150px){.showSiteBanner .siteBanner-details-wrapper .site-text h1{font-size:28px}.showSiteBanner .siteBanner-details-wrapper .site-text h3{font-size:18px}}.showSiteBanner .siteBanner-media-solar{margin:0;padding:0}.showSiteBanner .siteBanner-media-solar .map-btn{height:100%;display:flex;justify-content:center;align-items:center}.showSiteBanner .siteBanner-media-solar .map-btn .fa-info:hover,.showSiteBanner .siteBanner-media-solar .map-btn .fa-play:hover{font-size:3.5em;color:#ffdf99}.showSiteBanner .siteBanner-media-solar .info-btn{cursor:pointer;background-color:#ffbe33}.showSiteBanner .siteBanner-media-solar .video-btn{cursor:pointer;background-color:#ffae00}.showSiteBanner .siteBanner-media-wind{margin:0;padding:0}.showSiteBanner .siteBanner-media-wind .map-btn{height:100%;display:flex;justify-content:center;align-items:center}.showSiteBanner .siteBanner-media-wind .map-btn .fa-info:hover,.showSiteBanner .siteBanner-media-wind .map-btn .fa-play:hover{font-size:3.5em;color:#ffdf99}.showSiteBanner .siteBanner-media-wind .info-btn{cursor:pointer;background-color:#ffbe33}.showSiteBanner .siteBanner-media-wind .video-btn{cursor:pointer;background-color:#ffae00}.showSiteBanner .siteBanner-media-nuclear{margin:0;padding:0}.showSiteBanner .siteBanner-media-nuclear .map-btn{height:100%;display:flex;justify-content:center;align-items:center}.showSiteBanner .siteBanner-media-nuclear .map-btn .fa-info:hover,.showSiteBanner .siteBanner-media-nuclear .map-btn .fa-play:hover{font-size:3.5em;color:#ffdf99}.showSiteBanner .siteBanner-media-nuclear .info-btn{cursor:pointer;background-color:#ffbe33}.showSiteBanner .siteBanner-media-nuclear .video-btn{cursor:pointer;background-color:#ffae00}.showSiteBanner .siteBanner-media-natural_gas{margin:0;padding:0}.showSiteBanner .siteBanner-media-natural_gas .map-btn{height:100%;display:flex;justify-content:center;align-items:center}.showSiteBanner .siteBanner-media-natural_gas .map-btn .fa-info:hover,.showSiteBanner .siteBanner-media-natural_gas .map-btn .fa-play:hover{font-size:3.5em;color:#ffdf99}.showSiteBanner .siteBanner-media-natural_gas .info-btn{cursor:pointer;background-color:#ffbe33}.showSiteBanner .siteBanner-media-natural_gas .video-btn{cursor:pointer;background-color:#ffae00}.showSiteBanner .siteBanner-media-fossils{margin:0;padding:0}.showSiteBanner .siteBanner-media-fossils .map-btn{height:100%;display:flex;justify-content:center;align-items:center}.showSiteBanner .siteBanner-media-fossils .map-btn .fa-info:hover,.showSiteBanner .siteBanner-media-fossils .map-btn .fa-play:hover{font-size:3.5em;color:#ffdf99}.showSiteBanner .siteBanner-media-fossils .info-btn{cursor:pointer;background-color:#ffbe33}.showSiteBanner .siteBanner-media-fossils .video-btn{cursor:pointer;background-color:#ffae00}.showSiteBanner .siteBanner-media-altalink{margin:0;padding:0}.showSiteBanner .siteBanner-media-altalink .map-btn{height:100%;display:flex;justify-content:center;align-items:center}.showSiteBanner .siteBanner-media-altalink .map-btn .fa-info:hover,.showSiteBanner .siteBanner-media-altalink .map-btn .fa-play:hover{font-size:3.5em;color:#ffdf99}.showSiteBanner .siteBanner-media-altalink .info-btn{cursor:pointer;background-color:#ffbe33}.showSiteBanner .siteBanner-media-altalink .video-btn{cursor:pointer;background-color:#ffae00}.showSiteBanner .banner-truescape{background-color:#e9e9ec;padding:20px;display:flex;align-items:center;justify-content:center}.showSiteBanner .banner-truescape img{max-width:50%}.tooltip.tooltip-solar .tooltip-inner{text-transform:capitalize;letter-spacing:1px;color:#f0f0f0;background-color:rgba(26,26,26,.5);border-bottom:3px solid #ffb61a}.tooltip-solar .tooltip-arrow{border-top-color:#ffb61a!important}.tooltip.tooltip-wind .tooltip-inner{text-transform:capitalize;letter-spacing:1px;color:#f0f0f0;background-color:rgba(26,26,26,.5);border-bottom:3px solid #ffb61a}.tooltip-wind .tooltip-arrow{border-top-color:#ffb61a!important}.tooltip.tooltip-nuclear .tooltip-inner{text-transform:capitalize;letter-spacing:1px;color:#f0f0f0;background-color:rgba(26,26,26,.5);border-bottom:3px solid #ffb61a}.tooltip-nuclear .tooltip-arrow{border-top-color:#ffb61a!important}.tooltip.tooltip-natural_gas .tooltip-inner{text-transform:capitalize;letter-spacing:1px;color:#f0f0f0;background-color:rgba(26,26,26,.5);border-bottom:3px solid #ffb61a}.tooltip-natural_gas .tooltip-arrow{border-top-color:#ffb61a!important}.tooltip.tooltip-fossils .tooltip-inner{text-transform:capitalize;letter-spacing:1px;color:#f0f0f0;background-color:rgba(26,26,26,.5);border-bottom:3px solid #ffb61a}.tooltip-fossils .tooltip-arrow{border-top-color:#ffb61a!important}.tooltip.tooltip-altalink .tooltip-inner{text-transform:capitalize;letter-spacing:1px;color:#f0f0f0;background-color:rgba(26,26,26,.5);border-bottom:3px solid #ffb61a}.tooltip-altalink .tooltip-arrow{border-top-color:#ffb61a!important}div.siteLayers{position:relative;padding:0;margin:0 auto;height:100%}div.siteLayers .background{z-index:50;max-width:100%}div.siteLayers .overlay{position:absolute;z-index:100;max-width:100%;width:100%;top:0;left:0;right:0}div.siteLayers .overlay svg{max-width:100%}div.siteLayers .overlay svg g>rect{stroke:none;cursor:default}div.siteLayers .overlay svg g[id^=Animation_],div.siteLayers .overlay svg g[id^=Cone_],div.siteLayers .overlay svg g[id^=Layer_]{cursor:pointer;pointer-events:all}div.siteLayers .overlay svg g[id^=Animation_] *,div.siteLayers .overlay svg g[id^=Cone_] *,div.siteLayers .overlay svg g[id^=Layer_] *{transition:all .1s ease-in}div.siteLayers .overlay svg g[id^=Animation_].pathTarget>path,div.siteLayers .overlay svg g[id^=Cone_].pathTarget>path,div.siteLayers .overlay svg g[id^=Layer_].pathTarget>path{stroke:#fff}div.siteLayers .overlay svg g[id^=Animation_] path[class*=viewpoint],div.siteLayers .overlay svg g[id^=Cone_] path[class*=viewpoint],div.siteLayers .overlay svg g[id^=Layer_] path[class*=viewpoint]{fill:#3e83a7;stroke-width:11px}div.siteLayers .overlay svg g[id^=Animation_]:hover.pathTarget>path,div.siteLayers .overlay svg g[id^=Cone_]:hover.pathTarget>path,div.siteLayers .overlay svg g[id^=Layer]:hover.pathTarget>path{stroke:#fff;stroke-width:15px}div.siteLayers .overlay svg g[id^=Animation_]:hover path[class*=site],div.siteLayers .overlay svg g[id^=Cone_]:hover path[class*=site],div.siteLayers .overlay svg g[id^=Layer]:hover path[class*=site]{fill:#448cd7}.svg-clickable{pointer-events:all}a:hover{fill:pink;stroke:red;stroke-width:.5;cursor:pointer}.tooltip.map-popover .tooltip-inner{color:#e9e9ec;font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:100;font-size:16px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-submenu{position:relative}.dropdown-submenu>.dropdown-menu{bottom:-8px;left:100%}.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu>a:after{display:block;content:\" \";float:right;width:0;height:0;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;border-left-color:#e9e9ec;margin-top:20px;margin-right:-10px}.dropdown-submenu>a:hover:after{border-left-color:#262626!important}.dropdown-menu{background:#e65400!important;border-radius:0!important}.dropdown-menu li>a{padding:0 20px!important}.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background:#e65400!important}.video-main-menu{height:50px!important;line-height:50px!important;color:#e9e9ec!important}.video-main-menu:hover{cursor:pointer!important;color:#262626!important}.post-example{color:#363636;text-align:center;font-family:Oswald,Helvetica,Arial,sans-serif;font-size:18px}.showSiteBanner .siteBanner-media-altalink .info-btn:hover{background-color:#4f4f4f}.showSiteBanner .siteBanner-media-altalink .info-btn:hover span{color:#ffb61a}.site-trueviewView{padding:20px 15px 5px;color:#f0f0f0}.map-marker-icon{float:left;margin-right:10px}.map-marker-icon.large{font-size:5em;margin-right:20px}.viewpoint-site-icon-container{text-align:center;height:100%;margin-right:30px;display:inline-block}.viewpoint-site-description-container{transform:translateY(45%)}.viewpoint-site-description-container i{margin-left:100px}.icon-fossils-viewpoint,.icon-natural_gas-viewpoint,.icon-nuclear-viewpoint,.icon-solar-viewpoint,.icon-wind-viewpoint{font-size:10em;color:#ffb61a}.viewpoint-site-icon-container span{background:#fff}.viewpoint-site-icon-container img{background:#ffb61a}.icon-altalink-viewpoint{font-size:10em;color:#ffb61a}.current-trueview{color:#ffb61a}.current-trueview *{font-size:1.2em;font-weight:700}.current-trueview h5{margin-top:-3px}.current-trueview i{margin-left:-2px;font-size:1.25em}.juxtapose-container{max-height:0;overflow:hidden;transition:max-height .5s ease-in}.juxtapose-container.invisible{height:0}.site-description .h1,.site-description .h2,.site-description .h3,.site-description .h4,.site-description .h5,.site-description h1,.site-description h2,.site-description h3,.site-description h4,.site-description h5{font-family:Oswald,Arial,Helvetica,sans-serif;display:inline;text-transform:uppercase}.site-description h4{font-weight:200}.list-inline .h1,.list-inline .h2,.list-inline .h3,.list-inline .h4,.list-inline .h5,.list-inline h1,.list-inline h2,.list-inline h3,.list-inline h4,.list-inline h5{display:inline;text-transform:uppercase}.list-inline h4{font-weight:200}.zoom-container{position:relative}.zoom-container,.zoom-container .openseadragon-container{min-height:500px}.zoom-container div.magnification-factor{position:absolute;top:0;right:0;z-index:1050}.zoom-container div.magnification-factor .magnification-number{padding:15px;min-width:175px;text-shadow:0 0 1px #000}.zoom-container div.magnification-factor .magnification-number h1{font-size:48px;line-height:48px;font-weight:400}.zoom-container div.magnification-factor .magnification-number h1 span{font-size:32px}.zoom-container div.toggle-switch{position:absolute;bottom:0;right:0}.zoom-container div.toggle-switch .before-after-switch{padding:25px;text-shadow:0 0 1px #000}.zoom-container div.toggle-switch .before-after-switch p{float:left;margin:0 15px;line-height:32px;font-weight:700}a.jx-knightlab{display:none!important}.zoomed-juxta{overflow:hidden;width:100%;opacity:1;max-height:0}.canvas-overlay-box{position:absolute;bottom:25px;right:25px;z-index:999999}.canvas-overlay-box .reset-zoom-button{margin-right:25px}.canvas-overlay-box .exit-fullscreen-button{margin-left:25px}.canvas-overlay-box label{margin:auto 15px;font-size:2em;color:#fff}[id^=navigator-].navigator{margin:2em!important;z-index:999999}[id^=navigator-][id$=displayregion]{border:2px solid #fff!important}.full-screen-disclaimer{position:absolute;color:#fff;top:25px;right:0;left:0;z-index:999999}.full-screen-disclaimer .container{margin:25px auto}.full-screen-disclaimer .disclaimer{background:rgba(0,0,0,.5);padding:15px;border-radius:5px}.full-screen-disclaimer h1{text-align:center;text-shadow:0 0 1px 1px #000}div.jx-controller{position:absolute;margin:auto;top:90%;bottom:0;height:18px;width:180px;margin-left:-90px;font-size:10pt;border-radius:3px;background-color:#000;color:#fff;opacity:.5}div.jx-controller:after,div.jx-controller:before{position:absolute;text-transform:uppercase}div.jx-control{height:100%;margin-right:auto;margin-left:auto;width:3px;background-color:#fff}.trueviews-list{text-align:center;color:#999}.trueviews-list .trueview-item{margin:5px 0;cursor:pointer}.trueviews-list .trueview-item span{text-transform:uppercase}.trueview-solar{border-top:5px solid #ffb61a;border-bottom:5px solid #ffb61a}.trueview-btn-solar{background-color:#ffb61a;color:#f0f0f0;display:block;cursor:pointer;padding-top:10px;border-radius:0;margin:20px auto 0;width:180px;height:50px;font-size:16pt;text-decoration:none;text-transform:uppercase}.trueview-btn-solar:hover{background:#f0f0f0;color:#ffb61a}.trueview-wind{border-top:5px solid #ffb61a;border-bottom:5px solid #ffb61a}.trueview-btn-wind{background-color:#ffb61a;color:#f0f0f0;display:block;cursor:pointer;padding-top:10px;border-radius:0;margin:20px auto 0;width:180px;height:50px;font-size:16pt;text-decoration:none;text-transform:uppercase}.trueview-btn-wind:hover{background:#f0f0f0;color:#ffb61a}.trueview-nuclear{border-top:5px solid #ffb61a;border-bottom:5px solid #ffb61a}.trueview-btn-nuclear{background-color:#ffb61a;color:#f0f0f0;display:block;cursor:pointer;padding-top:10px;border-radius:0;margin:20px auto 0;width:180px;height:50px;font-size:16pt;text-decoration:none;text-transform:uppercase}.trueview-btn-nuclear:hover{background:#f0f0f0;color:#ffb61a}.trueview-natural_gas{border-top:5px solid #ffb61a;border-bottom:5px solid #ffb61a}.trueview-btn-natural_gas{background-color:#ffb61a;color:#f0f0f0;display:block;cursor:pointer;padding-top:10px;border-radius:0;margin:20px auto 0;width:180px;height:50px;font-size:16pt;text-decoration:none;text-transform:uppercase}.trueview-btn-natural_gas:hover{background:#f0f0f0;color:#ffb61a}.trueview-fossils{border-top:5px solid #ffb61a;border-bottom:5px solid #ffb61a}.trueview-btn-fossils{background-color:#ffb61a;color:#f0f0f0;display:block;cursor:pointer;padding-top:10px;border-radius:0;margin:20px auto 0;width:180px;height:50px;font-size:16pt;text-decoration:none;text-transform:uppercase}.trueview-btn-fossils:hover{background:#f0f0f0;color:#ffb61a}.trueview-altalink{border-top:5px solid #ffb61a;border-bottom:5px solid #ffb61a}.trueview-btn-altalink{background-color:#ffb61a;color:#f0f0f0;display:block;cursor:pointer;padding-top:10px;border-radius:0;margin:20px auto 0;width:180px;height:50px;font-size:16pt;text-decoration:none;text-transform:uppercase}.trueview-btn-altalink:hover{background:#f0f0f0;color:#ffb61a}div.tv-tech{margin-top:5px}.switch.highlight.checked{background:#ffb61a;border-color:#ffb61a}.switch.highlight{background:#999;border:1px solid #999;box-shadow:inset 0 0 0 0 #999}.switch.highlight small:hover{background-color:#d3d3d3;border-color:#e65400}.highlight-text{font-weight:400;color:#999;text-transform:uppercase}.highlight-btn-wrapper{transform:translateY(22%)}.tooltip.viewpoint-popover .tooltip-inner{color:#363636;background:hsla(240,7%,92%,.9);font-family:Oswald,Arial,Helvetica,sans-serif;font-weight:100;font-size:16px;box-shadow:0 6px 12px 0 #ffb61a,0,0,.175;min-width:500px;padding:10px;position:relative;margin-bottom:10px}.tooltip.viewpoint-popover .tooltip-arrow{border-top-color:transparent!important}.info-text{color:#e9e9ec;position:absolute;bottom:25px}.info-text p{display:inline-block;font-size:18px}.distance-text{margin-top:-10px;margin-bottom:25px;color:#e9e9ec}@keyframes imageBlur{0%{-webkit-filter:blur(5px)}50%{-webkit-filter:blur 2 px}to{-webkit-filter:blur 0 px}}.blur{filter:blur(5px)}.img-show{display:block;animation-name:imageBlur;animation-duration:1.5s}.img-hide{display:none}.site-popover-img{max-width:100%;min-height:145px}.popover-container{max-width:100%!important}.popover{max-width:520px;border:2px solid teal}.popover .arrow{display:none}.modal.calibration .modal-dialog .modal-content .modal-body .credit-card.outlined{border-radius:8px}.modal-title-map{font-weight:700;font-size:24px}.map-legend li,.modal-title-map{font-family:Oswald,Arial,Helvetica,sans-serif}.map-legend li{list-style-type:none;font-weight:100;font-size:16px}.map-legend-close-btn{cursor:pointer}.map-legend-close-btn:hover{color:#ffd780}.modal-header--legend{background-color:#ffb61a;color:#e9e9ec}.modal{color:#444}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}.loader.ng-animate{animation:none 0s}.modal-body.site-popup{position:relative;padding:0;overflow:hidden;color:#444}.modal-body.site-popup .close{position:absolute;top:10px;right:10px;text-shadow:0 0 1px 1px #000;color:#fff;opacity:.75;z-index:1050;transition:all .2s}.modal-body.site-popup .close:hover{opacity:1;transform:scale(1.1)}.modal-body.site-popup .modal-text{position:relative;text-align:center;padding:0 30px 20px}.modal-body.site-popup .modal-text .site-btn{display:block;cursor:pointer;position:relative;padding-top:10px;border-radius:3px;top:-25px;margin:0 auto;width:180px;height:50px;font-size:16pt;text-decoration:none}.modal-body.site-popup .modal-text .modal-title{text-transform:uppercase;font-weight:700}.modal-body.site-popup.sector-solar{border-color:#ffb61a}.modal-body.site-popup.sector-solar i{color:#ffb61a}.modal-body.site-popup.sector-solar .modal-text{border-bottom:10px solid #ffb61a}.modal-body.site-popup.sector-solar .site-btn{background:#ffb61a;color:#1a1100}.modal-body.site-popup.sector-solar .site-btn:hover{background:#e69d00;color:#ffdf99;box-shadow:0 0 3px #1a1100}.modal-body.site-popup.sector-solar .site-btn:active{box-shadow:inset 0 0 3px #1a1100}.modal-body.site-popup.sector-wind{border-color:#ffb61a}.modal-body.site-popup.sector-wind i{color:#ffb61a}.modal-body.site-popup.sector-wind .modal-text{border-bottom:10px solid #ffb61a}.modal-body.site-popup.sector-wind .site-btn{background:#ffb61a;color:#1a1100}.modal-body.site-popup.sector-wind .site-btn:hover{background:#e69d00;color:#ffdf99;box-shadow:0 0 3px #1a1100}.modal-body.site-popup.sector-wind .site-btn:active{box-shadow:inset 0 0 3px #1a1100}.modal-body.site-popup.sector-nuclear{border-color:#ffb61a}.modal-body.site-popup.sector-nuclear i{color:#ffb61a}.modal-body.site-popup.sector-nuclear .modal-text{border-bottom:10px solid #ffb61a}.modal-body.site-popup.sector-nuclear .site-btn{background:#ffb61a;color:#1a1100}.modal-body.site-popup.sector-nuclear .site-btn:hover{background:#e69d00;color:#ffdf99;box-shadow:0 0 3px #1a1100}.modal-body.site-popup.sector-nuclear .site-btn:active{box-shadow:inset 0 0 3px #1a1100}.modal-body.site-popup.sector-natural_gas{border-color:#ffb61a}.modal-body.site-popup.sector-natural_gas i{color:#ffb61a}.modal-body.site-popup.sector-natural_gas .modal-text{border-bottom:10px solid #ffb61a}.modal-body.site-popup.sector-natural_gas .site-btn{background:#ffb61a;color:#1a1100}.modal-body.site-popup.sector-natural_gas .site-btn:hover{background:#e69d00;color:#ffdf99;box-shadow:0 0 3px #1a1100}.modal-body.site-popup.sector-natural_gas .site-btn:active{box-shadow:inset 0 0 3px #1a1100}.modal-body.site-popup.sector-fossils{border-color:#ffb61a}.modal-body.site-popup.sector-fossils i{color:#ffb61a}.modal-body.site-popup.sector-fossils .modal-text{border-bottom:10px solid #ffb61a}.modal-body.site-popup.sector-fossils .site-btn{background:#ffb61a;color:#1a1100}.modal-body.site-popup.sector-fossils .site-btn:hover{background:#e69d00;color:#ffdf99;box-shadow:0 0 3px #1a1100}.modal-body.site-popup.sector-fossils .site-btn:active{box-shadow:inset 0 0 3px #1a1100}.modal-body.site-popup.sector-altalink{border-color:#ffb61a}.modal-body.site-popup.sector-altalink i{color:#ffb61a}.modal-body.site-popup.sector-altalink .modal-text{border-bottom:10px solid #ffb61a}.modal-body.site-popup.sector-altalink .site-btn{background:#ffb61a;color:#1a1100}.modal-body.site-popup.sector-altalink .site-btn:hover{background:#e69d00;color:#ffdf99;box-shadow:0 0 3px #1a1100}.modal-body.site-popup.sector-altalink .site-btn:active{box-shadow:inset 0 0 3px #1a1100}.modal-body .site-img-container{overflow:hidden;min-height:25rem}.modal-body .site-img-container .site-img,.modal-body .site-img-container img.blur{max-width:100%;min-width:100%;transition:all .2s}.modal-body .site-img-container .site-img{animation:kenburns 45s}@keyframes kenburns{0%{transform:scale(1)}50%{transform:scale(1.25)}to{transform:scale(1)}}.modal-body.viewpoint-modal-body{background:#eee}p.drop-text--top{margin:10px 0 0}p.drop-text--middle{margin:3px 0}p.drop-text--bottom{margin:0}.home .info-modal .modal-dialog{float:right}.home .in{background:none!important}.home .calibration.in{background:rgba(26,26,26,.75)!important}.pos-relative{position:relative}.modal.calibration .modal-dialog .modal-content{padding:30px;min-height:50%}.modal.calibration .modal-dialog .modal-content .modal-body .modal-title{text-align:center}.modal.calibration .modal-dialog .modal-content .modal-body .monitor-size{display:inline-block;margin:0 auto;padding:20px;border:3px solid #444;border-radius:4px;color:#444}.modal.calibration .modal-dialog .modal-content .modal-body .monitor-size h1{font-size:4em}.modal.calibration .modal-dialog .modal-content .modal-body .monitor-size h4{text-transform:uppercase}.modal.calibration .modal-dialog .modal-content .modal-body .credit-card{position:relative;margin:0 auto;max-width:100%;background:url(\"/assets/images/gift-card.png\");background-size:cover;opacity:.5}.modal.calibration .modal-dialog .modal-content .modal-body .credit-card .dot{opacity:1;position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);margin:0 auto;width:50px;height:50px;border-radius:100%;background:red}.modal.calibration .modal-dialog .modal-content .modal-body .credit-card.outlined{border:4px dashed #005ea0;border-radius:15px}.modal.calibration .modal-dialog .modal-content .modal-footer{border:none;padding:0;padding-top:15px}label.size-label{line-height:55px;height:30px}.rzslider .rz-pointer{top:-14px;z-index:3;width:32px;height:32px;cursor:pointer;background-color:#008dd1!important;border-radius:16px;outline:6px solid #fff;transition:background-color .1s ease-in,outline .1s ease-in}.rzslider .rz-pointer:hover{outline:3px solid #fff!important;background-color:#009eeb!important}.rzslider .rz-pointer:after{position:absolute;top:4px!important;left:4px!important;width:24px!important;height:24px!important;background:#fff!important;border-radius:100%!important;content:\"\"}.spacer-10{margin:5px}.spacer-20{margin:10px}.spacer-30{margin:15px}.spacer-40{margin:20px}.spacer-50{margin:25px}.modal-header--danger,.modal-header--warning{color:#fff}.modal-header--danger{background:#d4403a}.modal-header--warning{background:#efac4d}.modal-title-video{font-weight:700;font-size:24px}.btn-altalink-video,.modal-title-video{font-family:Oswald,Arial,Helvetica,sans-serif}.btn-altalink-video{background-color:#ffb61a;color:#e9e9ec;border-radius:0}.btn-altalink-video:hover{background-color:#e9e9ec;color:#ffb61a;border:1px solid #ffb61a}.modal-body-video{min-height:524.25px;position:relative}.video-overlay{position:absolute;top:0;left:0;width:100%;min-height:524.25px;z-index:10;background-color:hsla(0,0%,100%,0)}.btn-video-years{border-radius:0}.navbar-default{font-family:Oswald,Arial,Helvetica,sans-serif;font-size:16px;border:none;padding:25px;transition:all .15s ease-in-out;background:transparent}.map .sector-menu{display:block}.navbar-item{font-size:1em;font-family:Oswald,Arial,Helvetica,sans-serif}.active .navbar-item{font-weight:700!important}.sector-menu{display:none;position:fixed;left:0;margin:0 auto;z-index:125}@media screen and (min-width:1150px){.sector-menu{right:0;bottom:0}}@media screen and (max-width:1150px){.sector-menu{right:auto;bottom:25px}}.sector-menu p{padding-top:7px}.sector-menu .sector-item{display:inline}@media screen and (max-width:1150px){.sector-menu .sector-item{display:block;margin-bottom:3px}.sector-menu .sector-item:last-child{margin-bottom:0}}.sector-menu .sector-item .btn-sector{margin:0;border-radius:0;padding:10px 15px;vertical-align:bottom;border-width:0 0 3px;background-color:rgba(0,0,0,.5);border-color:hsla(0,0%,100%,.25);min-width:150px;text-align:center;text-transform:uppercase;transition:all .2s;-webkit-transition:all .2s;-moz-transition:all .2s}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector{border-width:0 0 0 3px;min-width:200px}}.sector-menu .sector-item .btn-sector .map-navbar-sector-icon{transition:all .2s;max-width:35px;filter:gray;filter:grayscale(1)}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector .map-navbar-sector-icon{font-size:3em;float:left}}.sector-menu .sector-item .btn-sector.active,.sector-menu .sector-item .btn-sector:active,.sector-menu .sector-item .btn-sector:hover,.sector-menu .sector-item .open .dropdown-toggle.btn-sector{background-image:none;border-width:0 0 6px}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active,.sector-menu .sector-item .btn-sector:active,.sector-menu .sector-item .btn-sector:hover,.sector-menu .sector-item .open .dropdown-toggle.btn-sector{border-width:0 0 0 6px}}.sector-menu .sector-item .btn-sector.active.solar.active,.sector-menu .sector-item .btn-sector:active.solar.active,.sector-menu .sector-item .btn-sector:hover.solar.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.solar.active{border-color:#ffb61a}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active.solar.active,.sector-menu .sector-item .btn-sector:active.solar.active,.sector-menu .sector-item .btn-sector:hover.solar.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.solar.active{width:105%}}.sector-menu .sector-item .btn-sector.active.wind.active,.sector-menu .sector-item .btn-sector:active.wind.active,.sector-menu .sector-item .btn-sector:hover.wind.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.wind.active{border-color:#ffb61a}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active.wind.active,.sector-menu .sector-item .btn-sector:active.wind.active,.sector-menu .sector-item .btn-sector:hover.wind.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.wind.active{width:105%}}.sector-menu .sector-item .btn-sector.active.nuclear.active,.sector-menu .sector-item .btn-sector:active.nuclear.active,.sector-menu .sector-item .btn-sector:hover.nuclear.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.nuclear.active{border-color:#ffb61a}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active.nuclear.active,.sector-menu .sector-item .btn-sector:active.nuclear.active,.sector-menu .sector-item .btn-sector:hover.nuclear.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.nuclear.active{width:105%}}.sector-menu .sector-item .btn-sector.active.natural_gas.active,.sector-menu .sector-item .btn-sector:active.natural_gas.active,.sector-menu .sector-item .btn-sector:hover.natural_gas.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.natural_gas.active{border-color:#ffb61a}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active.natural_gas.active,.sector-menu .sector-item .btn-sector:active.natural_gas.active,.sector-menu .sector-item .btn-sector:hover.natural_gas.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.natural_gas.active{width:105%}}.sector-menu .sector-item .btn-sector.active.fossils.active,.sector-menu .sector-item .btn-sector:active.fossils.active,.sector-menu .sector-item .btn-sector:hover.fossils.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.fossils.active{border-color:#ffb61a}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active.fossils.active,.sector-menu .sector-item .btn-sector:active.fossils.active,.sector-menu .sector-item .btn-sector:hover.fossils.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.fossils.active{width:105%}}.sector-menu .sector-item .btn-sector.active.altalink.active,.sector-menu .sector-item .btn-sector:active.altalink.active,.sector-menu .sector-item .btn-sector:hover.altalink.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.altalink.active{border-color:#ffb61a}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active.altalink.active,.sector-menu .sector-item .btn-sector:active.altalink.active,.sector-menu .sector-item .btn-sector:hover.altalink.active,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.altalink.active{width:105%}}.sector-menu .sector-item .btn-sector.active .map-navbar-sector-icon,.sector-menu .sector-item .btn-sector:active .map-navbar-sector-icon,.sector-menu .sector-item .btn-sector:hover .map-navbar-sector-icon,.sector-menu .sector-item .open .dropdown-toggle.btn-sector .map-navbar-sector-icon{max-width:55px;font-size:5em}@media screen and (max-width:1150px){.sector-menu .sector-item .btn-sector.active .map-navbar-sector-icon,.sector-menu .sector-item .btn-sector:active .map-navbar-sector-icon,.sector-menu .sector-item .btn-sector:hover .map-navbar-sector-icon,.sector-menu .sector-item .open .dropdown-toggle.btn-sector .map-navbar-sector-icon{font-size:3em;margin-right:20px}}.sector-menu .sector-item .btn-sector.active.active>.map-navbar-sector-icon,.sector-menu .sector-item .btn-sector.active.active>.map-sector-altalink,.sector-menu .sector-item .btn-sector.active.active>.map-sector-fossils,.sector-menu .sector-item .btn-sector.active.active>.map-sector-natural_gas,.sector-menu .sector-item .btn-sector.active.active>.map-sector-nuclear,.sector-menu .sector-item .btn-sector.active.active>.map-sector-solar,.sector-menu .sector-item .btn-sector.active.active>.map-sector-wind,.sector-menu .sector-item .btn-sector:active.active>.map-navbar-sector-icon,.sector-menu .sector-item .btn-sector:active.active>.map-sector-altalink,.sector-menu .sector-item .btn-sector:active.active>.map-sector-fossils,.sector-menu .sector-item .btn-sector:active.active>.map-sector-natural_gas,.sector-menu .sector-item .btn-sector:active.active>.map-sector-nuclear,.sector-menu .sector-item .btn-sector:active.active>.map-sector-solar,.sector-menu .sector-item .btn-sector:active.active>.map-sector-wind,.sector-menu .sector-item .btn-sector:hover.active>.map-navbar-sector-icon,.sector-menu .sector-item .btn-sector:hover.active>.map-sector-altalink,.sector-menu .sector-item .btn-sector:hover.active>.map-sector-fossils,.sector-menu .sector-item .btn-sector:hover.active>.map-sector-natural_gas,.sector-menu .sector-item .btn-sector:hover.active>.map-sector-nuclear,.sector-menu .sector-item .btn-sector:hover.active>.map-sector-solar,.sector-menu .sector-item .btn-sector:hover.active>.map-sector-wind,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-navbar-sector-icon,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-sector-altalink,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-sector-fossils,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-sector-natural_gas,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-sector-nuclear,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-sector-solar,.sector-menu .sector-item .open .dropdown-toggle.btn-sector.active>.map-sector-wind{filter:none;-webkit-filter:grayscale(0)}.navbar-default .navbar-brand{padding:8px;margin-left:0!important}.navbar-default .navbar-brand>img{max-height:65px;margin-top:-10px}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{background:transparent}.navbar-default .navbar-back{float:left;font-size:35px;line-height:35px;margin:5px 15px 5px 0;cursor:pointer}.navbar-default .navbar-back:hover{margin:5px 16px 5px -1px}.navbar-padding{padding-top:100px}@font-face{font-family:icomoon;src:url(\"/assets/font-icons/icomoon.eot?1jk0mn\");src:url(\"/assets/font-icons/icomoon.eot?1jk0mn#iefix\") format(\"embedded-opentype\"),url(\"/assets/font-icons/icomoon.ttf?1jk0mn\") format(\"truetype\"),url(\"/assets/font-icons/icomoon.woff?1jk0mn\") format(\"woff\"),url(\"/assets/font-icons/icomoon.svg?1jk0mn#icomoon\") format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:icomoon!important;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-fossils:before{content:\"\\E900\"}.icon-natural_gas:before{content:\"\\E901\"}.icon-nuclear:before{content:\"\\E902\"}.icon-solar:before{content:\"\\E903\"}.icon-wind:before{content:\"\\E904\"}.icon-fossils-hover:before{content:\"\\E905\"}.icon-natural_gas-hover:before{content:\"\\E906\"}.icon-nuclear-hover:before{content:\"\\E907\"}.icon-solar-hover:before{content:\"\\E908\"}.icon-wind-hover:before{content:\"\\E909\"}.icon-fossils-viewpoint:before{content:\"\\E90A\"}.icon-natural_gas-viewpoint:before{content:\"\\E90B\"}.icon-nuclear-viewpoint:before{content:\"\\E90C\"}.icon-solar-viewpoint:before{content:\"\\E90D\"}.icon-wind-viewpoint:before{content:\"\\E90E\"}.icon-navbar-fossils:before{content:\"\\E90F\"}.icon-navbar-natural_gas:before{content:\"\\E910\"}.icon-navbar-nuclear:before{content:\"\\E911\"}.icon-navbar-solar:before{content:\"\\E912\"}.icon-navbar-wind:before{content:\"\\E913\"}.icon-fossils-site:before{content:\"\\E914\"}.icon-natural_gas-site:before{content:\"\\E915\"}.icon-nuclear-site:before{content:\"\\E916\"}.icon-solar-site:before{content:\"\\E917\"}.icon-wind-site:before{content:\"\\E918\"}", ""]);
	
	// exports


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, ".container,.container-fluid{margin-right:auto;margin-left:auto}.container-fluid{padding-right:2rem;padding-left:2rem}.row{box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex:0 1 auto;flex:0 1 auto;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-.5rem;margin-left:-.5rem}.row.reverse{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.col.reverse{-ms-flex-direction:column-reverse;flex-direction:column-reverse}.col-xs,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-offset-0,.col-xs-offset-1,.col-xs-offset-2,.col-xs-offset-3,.col-xs-offset-4,.col-xs-offset-5,.col-xs-offset-6,.col-xs-offset-7,.col-xs-offset-8,.col-xs-offset-9,.col-xs-offset-10,.col-xs-offset-11,.col-xs-offset-12{box-sizing:border-box;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.5rem;padding-left:.5rem}.col-xs{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-xs-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}.col-xs-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.col-xs-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xs-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}.col-xs-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}.col-xs-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xs-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}.col-xs-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}.col-xs-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xs-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}.col-xs-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}.col-xs-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-11{margin-left:91.66666667%}.start-xs{-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-xs{-ms-flex-pack:center;justify-content:center;text-align:center}.end-xs{-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-xs{-ms-flex-align:start;align-items:flex-start}.middle-xs{-ms-flex-align:center;align-items:center}.bottom-xs{-ms-flex-align:end;align-items:flex-end}.around-xs{-ms-flex-pack:distribute;justify-content:space-around}.between-xs{-ms-flex-pack:justify;justify-content:space-between}.first-xs{-ms-flex-order:-1;order:-1}.last-xs{-ms-flex-order:1;order:1}@media only screen and (min-width:48em){.container{width:49rem}.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-offset-0,.col-sm-offset-1,.col-sm-offset-2,.col-sm-offset-3,.col-sm-offset-4,.col-sm-offset-5,.col-sm-offset-6,.col-sm-offset-7,.col-sm-offset-8,.col-sm-offset-9,.col-sm-offset-10,.col-sm-offset-11,.col-sm-offset-12{box-sizing:border-box;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.5rem;padding-left:.5rem}.col-sm{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-sm-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}.col-sm-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.col-sm-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-sm-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}.col-sm-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}.col-sm-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-sm-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}.col-sm-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}.col-sm-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-sm-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}.col-sm-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}.col-sm-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-11{margin-left:91.66666667%}.start-sm{-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-sm{-ms-flex-pack:center;justify-content:center;text-align:center}.end-sm{-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-sm{-ms-flex-align:start;align-items:flex-start}.middle-sm{-ms-flex-align:center;align-items:center}.bottom-sm{-ms-flex-align:end;align-items:flex-end}.around-sm{-ms-flex-pack:distribute;justify-content:space-around}.between-sm{-ms-flex-pack:justify;justify-content:space-between}.first-sm{-ms-flex-order:-1;order:-1}.last-sm{-ms-flex-order:1;order:1}}@media only screen and (min-width:64em){.container{width:65rem}.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-offset-0,.col-md-offset-1,.col-md-offset-2,.col-md-offset-3,.col-md-offset-4,.col-md-offset-5,.col-md-offset-6,.col-md-offset-7,.col-md-offset-8,.col-md-offset-9,.col-md-offset-10,.col-md-offset-11,.col-md-offset-12{box-sizing:border-box;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.5rem;padding-left:.5rem}.col-md{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-md-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}.col-md-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.col-md-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-md-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}.col-md-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}.col-md-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-md-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}.col-md-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}.col-md-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-md-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}.col-md-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}.col-md-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-11{margin-left:91.66666667%}.start-md{-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-md{-ms-flex-pack:center;justify-content:center;text-align:center}.end-md{-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-md{-ms-flex-align:start;align-items:flex-start}.middle-md{-ms-flex-align:center;align-items:center}.bottom-md{-ms-flex-align:end;align-items:flex-end}.around-md{-ms-flex-pack:distribute;justify-content:space-around}.between-md{-ms-flex-pack:justify;justify-content:space-between}.first-md{-ms-flex-order:-1;order:-1}.last-md{-ms-flex-order:1;order:1}}@media only screen and (min-width:75em){.container{width:76rem}.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-offset-0,.col-lg-offset-1,.col-lg-offset-2,.col-lg-offset-3,.col-lg-offset-4,.col-lg-offset-5,.col-lg-offset-6,.col-lg-offset-7,.col-lg-offset-8,.col-lg-offset-9,.col-lg-offset-10,.col-lg-offset-11,.col-lg-offset-12{box-sizing:border-box;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.5rem;padding-left:.5rem}.col-lg{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-lg-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}.col-lg-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.col-lg-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-lg-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}.col-lg-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}.col-lg-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-lg-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}.col-lg-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}.col-lg-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-lg-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}.col-lg-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}.col-lg-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-11{margin-left:91.66666667%}.start-lg{-ms-flex-pack:start;justify-content:flex-start;text-align:start}.center-lg{-ms-flex-pack:center;justify-content:center;text-align:center}.end-lg{-ms-flex-pack:end;justify-content:flex-end;text-align:end}.top-lg{-ms-flex-align:start;align-items:flex-start}.middle-lg{-ms-flex-align:center;align-items:center}.bottom-lg{-ms-flex-align:end;align-items:flex-end}.around-lg{-ms-flex-pack:distribute;justify-content:space-around}.between-lg{-ms-flex-pack:justify;justify-content:space-between}.first-lg{-ms-flex-order:-1;order:-1}.last-lg{-ms-flex-order:1;order:1}}", ""]);
	
	// exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, "div.juxtapose{width:100%;font-family:Helvetica,Arial,sans-serif}div.jx-slider{width:100%;height:100%;position:relative;overflow:hidden;cursor:pointer}div.jx-handle{position:absolute;height:100%;width:40px;cursor:col-resize;z-index:15;margin-left:-20px}.vertical div.jx-handle{height:40px;width:100%;cursor:row-resize;margin-top:-20px;margin-left:0}div.jx-control{height:100%;margin-right:auto;margin-left:auto;width:3px;background-color:#fff}.vertical div.jx-control{height:3px;width:100%;background-color:#fff;position:relative;top:50%;transform:translateY(-50%)}div.jx-controller{position:absolute;margin:auto;top:0;bottom:0;height:60px;width:9px;margin-left:-3px;background-color:#fff}.vertical div.jx-controller{height:9px;width:100px;margin-left:auto;margin-right:auto;top:-3px;position:relative}div.jx-arrow{margin:auto;top:0;bottom:0}.vertical div.jx-arrow,div.jx-arrow{position:absolute;width:0;height:0;transition:all .2s ease}.vertical div.jx-arrow{margin:0 auto;left:0;right:0}div.jx-arrow.jx-left{left:2px;border-style:solid;border-width:8px 8px 8px 0;border-color:transparent #fff transparent transparent}div.jx-arrow.jx-right{right:2px;border-style:solid;border-width:8px 0 8px 8px;border-color:transparent transparent transparent #fff}.vertical div.jx-arrow.jx-left{left:0;top:2px;border-style:solid;border-width:0 8px 8px;border-color:transparent transparent #fff}.vertical div.jx-arrow.jx-right{right:0;top:auto;bottom:2px;border-style:solid;border-width:8px 8px 0;border-color:#fff transparent transparent}div.jx-handle:active div.jx-arrow.jx-left,div.jx-handle:hover div.jx-arrow.jx-left{left:-1px}div.jx-handle:active div.jx-arrow.jx-right,div.jx-handle:hover div.jx-arrow.jx-right{right:-1px}.vertical div.jx-handle:active div.jx-arrow.jx-left,.vertical div.jx-handle:hover div.jx-arrow.jx-left{left:0;top:0}.vertical div.jx-handle:active div.jx-arrow.jx-right,.vertical div.jx-handle:hover div.jx-arrow.jx-right{right:0;bottom:0}div.jx-image{position:absolute;height:100%;display:inline-block;top:0;overflow:hidden;-webkit-backface-visibility:hidden}.vertical div.jx-image{width:100%;left:0;top:auto}div.jx-image img{height:100%;z-index:5;position:absolute;max-height:none;max-width:none}.vertical div.jx-image img{height:auto;width:100%}div.jx-image.jx-left{left:0;background-position:0}div.jx-image.jx-left img{left:0}div.jx-image.jx-right{right:0;background-position:100%}div.jx-image.jx-right img{right:0;bottom:0}.veritcal div.jx-image.jx-left{top:0;background-position:top}.veritcal div.jx-image.jx-left img{top:0}.vertical div.jx-image.jx-right{bottom:0;background-position:bottom}.veritcal div.jx-image.jx-right img{bottom:0}div.jx-image div.jx-label{font-size:1em;padding:.25em .75em;position:relative;display:inline-block;top:0;background-color:#000;background-color:rgba(0,0,0,.7);color:#fff;z-index:10;white-space:nowrap;line-height:18px;vertical-align:middle}div.jx-image.jx-left div.jx-label{float:left;left:0}div.jx-image.jx-right div.jx-label{float:right;right:0}.vertical div.jx-image div.jx-label{display:table;position:absolute}.vertical div.jx-image.jx-right div.jx-label{left:0;bottom:0;top:auto}div.jx-credit{line-height:1.1;font-size:.75em}div.jx-credit em{font-weight:700;font-style:normal}div.jx-image.transition{transition:width .5s ease}div.jx-handle.transition{transition:left .5s ease}.vertical div.jx-image.transition{transition:height .5s ease}.vertical div.jx-handle.transition{transition:top .5s ease}a.jx-knightlab{background-color:#000;background-color:rgba(0,0,0,.25);bottom:0;display:table;height:14px;line-height:14px;padding:1px 4px 1px 5px;position:absolute;right:0;text-decoration:none;z-index:10}a.jx-knightlab div.knightlab-logo{display:inline-block;vertical-align:middle;height:8px;width:8px;background-color:#c34528;transform:rotate(45deg);-ms-transform:rotate(45deg);-webkit-transform:rotate(45deg);top:-1.25px;position:relative;cursor:pointer}a.jx-knightlab:hover{background-color:#000;background-color:rgba(0,0,0,.35)}a.jx-knightlab:hover div.knightlab-logo{background-color:#ce4d28}a.jx-knightlab span.juxtapose-name{display:table-cell;margin:0;padding:0;font-family:Helvetica,Arial,sans-serif;font-weight:300;color:#fff;font-size:10px;padding-left:.375em;vertical-align:middle;line-height:normal}a.jx-knightlab:focus,div.jx-controller:focus,div.jx-image.jx-left div.jx-label:focus,div.jx-image.jx-right div.jx-label:focus{background:#eae34a;color:#000}a.jx-knightlab:focus span.juxtapose-name{color:#000;border:none}", ""]);
	
	// exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * animate.css -https://daneden.github.io/animate.css/\n * Version - 3.7.1\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2019 Daniel Eden\n */@keyframes bounce{0%,20%,53%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.bounce{animation-name:bounce;transform-origin:center bottom}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{animation-name:flash}@keyframes pulse{0%{transform:scaleX(1)}50%{transform:scale3d(1.05,1.05,1.05)}to{transform:scaleX(1)}}.pulse{animation-name:pulse}@keyframes rubberBand{0%{transform:scaleX(1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}to{transform:scaleX(1)}}.rubberBand{animation-name:rubberBand}@keyframes shake{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}.shake{animation-name:shake}@keyframes headShake{0%{transform:translateX(0)}6.5%{transform:translateX(-6px) rotateY(-9deg)}18.5%{transform:translateX(5px) rotateY(7deg)}31.5%{transform:translateX(-3px) rotateY(-5deg)}43.5%{transform:translateX(2px) rotateY(3deg)}50%{transform:translateX(0)}}.headShake{animation-timing-function:ease-in-out;animation-name:headShake}@keyframes swing{20%{transform:rotate(15deg)}40%{transform:rotate(-10deg)}60%{transform:rotate(5deg)}80%{transform:rotate(-5deg)}to{transform:rotate(0deg)}}.swing{transform-origin:top center;animation-name:swing}@keyframes tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{transform:scaleX(1)}}.tada{animation-name:tada}@keyframes wobble{0%{transform:translateZ(0)}15%{transform:translate3d(-25%,0,0) rotate(-5deg)}30%{transform:translate3d(20%,0,0) rotate(3deg)}45%{transform:translate3d(-15%,0,0) rotate(-3deg)}60%{transform:translate3d(10%,0,0) rotate(2deg)}75%{transform:translate3d(-5%,0,0) rotate(-1deg)}to{transform:translateZ(0)}}.wobble{animation-name:wobble}@keyframes jello{0%,11.1%,to{transform:translateZ(0)}22.2%{transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{transform:skewX(6.25deg) skewY(6.25deg)}44.4%{transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{transform:skewX(.390625deg) skewY(.390625deg)}88.8%{transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{animation-name:jello;transform-origin:center}@keyframes heartBeat{0%{transform:scale(1)}14%{transform:scale(1.3)}28%{transform:scale(1)}42%{transform:scale(1.3)}70%{transform:scale(1)}}.heartBeat{animation-name:heartBeat;animation-duration:1.3s;animation-timing-function:ease-in-out}@keyframes bounceIn{0%,20%,40%,60%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scaleX(1)}}.bounceIn{animation-duration:.75s;animation-name:bounceIn}@keyframes bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:translateZ(0)}}.bounceInDown{animation-name:bounceInDown}@keyframes bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:translateZ(0)}}.bounceInLeft{animation-name:bounceInLeft}@keyframes bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:translateZ(0)}}.bounceInRight{animation-name:bounceInRight}@keyframes bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}.bounceInUp{animation-name:bounceInUp}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{animation-duration:.75s;animation-name:bounceOut}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{animation-name:bounceOutDown}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{animation-name:bounceOutLeft}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{animation-name:bounceOutRight}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{animation-name:bounceOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:translateZ(0)}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}to{opacity:1;transform:translateZ(0)}}.fadeInDownBig{animation-name:fadeInDownBig}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:translateZ(0)}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}to{opacity:1;transform:translateZ(0)}}.fadeInLeftBig{animation-name:fadeInLeftBig}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:translateZ(0)}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}to{opacity:1;transform:translateZ(0)}}.fadeInRightBig{animation-name:fadeInRightBig}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:translateZ(0)}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}to{opacity:1;transform:translateZ(0)}}.fadeInUpBig{animation-name:fadeInUpBig}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{animation-name:fadeOutDownBig}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{animation-name:fadeOutLeftBig}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{animation-name:fadeOutRightBig}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{animation-name:fadeOutUpBig}@keyframes flip{0%{transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);animation-timing-function:ease-out}40%{transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);animation-timing-function:ease-out}50%{transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);animation-timing-function:ease-in}to{transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;animation-name:flip}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInX}@keyframes flipInY{0%{transform:perspective(400px) rotateY(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateY(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateY(10deg);opacity:1}80%{transform:perspective(400px) rotateY(-5deg)}to{transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInY}@keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{animation-duration:.75s;animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateY(-15deg);opacity:1}to{transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{animation-duration:.75s;-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipOutY}@keyframes lightSpeedIn{0%{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg);opacity:1}80%{transform:skewX(-5deg)}to{transform:translateZ(0)}}.lightSpeedIn{animation-name:lightSpeedIn;animation-timing-function:ease-out}@keyframes lightSpeedOut{0%{opacity:1}to{transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{animation-name:lightSpeedOut;animation-timing-function:ease-in}@keyframes rotateIn{0%{transform-origin:center;transform:rotate(-200deg);opacity:0}to{transform-origin:center;transform:translateZ(0);opacity:1}}.rotateIn{animation-name:rotateIn}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}to{transform-origin:left bottom;transform:translateZ(0);opacity:1}}.rotateInDownLeft{animation-name:rotateInDownLeft}@keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate(45deg);opacity:0}to{transform-origin:right bottom;transform:translateZ(0);opacity:1}}.rotateInDownRight{animation-name:rotateInDownRight}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate(45deg);opacity:0}to{transform-origin:left bottom;transform:translateZ(0);opacity:1}}.rotateInUpLeft{animation-name:rotateInUpLeft}@keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate(-90deg);opacity:0}to{transform-origin:right bottom;transform:translateZ(0);opacity:1}}.rotateInUpRight{animation-name:rotateInUpRight}@keyframes rotateOut{0%{transform-origin:center;opacity:1}to{transform-origin:center;transform:rotate(200deg);opacity:0}}.rotateOut{animation-name:rotateOut}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{animation-name:rotateOutDownLeft}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{animation-name:rotateOutDownRight}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{animation-name:rotateOutUpLeft}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(90deg);opacity:0}}.rotateOutUpRight{animation-name:rotateOutUpRight}@keyframes hinge{0%{transform-origin:top left;animation-timing-function:ease-in-out}20%,60%{transform:rotate(80deg);transform-origin:top left;animation-timing-function:ease-in-out}40%,80%{transform:rotate(60deg);transform-origin:top left;animation-timing-function:ease-in-out;opacity:1}to{transform:translate3d(0,700px,0);opacity:0}}.hinge{animation-duration:2s;animation-name:hinge}@keyframes jackInTheBox{0%{opacity:0;transform:scale(.1) rotate(30deg);transform-origin:center bottom}50%{transform:rotate(-10deg)}70%{transform:rotate(3deg)}to{opacity:1;transform:scale(1)}}.jackInTheBox{animation-name:jackInTheBox}@keyframes rollIn{0%{opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;transform:translateZ(0)}}.rollIn{animation-name:rollIn}@keyframes rollOut{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{animation-name:rollOut}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{animation-name:zoomIn}@keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{animation-name:zoomInDown}@keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{animation-name:zoomInLeft}@keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{animation-name:zoomInRight}@keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{animation-name:zoomInUp}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{animation-name:zoomOut}@keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{animation-name:zoomOutDown}@keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{animation-name:zoomOutLeft}@keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{animation-name:zoomOutRight}@keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{animation-name:zoomOutUp}@keyframes slideInDown{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInDown{animation-name:slideInDown}@keyframes slideInLeft{0%{transform:translate3d(-100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInLeft{animation-name:slideInLeft}@keyframes slideInRight{0%{transform:translate3d(100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInRight{animation-name:slideInRight}@keyframes slideInUp{0%{transform:translate3d(0,100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInUp{animation-name:slideInUp}@keyframes slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,100%,0)}}.slideOutDown{animation-name:slideOutDown}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-100%,0,0)}}.slideOutLeft{animation-name:slideOutLeft}@keyframes slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(100%,0,0)}}.slideOutRight{animation-name:slideOutRight}@keyframes slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-100%,0)}}.slideOutUp{animation-name:slideOutUp}.animated{animation-duration:1s;animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.delay-1s{animation-delay:1s}.animated.delay-2s{animation-delay:2s}.animated.delay-3s{animation-delay:3s}.animated.delay-4s{animation-delay:4s}.animated.delay-5s{animation-delay:5s}.animated.fast{animation-duration:.8s}.animated.faster{animation-duration:.5s}.animated.slow{animation-duration:2s}.animated.slower{animation-duration:3s}@media (prefers-reduced-motion:reduce),(print){.animated{animation-duration:1ms!important;transition-duration:1ms!important;animation-iteration-count:1!important}}", ""]);
	
	// exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, ".switch{background:#fff;border:1px solid #dfdfdf;position:relative;display:inline-block;box-sizing:content-box;overflow:visible;width:52px;height:30px;padding:0;margin:0;border-radius:20px;cursor:pointer;box-shadow:inset 0 0 0 0 #dfdfdf;transition:all .3s ease-out;-webkit-transition:all .3s ease-out;top:-1px}.switch.wide{width:80px}.switch small{background:#fff;border-radius:100%;box-shadow:0 1px 3px rgba(0,0,0,.4);width:30px;height:30px;position:absolute;top:0;left:0;transition:all .3s ease-out;-webkit-transition:all .3s ease-out}.switch.checked{background:#64bd63;border-color:#64bd63}.switch.checked small{left:22px}.switch.wide.checked small{left:52px}.switch .switch-text{font-family:Arial,Helvetica,sans-serif;font-size:13px}.switch .off{display:block;right:10%;color:#a9a9a9}.switch .off,.switch .on{position:absolute;top:25%;z-index:0}.switch .on{color:#fff;left:9%}.switch.checked .off,.switch .on{display:none}.switch.checked .on{display:block}.switch.disabled{opacity:.5;cursor:not-allowed}", ""]);
	
	// exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * ngToast v2.0.0 (http://tameraydin.github.io/ngToast)\n * Copyright 2016 Tamer Aydin (http://tamerayd.in)\n * Licensed under MIT (http://tameraydin.mit-license.org/)\n */.ng-toast--animate-fade .ng-enter,.ng-toast--animate-fade .ng-leave,.ng-toast--animate-fade .ng-move{transition-property:opacity;transition-duration:.3s;transition-timing-function:ease}.ng-toast--animate-fade .ng-enter{opacity:0}.ng-toast--animate-fade .ng-enter.ng-enter-active,.ng-toast--animate-fade .ng-leave{opacity:1}.ng-toast--animate-fade .ng-leave.ng-leave-active{opacity:0}.ng-toast--animate-fade .ng-move{opacity:.5}.ng-toast--animate-fade .ng-move.ng-move-active{opacity:1}.ng-toast--animate-slide .ng-enter,.ng-toast--animate-slide .ng-leave,.ng-toast--animate-slide .ng-move{position:relative;transition-duration:.3s;transition-timing-function:ease}.ng-toast--animate-slide.ng-toast--center.ng-toast--top .ng-toast__message{position:relative;transition-property:top,margin-top,opacity}.ng-toast--animate-slide.ng-toast--center.ng-toast--top .ng-toast__message.ng-enter{opacity:0;top:-100px}.ng-toast--animate-slide.ng-toast--center.ng-toast--top .ng-toast__message.ng-enter.ng-enter-active,.ng-toast--animate-slide.ng-toast--center.ng-toast--top .ng-toast__message.ng-leave{opacity:1;top:0}.ng-toast--animate-slide.ng-toast--center.ng-toast--top .ng-toast__message.ng-leave.ng-leave-active{opacity:0;margin-top:-72px}.ng-toast--animate-slide.ng-toast--center.ng-toast--bottom .ng-toast__message{position:relative;transition-property:bottom,margin-bottom,opacity}.ng-toast--animate-slide.ng-toast--center.ng-toast--bottom .ng-toast__message.ng-enter{opacity:0;bottom:-100px}.ng-toast--animate-slide.ng-toast--center.ng-toast--bottom .ng-toast__message.ng-enter.ng-enter-active,.ng-toast--animate-slide.ng-toast--center.ng-toast--bottom .ng-toast__message.ng-leave{opacity:1;bottom:0}.ng-toast--animate-slide.ng-toast--center.ng-toast--bottom .ng-toast__message.ng-leave.ng-leave-active{opacity:0;margin-bottom:-72px}.ng-toast--animate-slide.ng-toast--right{transition-property:right,margin-right,opacity}.ng-toast--animate-slide.ng-toast--right .ng-enter{opacity:0;right:-200%;margin-right:20px}.ng-toast--animate-slide.ng-toast--right .ng-enter.ng-enter-active,.ng-toast--animate-slide.ng-toast--right .ng-leave{opacity:1;right:0;margin-right:0}.ng-toast--animate-slide.ng-toast--right .ng-leave.ng-leave-active{opacity:0;right:-200%;margin-right:20px}.ng-toast--animate-slide.ng-toast--left{transition-property:left,margin-left,opacity}.ng-toast--animate-slide.ng-toast--left .ng-enter{opacity:0;left:-200%;margin-left:20px}.ng-toast--animate-slide.ng-toast--left .ng-enter.ng-enter-active,.ng-toast--animate-slide.ng-toast--left .ng-leave{opacity:1;left:0;margin-left:0}.ng-toast--animate-slide.ng-toast--left .ng-leave.ng-leave-active{opacity:0;left:-200%;margin-left:20px}", ""]);
	
	// exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * ngToast v2.0.0 (http://tameraydin.github.io/ngToast)\n * Copyright 2016 Tamer Aydin (http://tamerayd.in)\n * Licensed under MIT (http://tameraydin.mit-license.org/)\n */.ng-toast{position:fixed;z-index:1080;width:100%;height:0;margin-top:20px;text-align:center}.ng-toast.ng-toast--top,.ng-toast.ng-toast--top .ng-toast__list{top:0;bottom:auto}.ng-toast.ng-toast--top.ng-toast--center .ng-toast__list{position:static}.ng-toast.ng-toast--bottom,.ng-toast.ng-toast--bottom .ng-toast__list{top:auto;bottom:0}.ng-toast.ng-toast--bottom.ng-toast--center .ng-toast__list{pointer-events:none}.ng-toast.ng-toast--bottom.ng-toast--center .ng-toast__message .alert{pointer-events:auto}.ng-toast.ng-toast--right .ng-toast__list{left:auto;right:0;margin-right:20px}.ng-toast.ng-toast--right .ng-toast__message{text-align:right}.ng-toast.ng-toast--left .ng-toast__list{right:auto;left:0;margin-left:20px}.ng-toast.ng-toast--left .ng-toast__message{text-align:left}.ng-toast .ng-toast__list{display:inline-block;position:absolute;right:0;left:0;margin:0 auto;padding:0;list-style:none}.ng-toast .ng-toast__message{display:block;width:100%;text-align:center}.ng-toast .ng-toast__message .alert{display:inline-block}.ng-toast .ng-toast__message__count{display:inline-block;margin:0 15px 0 5px}", ""]);
	
	// exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! angularjs-slider - v6.7.0 -  (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervi.eu>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> -  https://github.com/angular-slider/angularjs-slider -  2019-02-23 */.rzslider{position:relative;display:inline-block;width:100%;height:4px;margin:35px 0 15px;vertical-align:middle;user-select:none}.rzslider.with-legend{margin-bottom:40px}.rzslider[disabled]{cursor:not-allowed}.rzslider[disabled] .rz-pointer{cursor:not-allowed;background-color:#d8e0f3}.rzslider[disabled] .rz-draggable{cursor:not-allowed}.rzslider[disabled] .rz-selection{background:#8b91a2}.rzslider[disabled] .rz-tick{cursor:not-allowed}.rzslider[disabled] .rz-tick.rz-selected{background:#8b91a2}.rzslider span{position:absolute;display:inline-block;white-space:nowrap}.rzslider .rz-base{width:100%;height:100%;padding:0}.rzslider .rz-bar-wrapper{left:0;z-index:1;width:100%;height:32px;padding-top:16px;margin-top:-16px;box-sizing:border-box}.rzslider .rz-draggable{cursor:move}.rzslider .rz-bar{left:0;z-index:1;width:100%;height:4px;background:#d8e0f3;border-radius:2px}.rzslider .rz-bar-wrapper.rz-transparent .rz-bar{background:transparent}.rzslider .rz-bar-wrapper.rz-left-out-selection .rz-bar{background:#df002d}.rzslider .rz-bar-wrapper.rz-right-out-selection .rz-bar{background:#03a688}.rzslider .rz-selection{z-index:2;background:#0db9f0;border-radius:2px}.rzslider .rz-restricted{z-index:3;background:red;border-radius:2px}.rzslider .rz-pointer{top:-14px;z-index:3;width:32px;height:32px;cursor:pointer;background-color:#0db9f0;border-radius:16px}.rzslider .rz-pointer:after{position:absolute;top:12px;left:12px;width:8px;height:8px;background:#fff;border-radius:4px;content:\"\"}.rzslider .rz-pointer:hover:after{background-color:#fff}.rzslider .rz-pointer.rz-active{z-index:4}.rzslider .rz-pointer.rz-active:after{background-color:#451aff}.rzslider .rz-bubble{bottom:16px;padding:1px 3px;color:#55637d;cursor:default}.rzslider .rz-bubble.rz-limit{color:#55637d}.rzslider .rz-ticks{position:absolute;top:-3px;left:0;z-index:1;width:100%;height:0;margin:0;list-style:none;box-sizing:border-box}.rzslider .rz-ticks-values-under .rz-tick-value{top:auto;bottom:-32px}.rzslider .rz-tick{position:absolute;top:0;left:0;width:10px;height:10px;margin-left:11px;text-align:center;cursor:pointer;background:#d8e0f3;border-radius:50%}.rzslider .rz-tick.rz-selected{background:#0db9f0}.rzslider .rz-tick-value{position:absolute;top:-30px;transform:translate(-50%)}.rzslider .rz-tick-legend{position:absolute;top:24px;max-width:50px;white-space:normal;transform:translate(-50%)}.rzslider.rz-vertical{position:relative;width:4px;height:100%;padding:0;margin:0 20px;vertical-align:baseline}.rzslider.rz-vertical .rz-base{width:100%;height:100%;padding:0}.rzslider.rz-vertical .rz-bar-wrapper{top:auto;left:0;width:32px;height:100%;padding:0 0 0 16px;margin:0 0 0 -16px}.rzslider.rz-vertical .rz-bar{bottom:0;left:auto;width:4px;height:100%}.rzslider.rz-vertical .rz-pointer{top:auto;bottom:0;left:-14px!important}.rzslider.rz-vertical .rz-bubble{bottom:0;left:16px!important;margin-left:3px}.rzslider.rz-vertical .rz-ticks{top:0;left:-3px;z-index:1;width:0;height:100%}.rzslider.rz-vertical .rz-tick{margin-top:11px;margin-left:auto;vertical-align:middle}.rzslider.rz-vertical .rz-tick-value{top:auto;left:24px;transform:translateY(-28%)}.rzslider.rz-vertical .rz-tick-legend{top:auto;right:24px;max-width:none;white-space:nowrap;transform:translateY(-28%)}.rzslider.rz-vertical .rz-ticks-values-under .rz-tick-value{right:24px;bottom:auto;left:auto}", ""]);
	
	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(135)();
	// imports
	
	
	// module
	exports.push([module.id, ".mCustomScrollbar{-ms-touch-action:pinch-zoom;touch-action:pinch-zoom}.mCustomScrollbar.mCS_no_scrollbar,.mCustomScrollbar.mCS_touch_action{-ms-touch-action:auto;touch-action:auto}.mCustomScrollBox{position:relative;overflow:hidden;height:100%;max-width:100%;outline:none;direction:ltr}.mCSB_container{overflow:hidden;width:auto;height:auto}.mCSB_inside>.mCSB_container{margin-right:30px}.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container{margin-right:0;margin-left:30px}.mCS-dir-rtl>.mCSB_inside>.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-left:0}.mCSB_scrollTools{position:absolute;width:16px;height:auto;left:auto;top:0;right:0;bottom:0}.mCSB_outside+.mCSB_scrollTools{right:-26px}.mCS-dir-rtl>.mCSB_inside>.mCSB_scrollTools,.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{right:auto;left:0}.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{left:-26px}.mCSB_scrollTools .mCSB_draggerContainer{position:absolute;top:0;left:0;bottom:0;right:0;height:auto}.mCSB_scrollTools a+.mCSB_draggerContainer{margin:20px 0}.mCSB_scrollTools .mCSB_draggerRail{width:2px;height:100%;margin:0 auto;border-radius:16px}.mCSB_scrollTools .mCSB_dragger{cursor:pointer;width:100%;height:30px;z-index:1}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{position:relative;width:4px;height:100%;margin:0 auto;border-radius:16px;text-align:center}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:12px}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:8px}.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonUp{display:block;position:absolute;height:20px;width:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools .mCSB_buttonDown{bottom:0}.mCSB_horizontal.mCSB_inside>.mCSB_container{margin-right:0;margin-bottom:30px}.mCSB_horizontal.mCSB_outside>.mCSB_container{min-height:100%}.mCSB_horizontal>.mCSB_container.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal{width:auto;height:16px;top:auto;right:0;bottom:0;left:0}.mCustomScrollBox+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:-26px}.mCSB_scrollTools.mCSB_scrollTools_horizontal a+.mCSB_draggerContainer{margin:0 20px}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:2px;margin:7px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger{width:30px;height:100%;left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:4px;margin:6px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:12px;margin:2px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:8px;margin:4px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft,.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{display:block;position:absolute;width:20px;height:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft{left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{right:0}.mCSB_container_wrapper{position:absolute;height:auto;width:auto;overflow:hidden;top:0;left:0;right:0;bottom:0;margin-right:30px;margin-bottom:30px}.mCSB_container_wrapper>.mCSB_container{padding-right:30px;padding-bottom:30px;box-sizing:border-box}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:20px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:20px}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden+.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:20px}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container_wrapper{margin-right:0;margin-left:30px}.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden>.mCSB_container{padding-right:0}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden>.mCSB_container{padding-bottom:0}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0;margin-left:0}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools,.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight,.mCSB_scrollTools .mCSB_buttonUp,.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{transition:opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail{transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCS-autoHide>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide>.mCustomScrollBox~.mCSB_scrollTools{opacity:0;filter:\"alpha(opacity=0)\";-ms-filter:\"alpha(opacity=0)\"}.mCS-autoHide:hover>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide:hover>.mCustomScrollBox~.mCSB_scrollTools,.mCustomScrollbar>.mCustomScrollBox>.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollbar>.mCustomScrollBox~.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollBox:hover>.mCSB_scrollTools,.mCustomScrollBox:hover~.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=100)\";-ms-filter:\"alpha(opacity=100)\"}.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.4);filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.75);filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85);filter:\"alpha(opacity=85)\";-ms-filter:\"alpha(opacity=85)\"}.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9);filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight,.mCSB_scrollTools .mCSB_buttonUp{background-image:url(" + __webpack_require__(144) + ");background-repeat:no-repeat;opacity:.4;filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_buttonUp{background-position:0 0}.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -20px}.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -40px}.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -56px}.mCSB_scrollTools .mCSB_buttonDown:hover,.mCSB_scrollTools .mCSB_buttonLeft:hover,.mCSB_scrollTools .mCSB_buttonRight:hover,.mCSB_scrollTools .mCSB_buttonUp:hover{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_buttonDown:active,.mCSB_scrollTools .mCSB_buttonLeft:active,.mCSB_scrollTools .mCSB_buttonRight:active,.mCSB_scrollTools .mCSB_buttonUp:active{opacity:.9;filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCS-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:rgba(0,0,0,.85)}.mCS-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:rgba(0,0,0,.9)}.mCS-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.1);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.75);border-radius:1px}.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px auto}.mCS-light-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-light-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}.mCS-light-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px 0}.mCS-light-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -20px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -40px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px 0}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -20px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -40px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-thick.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.1);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;background-color:#fff;background-color:hsla(0,0%,100%,.75);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px 0}.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:6px;margin:5px auto}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px 0}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -20px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -40px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px 0}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -20px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -40px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -56px}.mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.1)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:2px}.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%}.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:2px;margin:7px auto}.mCS-dark-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-rounded.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger,.mCS-rounded.mCSB_scrollTools .mCSB_dragger{height:14px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:14px;margin:0 1px}.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger{width:14px}.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:14px;margin:1px 0}.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:16px;height:16px;margin:-1px 0}.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:4px}.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:16px;width:16px;margin:0 -1px}.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:4px;margin:6px 0}.mCS-rounded.mCSB_scrollTools .mCSB_buttonUp{background-position:0 -72px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -92px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -112px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -128px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px -72px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -92px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -112px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools_vertical .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_vertical .mCSB_draggerRail{width:4px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail{background-color:transparent;background-position:50%}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVQYV2NkIAAYiVbw//9/Y6DiM1ANJoyMjGdBbLgJQAX/kU0DKgDLkaQAvxW4HEvQFwCRcxIJK1XznAAAAABJRU5ErkJggg==\");background-repeat:repeat-y;opacity:.3;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail{height:4px;margin:6px 0;background-repeat:repeat-x}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px -72px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -92px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -112px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkIAAYSVFgDFR8BqrBBEifBbGRTfiPZhpYjiQFBK3A6l6CvgAAE9kGCd1mvgEAAAAASUVORK5CYII=\")}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px -72px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -92px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -112px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-y;background-image:linear-gradient(90deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,0))}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-x;background-image:linear-gradient(180deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,0))}.mCS-3d-dark.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-3d.mCSB_scrollTools_vertical .mCSB_dragger{height:70px}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger{width:70px}.mCS-3d-dark.mCSB_scrollTools,.mCS-3d.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_draggerRail{border-radius:16px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_draggerRail{width:8px;background-color:#000;background-color:rgba(0,0,0,.2);box-shadow:inset 1px 0 1px rgba(0,0,0,.5),inset -1px 0 1px hsla(0,0%,100%,.2)}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#555}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:8px}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:8px;margin:4px 0;box-shadow:inset 0 1px 1px rgba(0,0,0,.5),inset 0 -1px 1px hsla(0,0%,100%,.2)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:8px;margin:4px auto}.mCS-3d.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);box-shadow:inset 1px 0 1px rgba(0,0,0,.1)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{box-shadow:inset 0 1px 1px rgba(0,0,0,.1)}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer,.mCS-3d-thick.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{border-radius:7px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{border-radius:5px}.mCSB_inside+.mCS-3d-thick-dark.mCSB_scrollTools_vertical,.mCSB_inside+.mCS-3d-thick.mCSB_scrollTools_vertical{right:1px}.mCS-3d-thick-dark.mCSB_scrollTools_vertical,.mCS-3d-thick.mCSB_scrollTools_vertical{box-shadow:inset 1px 0 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.5)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal,.mCS-3d-thick.mCSB_scrollTools_horizontal{bottom:1px;box-shadow:inset 0 1px 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.5)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 hsla(0,0%,100%,.4);width:12px;margin:2px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.4)}.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#555}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:12px;width:auto}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{background-color:#000;background-color:rgba(0,0,0,.05);box-shadow:inset 1px 1px 16px rgba(0,0,0,.1)}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-thick-dark.mCSB_scrollTools{box-shadow:inset 0 0 14px rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal{box-shadow:inset 0 1px 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 hsla(0,0%,100%,.4),inset -1px 0 0 rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.4),inset 0 -1px 0 rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#777}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer{background-color:#fff;background-color:rgba(0,0,0,.05);box-shadow:inset 1px 1px 16px rgba(0,0,0,.1)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{right:0;margin:12px 0}.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:0;margin:0 12px}.mCS-dir-rtl>.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.mCS-dir-rtl>.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{left:0;right:auto}.mCS-minimal-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-minimal.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-minimal-dark.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-minimal.mCSB_scrollTools_vertical .mCSB_dragger{height:50px}.mCS-minimal-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-minimal.mCSB_scrollTools_horizontal .mCSB_dragger{width:50px}.mCS-minimal.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-minimal.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools .mCSB_draggerRail{width:6px;background-color:#000;background-color:rgba(0,0,0,.2)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px}.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:6px;margin:5px 0}.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:12px}.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:12px;margin:2px 0}.mCS-light-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1)}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset.mCSB_scrollTools .mCSB_draggerRail{width:12px;background-color:#000;background-color:rgba(0,0,0,.2)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;margin:3px 5px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:6px;margin:5px 3px;position:absolute;width:auto;top:0;bottom:0;left:0;right:0}.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:12px;margin:2px 0}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent;border-color:#fff;border:1px solid hsla(0,0%,100%,.2);box-sizing:border-box}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail{border-color:#000;border-color:rgba(0,0,0,.2)}.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.6)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.6)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.75)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}", ""]);
	
	// exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3a8a4582fe1dbc77086eccca317c459e.png";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "64c47097874f4f12a79b905a87bb310e.jpg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.91307e45e61280f69f7d.js